import { stat } from "fs";
import { MdOutline10K } from "react-icons/md";
import { IListing, IListingSummary } from ".";

export const ListingSummaryResidential: IListingSummary = {
  type: "Residential",
  beds: 5,
  baths: 4,
  sqft: 3425,
  lotsqft: 20122,
  lotacres: 4.5,
  price: 3245000,
  flags: ["New Listing", "Open House at May 3, 2023, 3:00 PM"],
  exclusive: true,
  address: {
    street1: "1234 Main St",
    city: "Basalt",
    state: "CO",
    postal: "81621",
    text: "1234 Main St, Basalt, CO",
  },
};

export const ListingSummaryResidentialClosed: IListingSummary = {
  type: "Residential",
  beds: 5,
  baths: 4,
  sqft: 3425,
  lotsqft: 20122,
  lotacres: 4.5,
  price: 3245000,
  flags: ["New Listing", "Open House at May 3, 2023, 3:00 PM"],
  exclusive: true,
  address: {
    street1: "1234 Main St",
    city: "Basalt",
    state: "CO",
    postal: "81621",
    text: "1234 Main St, Basalt, CO",
  },
  status: "closed",
};
export const listingSummaryListResidential = () => {
  const data = require("./mock-listing-results.json");
  let list: IListingSummary[] = [];
  data.result.data.allListingResidential.nodes.map((o: any, index: number) => {
    list.push({
      mlsID: o.ListingId,
      price: o.ListPrice,
      beds: o.BedroomsTotal,
      baths: o.BathroomsTotalInteger,
      status: "closed",
      address: {
        text: o.UnparsedAddress,
      },
      type: "Residential",
      defaultImage: {
        url: o.PrefferedPhoto,
        dimensions: [1200, 800],
      },
      exclusive: index % 12 == 0,
      majorArea: o.MLSAreaMajor,
      minorArea: o.MLSAreaMinor,
      lotacres: o.LotSizeAcres,
      sqft: o.LivingArea,
    });
  });
  return list;
};

export const listingSummaryListResidentialTwo = () => {
  const data = require("./mock-listing-results-two.json");
  let list: IListingSummary[] = [];
  data.result.data.allListing.nodes.map((o: any, index: number) => {
    let listing: IListing = {

      mlsID: o.ListingId,
      price: o.ListPrice,
      beds: o.BedroomsTotal,
      baths: o.BathroomsTotalInteger,
      status: o.StandardStatus,
      address: {
        text: o.UnparsedAddress,
        county: o.CountyOrParish,
        postal: o.PostalCode,
        city: o.City,
      },
      rooms: o.MFR_Room_Count || null,
      subdivision: o.SubdivisionName,
      statusTS: o.StatusChangeTimestamp,
      type: "Residential",
      exclusive: index % 12 == 0,
      subType: o.PropertySubType,

      majorArea: o.MLSAreaMajor,
      minorArea: o.MLSAreaMinor,
      lotacres: o.LotSizeAcres,
      sqft: o.LivingArea,
    };
    if (o.PrefferedPhoto && o.PrefferedPhoto.length) {
      listing.defaultImage = {
        url: `${o.PrefferedPhoto}`.replace(
          "https://res.cloudinary.com/dnsr06bev/image/fetch/q_80,ar_1.5,c_fill,f_auto/",
          ""
        ),
        dimensions: [1200, 800],
      };
    }
    list.push(listing);
  });
  return list;
};

export const ListingResidential: IListing = {
  mlsID: "168411",
  flags: ["just"],
  status: "closed",
  baths: 15,
  beds: 9,
  address: {
    street1: "1000 S Starwood Drive",
    city: "Aspen",
    state: "CO",
    text: "1000 S Starwood Drive, Aspen, CO 81611",
    county: "Pitkin",
    postal: "81611",
  },
  office: [
    {
      mlsID: "CBMMAspen",
      fullName: "Coldwell Banker Mason Morse-Aspen",
      phone: "9709257000",
      address: {
        city: "Aspen",
        state: "CO",
        text: "514 E Hyman Ave, Aspen, CO 81611",
      },
      email: "era@eralandmark.com",
      photos: [
        {
          url: "https://img.freepik.com/free-photo/conference-room-with-desk-wall-windows-that-says-office_1340-37385.jpg",
        },
      ],
    },
  ],
  price: 48000000,
  sqft: 18951,
  defaultImage: {
    url: "https://res.cloudinary.com/dnsr06bev/image/fetch/q_auto:best,ar_1.5,c_fill,f_auto,w_1200/https://cdn.photos.sparkplatform.com/ags/20210304180048582079000000-o.jpg",
  },
  type: "Residential",
  furnished: false,
  fireplace: true,
  cooling: true,
  images: [
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210304180048582079000000-o.jpg",
      caption: "105",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200705212946000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-108",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200642857957000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-38",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200648231550000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-47",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200651031918000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-56",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200653323680000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-64",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200634251691000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-13",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200637961951000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-17",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200636313583000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-16",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210201200655121555000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-76",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140703367293000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-4",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140720222694000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-5",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140730237387000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-7",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140741507996000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-8",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140751637872000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-23",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140803104921000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-25",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140813965415000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-26",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140821171629000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-27",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140829108859000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-28",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140840427840000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-29",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140852279546000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-30",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140906292449000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-31",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140926632386000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-57",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140934463056000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-94",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412140956006482000000-o.jpg",
      caption: "1000_S_Starwood_LowRes-98",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141428539979000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_15",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141540181935000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_16",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141642053013000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_19",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141727652364000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_22",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141822392008000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_23",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412141925086862000000-o.jpg",
      caption: "1000sStarwood_HiRes_012320_26",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412142028816797000000-o.jpg",
      caption: "1000sStarwood_HiRes_012620_03",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412142142582868000000-o.jpg",
      caption: "1000sStarwood_HiRes_012620_04",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412142243672021000000-o.jpg",
      caption: "1000sStarwood_HiRes_012620_05",
    },
    {
      url: "https://cdn.photos.sparkplatform.com/ags/20210412142329099713000000-o.jpg",
      caption: "1000sStarwood_HiRes_012620_11",
    },
  ],
  floorplans: [
    { url: "https://imgs.azureedge.net/B63144E1-076E-4750-B916-5397218F4B25" },
    { url: "https://imgs.azureedge.net/606522D1-52D2-44DB-A466-1A0B4A4F2712" },
  ],
  tours: [{ url: "https://my.matterport.com/show/?m=v8CfyyMAjCS&brand=0" }],
  videos: [
    {
      url: "https://players.brightcove.net/5699924528001/default_default/index.html?videoId=6300410288001",
    },
  ],
  location: { lat: 39.225857, lng: -106.84809 },
  description:
    "Views, privacy, security. The views are the star player here, but craftsmanship & design play impressive and vital roles. The great room features dry-stacked Oklahoma farmers stone supporting a ceiling of parquet white oak. Vertical window trim – sapele ornamented with a delicate bevel – invokes a mid-century design aesthetic, while a large hearth firmly centers the room in its alpine environs. If the great room is a natural showpiece for entertaining, the open plan kitchen/family room nearby is the obvious choice for family life. From the pool, swimmers can see from Independence to Sopris, without any neighbors in sight.",
  garage: false,
  bathsFull: 12,
  bathsHalf: 3,
  bathsTQ: 0,
  heating: true,
  lotacres: 2.42,
  lotsqft: 105415.2,
  majorArea: "Aspen",
  minorArea: "McLain Flats",
  newlyBuilt: true,
  yearBuilt: 2019,
  details: [
    {
      details: [
        {
          label: "Status",
          value: "Active",
        },
        {
          label: "Location",
          value: "Aspen",
        },
        {
          label: "Area",
          value: "McLain Flats",
        },
        {
          label: "Neighborhoood",
          value: "Starwood",
        },
        {
          label: "Style",
          value: "Contemporary",
        },
        {
          label: "Zoning",
          value: "RESIDENTIAL",
        },
        {
          label: "Year Built",
          value: "2019",
        },
      ],
      name: "Foremost",
    },
    {
      details: [
        {
          label: "Bedrooms",
          value: "9",
        },
        {
          label: "Total Baths",
          value: "15",
        },
        {
          label: "Full Baths",
          value: "12",
        },
        {
          label: "Half Baths",
          value: "3",
        },
        {
          label: "Garage",
          value: "4+ Car",
        },
        {
          label: "Furnished",
          value: "Unfurnished",
        },
      ],
      name: "Essentials",
    },
    {
      details: [
        {
          label: "LV Heated SF",
          value: "18,951",
        },
        {
          label: "Total SF",
          value: "18,951",
        },
        {
          label: "Unfinished SF",
          value: "0",
        },
        {
          label: "Acres",
          value: "2.42",
        },
        {
          label: "Lot Size",
          value: "105,415.2",
        },
        {
          label: "Levels",
          value: "3",
        },
      ],
      name: "Measurements",
    },
    {
      details: [
        {
          label: "Property Condition",
          value: "Excellent, New Construction",
        },
        {
          label: "Construction",
          value: "Stone, Poured Concrete",
        },
        {
          label: "Exterior",
          value: "Metal, Stone Siding",
        },
        {
          label: "Cooling",
          value: "Yes",
        },
        {
          label: "Heating",
          value: "Yes",
        },
        {
          label: "Fireplaces #",
          value: "3",
        },
        {
          label: "Fireplace Type",
          value: "Gas",
        },
        {
          label: "Gas",
          value: "Natural Gas",
        },
        {
          label: "Water",
          value: "Community",
        },
        {
          label: "Sanitation",
          value: "Septic",
        },
        {
          label: "Extras",
          value:
            "Outdoor Hot TubSpa, PatioDeck, Landscaping, Elevator, Handicap Access, Lawn Sprinklers, Hot TubSpa, Pool, Steam Shower, Security System",
        },
        {
          label: "Laundry",
          value: "Room",
        },
        {
          label: "Roof",
          value: "Metal",
        },
        {
          label: "Mineral Rights",
          value: "No",
        },
        {
          label: "Water Rights",
          value: "No",
        },
        {
          label: "Location Amenities",
          value:
            "Trees, Views, Exposure Southern, Gentle Topo, Gated Community",
        },
        {
          label: "Inclusions",
          value:
            "Freezer, Water Softener, Stove Top, Oven, Built-In Recyling, Dishwasher, Microwave, Refrigerator, Dryer, Window Coverings, Washer",
        },
      ],
      name: "Feature Information",
    },
    {
      details: [
        {
          label: "Taxes",
          value: "$87,122.52",
        },
        {
          label: "Tax Year",
          value: "2021",
        },
        {
          label: "Transfer Tax",
          value: "No",
        },
        {
          label: "HOA",
          value: "Yes",
        },
        {
          label: "HOA Fee Per Year",
          value: "$1,034.31",
        },
        {
          label: "HOA Fees Inclusions",
          value: "Snow Removal, Management",
        },
        {
          label: "REO",
          value: "No",
        },
        {
          label: "Foreclosure",
          value: "No",
        },
        {
          label: "Short Sale",
          value: "No",
        },
        {
          label: "Auction",
          value: "No",
        },
      ],
      name: "Finance Information",
      
    },
  ],
  status: "closed",
  openHouse: [
    {
      startDate: "2022-09-23T20:00:00Z",
      endDate: "2022-09-23T23:00:00Z",
      headLine: "Washington Meadows (Lot 18) Spec",
    },
    {
      startDate: "2022-09-25T20:00:00Z",
      endDate: "2022-09-25T23:00:00Z",
      headLine: "Washington Meadows (Lot 18) Spec",
    },
    {
      startDate: "2022-09-24T20:00:00Z",
      endDate: "2022-09-24T23:00:00Z",
      headLine: "Washington Meadows (Lot 18) Spec",
    },
  ],
};

export const ListingRental: IListing = {
  baths: 6,
  bathsHalf: 2,
  address: {
    city: "Edgartown",
    state: "MA",
    text: "1 North Neck Road",
  },
  beds: 6,
  sleeps: 14,
  subdivision: "Chappy",
  type: "rental",
  defaultImage: {
    dimensions: [1024, 683],
    url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-1.jpg",
  },
  path: "/rentals/1-north-neck-road",
  features: ["A/C"],
  descriptionHTML:
    "<p>Spend your day swimming or sunbathing on the&nbsp;private beach just steps from your door, or&nbsp;enjoy being&nbsp;on the water with seven kayaks, a sunfish, a sailboat and a rowboat &nbsp;</p>\r\n<p>This stunning waterfront property is located on the tip of the North Neck peninsula on Chappaquiddick.&nbsp; With the most commanding views on the Vineyard, yet private and minutes to downtown Edgartown. New mahogany decks, new windows, new water filtration system, and many more luxurious upgrades await at this spectacular property! A fleet of boats, a private beach with swim platform, mooring, and outhaul! Paradise found!</p>\r\n<p>This luxury home comfortably sleeps 14 and affords the utmost in privacy. Water views from every room, even the first floor bedrooms &amp; baths! The Main House is comprised of four bedrooms, each with ensuite bathrooms, sleeping eight very comfortably. Fantastic working fireplace, beautiful open floor plan with endless windows and 360-degree water views.</p>\r\n<p>The primary suite has a Jacuzzi tub &amp; porch area. The guest house, which was the original summer cottage on the property, sleeps six comfortably with a spacious deck and wonderful lookout! Each house has an outdoor shower. Amazing sunrises and breathtaking sunsets from both houses.</p>\r\n<p>Bring your own boat and put it on the mooring. Walk to Edgartown restaurants, movie theatre or shopping as a pedestrian on the ferry, leaving your car parked at the free lot on the Chappy side!</p>",
  images: [
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-1.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-2.jpg",
      dimensions: [1024, 648],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-3.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-4.jpg",
      dimensions: [1024, 676],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-5.jpg",
      dimensions: [1024, 680],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-6.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-7.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-8.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-9.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-10.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-11.jpg",
      dimensions: [1024, 676],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-12.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-13.jpg",
      dimensions: [512, 768],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-14.jpg",
      dimensions: [561, 768],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-15.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-16.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-17.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-18.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-19.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-20.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-21.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-22.jpg",
      dimensions: [512, 768],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-23.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-24.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-25.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-26.jpg",
      dimensions: [1024, 570],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-27.jpg",
      dimensions: [1024, 424],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-28.jpg",
      dimensions: [1024, 431],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-29.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-30.jpg",
      dimensions: [1024, 614],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-31.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-32.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-33.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-34.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-35.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-36.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-37.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-38.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-39.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-40.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-41.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-42.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-43.jpg",
      dimensions: [1024, 683],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-44.jpg",
      dimensions: [1024, 682],
    },
    {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-45.jpg",
      dimensions: [1024, 560],
    },
  ],
  floorplans: [
    { url: "https://imgs.azureedge.net/B63144E1-076E-4750-B916-5397218F4B25" },
    { url: "https://imgs.azureedge.net/606522D1-52D2-44DB-A466-1A0B4A4F2712" },
  ],
  tours: [{ url: "https://my.matterport.com/show/?m=v8CfyyMAjCS&brand=0" }],
  videos: [
    {
      url: "https://players.brightcove.net/5699924528001/default_default/index.html?videoId=6300410288001",
    },
  ],
  bookings: [
    {
      endDate: "2022-08-14",
      startDate: "2022-07-02",
    },
    {
      endDate: "2022-08-29",
      startDate: "2022-08-13",
    },
  ],
  rates: [
    {
      price: 2500,
      startDate: "2022-10-01",
      endDate: "2023-01-01",
    },
    {
      price: 2500,
      startDate: "2022-08-30",
      endDate: "2022-10-02",
    },
    {
      price: 2500,
      startDate: "2022-04-02",
      endDate: "2022-08-31",
    },
    {
      price: 2500,
      startDate: "2022-02-05",
      endDate: "2022-04-03",
    },
    {
      price: 2500,
      startDate: "2022-01-01",
      endDate: "2022-02-06",
    },
  ],
  location: {
    lat: 41.40064,
    lng: -70.46465,
  },
  details: [
    {
      name: "Amenities",
      details: [
        {
          label: "AC - Central Air",
        },
        {
          label: "Guest House",
        },
        {
          label: "Lawn / Garden Area",
        },
        {
          label: "Mooring",
        },
        {
          label: "Outdoor Dining Area",
        },
        {
          label: "Outdoor Furniture",
        },
        {
          label: "Outdoor Shower",
        },
        {
          label: "Porch",
        },
        {
          label: "Screened Porch",
        },
        {
          label: "Washer Dryer",
        },
      ],
    },
    {
      name: "Bedding",
      details: [
        {
          value: "First level - King with a private bath",
          label: "Bedroom One",
        },
        {
          value: "First level - Queen with a private bath",
          label: "Bedroom Two",
        },
        {
          value: "First level - (2) twins with a private bath",
          label: "Bedroom Three",
        },
        {
          value: "First level - (2) twin pullouts with a private bath",
          label: "Bedroom Four",
        },
        {
          value: "GH - Queen with a shared bath",
          label: "Bedroom Five",
        },
        {
          value: "GH - Bunk beds",
          label: "Bedroom Six",
        },
      ],
    },
  ],
};

export const ListingListRental: IListing[] = [
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "10 Littlefield Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 6,
    type: "rental",
    path: "/rentals/10-littlefield-lane",
    bookings: [
      {
        endDate: "2022-12-26",
        startDate: "2022-07-31",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-06-27",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-07-01",
      },
      {
        endDate: "2019-07-01",
        startDate: "2019-06-18",
      },
    ],
    rates: [
      {
        price: 5500,
        startDate: "2021-12-26",
        endDate: "2022-06-06",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/8/Courtney-1.jpg",
    },
    location: {
      lat: 41.396472,
      lng: -70.675203,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "West Tisbury",

      text: "39 Naushon Road",
    },
    features: [],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/39-naushon-road",
    bookings: [
      {
        endDate: "2019-09-08",
        startDate: "2019-07-20",
      },
      {
        endDate: "2018-10-07",
        startDate: "2018-10-05",
      },
      {
        endDate: "2018-10-12",
        startDate: "2018-10-07",
      },
      {
        endDate: "2021-09-26",
        startDate: "2021-08-28",
      },
      {
        endDate: "2022-04-24",
        startDate: "2021-12-26",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-04-23",
      },
      {
        endDate: "2020-06-21",
        startDate: "2020-06-13",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-08-01",
      },
      {
        endDate: "2021-06-13",
        startDate: "2021-06-05",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-08-07",
      },
    ],
    rates: [
      {
        price: 7500,
        startDate: "2019-04-27",
        endDate: "2019-06-09",
      },
      {
        price: 15000,
        startDate: "2019-08-04",
        endDate: "2019-08-25",
      },
      {
        price: 8500,
        startDate: "2019-09-08",
        endDate: "2019-09-22",
      },
      {
        price: 7500,
        startDate: "2019-09-22",
        endDate: "2019-11-03",
      },
      {
        price: 7500,
        startDate: "2020-04-25",
        endDate: "2020-06-07",
      },
      {
        price: 7500,
        startDate: "2020-09-19",
        endDate: "2020-10-25",
      },
      {
        price: 7500,
        startDate: "2021-04-24",
        endDate: "2021-06-06",
      },
      {
        price: 7500,
        startDate: "2021-09-18",
        endDate: "2021-10-24",
      },
      {
        price: 7500,
        startDate: "2022-09-17",
        endDate: "2022-10-23",
      },
      {
        price: 9500,
        startDate: "2019-06-09",
        endDate: "2019-06-23",
      },
      {
        price: 14000,
        startDate: "2019-07-14",
        endDate: "2019-07-28",
      },
      {
        price: 15000,
        startDate: "2021-07-17",
        endDate: "2021-08-29",
      },
      {
        price: 14000,
        startDate: "2022-07-09",
        endDate: "2022-07-17",
      },
      {
        price: 15000,
        startDate: "2022-07-16",
        endDate: "2022-08-28",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/66/39 Naushon-1.jpg",
    },
    location: {
      lat: 41.45987,
      lng: -70.65857,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "10 Mayfield Way",
    },
    features: ["A/C", "Pool"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/10-mayfield-way",
    bookings: [
      {
        endDate: "2019-09-01",
        startDate: "2019-07-06",
      },
      {
        endDate: "2019-10-06",
        startDate: "2019-09-07",
      },
    ],
    rates: [
      {
        price: 28000,
        startDate: "2022-08-06",
        endDate: "2022-08-21",
      },
      {
        price: 24000,
        startDate: "2022-07-02",
        endDate: "2022-08-07",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/9/Moravek-12.jpg",
    },
    location: {
      lat: 41.393958,
      lng: -70.524385,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "32 Martha's Road",
    },
    features: [],
    beds: 4,
    sleeps: 7,
    type: "rental",
    path: "/rentals/32-martha's-road",
    bookings: [
      {
        endDate: "2020-07-19",
        startDate: "2020-06-27",
      },
      {
        endDate: "2019-07-21",
        startDate: "2019-06-29",
      },
      {
        endDate: "2021-07-11",
        startDate: "2021-06-15",
      },
      {
        endDate: "2021-10-31",
        startDate: "2021-08-21",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-08-31",
      },
    ],
    rates: [
      {
        price: 2300,
        startDate: "2021-09-25",
        endDate: "2021-10-10",
      },
      {
        price: 2300,
        startDate: "2020-10-02",
        endDate: "2020-11-01",
      },
      {
        price: 1600,
        startDate: "2019-09-28",
        endDate: "2019-11-03",
      },
      {
        price: 2500,
        startDate: "2021-05-22",
        endDate: "2021-06-27",
      },
      {
        price: 1800,
        startDate: "2019-09-07",
        endDate: "2019-09-29",
      },
      {
        price: 2800,
        startDate: "2019-06-29",
        endDate: "2019-09-08",
      },
    ],
    defaultImage: {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/58/32 Marthas-1.jpg",
    },
    location: {
      lat: 41.37933,
      lng: -70.540585,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "105 Edgartown Bay Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/105-edgartown-bay-road",
    bookings: [
      {
        endDate: "2019-08-25",
        startDate: "2019-06-30",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-06-28",
      },
    ],
    rates: [
      {
        price: 10500,
        startDate: "2019-08-24",
        endDate: "2019-09-15",
      },
      {
        price: 11500,
        startDate: "2019-08-03",
        endDate: "2019-08-25",
      },
      {
        price: 10500,
        startDate: "2021-06-19",
        endDate: "2021-07-18",
      },
      {
        price: 10500,
        startDate: "2020-06-20",
        endDate: "2020-07-12",
      },
      {
        price: 11500,
        startDate: "2020-07-11",
        endDate: "2020-08-23",
      },
      {
        price: 10500,
        startDate: "2020-08-22",
        endDate: "2020-09-13",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/11/Bayha-1.jpg",
    },
    location: {
      lat: 41.351767,
      lng: -70.502384,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "384 Middle Road",
    },
    features: [],
    beds: 6,
    sleeps: 8,
    type: "rental",
    path: "/rentals/384-middle-road",
    bookings: [
      {
        endDate: "2019-08-04",
        startDate: "2019-06-22",
      },
      {
        endDate: "2022-08-15",
        startDate: "2022-08-14",
      },
      {
        endDate: "2018-09-02",
        startDate: "2018-07-28",
      },
      {
        endDate: "2020-07-25",
        startDate: "2020-07-10",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-08-14",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-30",
      },
      {
        endDate: "2020-07-11",
        startDate: "2020-07-01",
      },
      {
        endDate: "2020-09-20",
        startDate: "2020-09-12",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-07-30",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-08-15",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-08-14",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-06-25",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2019-07-27",
        endDate: "2019-08-18",
      },
      {
        price: 9500,
        startDate: "2019-08-17",
        endDate: "2019-09-29",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/64/Drummond-1792.jpg",
    },
    location: {
      lat: 41.345977,
      lng: -70.740775,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "181 South Road",
    },
    features: [],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/181-south-road",
    bookings: [
      {
        endDate: "2021-10-25",
        startDate: "2021-10-10",
      },
      {
        endDate: "2020-10-12",
        startDate: "2020-09-20",
      },
      {
        endDate: "2019-08-20",
        startDate: "2019-08-11",
      },
      {
        endDate: "2018-09-30",
        startDate: "2018-08-29",
      },
      {
        endDate: "2022-09-26",
        startDate: "2022-08-28",
      },
      {
        endDate: "2022-06-14",
        startDate: "2022-06-04",
      },
      {
        endDate: "2021-09-20",
        startDate: "2021-09-12",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-06-23",
      },
      {
        endDate: "2019-08-12",
        startDate: "2019-08-03",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-06-24",
      },
      {
        endDate: "2019-09-03",
        startDate: "2019-08-19",
      },
      {
        endDate: "2022-10-24",
        startDate: "2022-10-09",
      },
      {
        endDate: "2022-07-01",
        startDate: "2022-06-13",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2019-05-04",
        endDate: "2019-06-01",
      },
      {
        price: 4000,
        startDate: "2019-09-29",
        endDate: "2019-11-01",
      },
      {
        price: 10000,
        startDate: "2022-08-21",
        endDate: "2022-09-05",
      },
      {
        price: 5000,
        startDate: "2022-09-25",
        endDate: "2022-10-31",
      },
    ],
    defaultImage: {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/32/181 South-1.jpg",
    },
    location: {
      lat: 41.359125,
      lng: -70.691607,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "11 Ocean View Farm Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 5,
    sleeps: 9,
    type: "rental",
    path: "/rentals/11-ocean-view-farm-road",
    bookings: [
      {
        endDate: "2022-08-07",
        startDate: "2022-07-16",
      },
      {
        endDate: "2022-07-17",
        startDate: "2022-06-04",
      },
    ],
    rates: [
      {
        price: 9750,
        startDate: "2019-07-20",
        endDate: "2019-08-25",
      },
      {
        price: 8000,
        startDate: "2021-09-04",
        endDate: "2021-10-31",
      },
      {
        price: 8500,
        startDate: "2019-07-13",
        endDate: "2019-07-21",
      },
      {
        price: 7500,
        startDate: "2021-01-02",
        endDate: "2021-06-06",
      },
      {
        price: 8000,
        startDate: "2021-06-05",
        endDate: "2021-07-04",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/14/Pough-31.jpg",
    },
    location: {
      lat: 41.347934,
      lng: -70.71511,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "111 Pease's Point Way",
    },
    features: ["A/C", "Linens Provided"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/111-pease's-point-way",
    bookings: [
      {
        endDate: "2022-09-25",
        startDate: "2022-09-10",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-06-18",
      },
      {
        endDate: "2019-09-15",
        startDate: "2019-09-07",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-06-29",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-05-31",
      },
      {
        endDate: "2021-06-20",
        startDate: "2020-12-27",
      },
      {
        endDate: "2021-09-26",
        startDate: "2021-06-19",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-09-25",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-01",
      },
      {
        endDate: "2019-12-06",
        startDate: "2019-10-17",
      },
      {
        endDate: "2018-08-18",
        startDate: "2018-08-04",
      },
    ],
    rates: [
      {
        price: 11000,
        startDate: "2022-09-24",
        endDate: "2022-11-06",
      },
      {
        price: 12000,
        startDate: "2020-07-04",
        endDate: "2020-08-01",
      },
      {
        price: 8000,
        startDate: "2019-09-01",
        endDate: "2019-09-07",
      },
      {
        price: 7000,
        startDate: "2019-09-15",
        endDate: "2019-10-06",
      },
      {
        price: 5000,
        startDate: "2020-10-31",
        endDate: "2021-01-03",
      },
      {
        price: 3500,
        startDate: "2020-01-04",
        endDate: "2020-04-26",
      },
      {
        price: 3500,
        startDate: "2020-04-25",
        endDate: "2020-05-03",
      },
      {
        price: 5000,
        startDate: "2020-05-16",
        endDate: "2020-05-31",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/15/Celests-31.jpg",
    },
    location: {
      lat: 41.385195,
      lng: -70.519617,
    },
  },
  {
    baths: 7,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "117 Plantingfield Way",
    },
    features: ["A/C", "Dock", "Linens Provided", "Pool", "Waterfront"],
    beds: 7,
    sleeps: 12,
    type: "rental",
    path: "/rentals/117-plantingfield-way",
    bookings: [
      {
        endDate: "2021-06-27",
        startDate: "2021-06-05",
      },
      {
        endDate: "2021-09-12",
        startDate: "2021-09-04",
      },
      {
        endDate: "2021-09-26",
        startDate: "2021-09-18",
      },
      {
        endDate: "2022-07-25",
        startDate: "2022-06-12",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-07-27",
      },
      {
        endDate: "2022-09-12",
        startDate: "2022-08-21",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-06-26",
      },
      {
        endDate: "2022-06-13",
        startDate: "2022-05-29",
      },
      {
        endDate: "2018-09-19",
        startDate: "2018-09-02",
      },
      {
        endDate: "2020-07-05",
        startDate: "2020-06-20",
      },
    ],
    rates: [
      {
        price: 30000,
        startDate: "2022-09-04",
        endDate: "2022-10-31",
      },
      {
        price: 25000,
        startDate: "2018-12-30",
        endDate: "2019-06-16",
      },
      {
        price: 25000,
        startDate: "2020-01-04",
        endDate: "2020-06-14",
      },
      {
        price: 25000,
        startDate: "2019-08-31",
        endDate: "2020-01-05",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/17/117 Plantingfield-1.jpg",
    },
    location: {
      lat: 41.401211,
      lng: -70.51845,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "141 Waldrons Bottom Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 4,
    sleeps: 9,
    type: "rental",
    path: "/rentals/141-waldrons-bottom-road",
    bookings: [
      {
        endDate: "2022-06-19",
        startDate: "2022-01-01",
      },
      {
        endDate: "2018-08-25",
        startDate: "2018-08-11",
      },
      {
        endDate: "2021-08-01",
        startDate: "2021-07-10",
      },
      {
        endDate: "2020-08-11",
        startDate: "2020-08-01",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-09-10",
      },
      {
        endDate: "2019-08-10",
        startDate: "2019-07-27",
      },
    ],
    rates: [
      {
        price: 5250,
        startDate: "2022-06-18",
        endDate: "2022-07-31",
      },
      {
        price: 4400,
        startDate: "2020-05-31",
        endDate: "2020-06-28",
      },
      {
        price: 4000,
        startDate: "2020-09-05",
        endDate: "2020-11-01",
      },
      {
        price: 4000,
        startDate: "2019-08-31",
        endDate: "2019-11-03",
      },
      {
        price: 5250,
        startDate: "2019-06-22",
        endDate: "2019-07-28",
      },
      {
        price: 2000,
        startDate: "2019-11-02",
        endDate: "2020-01-05",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/22/Lynch-13.jpg",
    },
    location: {
      lat: 41.375256,
      lng: -70.620978,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "15 Pond Road",
    },
    features: ["A/C", "Linens Provided", "Pool"],
    beds: 4,
    sleeps: 9,
    type: "rental",
    path: "/rentals/15-pond-road",
    bookings: [
      {
        endDate: "2021-08-08",
        startDate: "2021-07-17",
      },
      {
        endDate: "2018-09-03",
        startDate: "2018-07-29",
      },
      {
        endDate: "2020-07-13",
        startDate: "2020-06-20",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-07-31",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-08-07",
      },
      {
        endDate: "2019-09-03",
        startDate: "2019-08-11",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-08-15",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2020-06-07",
        endDate: "2020-06-22",
      },
      {
        price: 14000,
        startDate: "2021-08-07",
        endDate: "2021-08-15",
      },
      {
        price: 13000,
        startDate: "2021-07-17",
        endDate: "2021-07-25",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/24/Shavers-26.jpg",
    },
    location: {
      lat: 41.382261,
      lng: -70.634619,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "17 Navy Way",
    },
    features: ["A/C", "Linens Provided"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/17-navy-way",
    bookings: [
      {
        endDate: "2021-09-05",
        startDate: "2021-07-10",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-07-04",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-05-26",
      },
      {
        endDate: "2022-05-26",
        startDate: "2022-05-18",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-07-20",
      },
      {
        endDate: "2022-07-24",
        startDate: "2022-07-02",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2021-09-04",
        endDate: "2021-11-07",
      },
      {
        price: 6500,
        startDate: "2019-04-27",
        endDate: "2019-06-30",
      },
      {
        price: 6500,
        startDate: "2020-01-05",
        endDate: "2020-06-29",
      },
      {
        price: 6500,
        startDate: "2020-08-30",
        endDate: "2021-01-03",
      },
      {
        price: 6500,
        startDate: "2019-08-31",
        endDate: "2020-01-01",
      },
      {
        price: 4500,
        startDate: "2021-11-06",
        endDate: "2022-01-02",
      },
      {
        price: 7000,
        startDate: "2022-08-27",
        endDate: "2022-10-30",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/30/DSC_0762.jpg",
    },
    location: {
      lat: 41.35045,
      lng: -70.512242,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "16 Oakdale Drive",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 0,
    type: "rental",
    path: "/rentals/16-oakdale-drive",
    bookings: [
      {
        endDate: "2019-07-09",
        startDate: "2019-07-01",
      },
      {
        endDate: "2019-06-11",
        startDate: "2019-05-26",
      },
      {
        endDate: "2019-06-18",
        startDate: "2019-06-10",
      },
      {
        endDate: "2019-08-13",
        startDate: "2019-07-15",
      },
      {
        endDate: "2018-09-03",
        startDate: "2018-07-30",
      },
      {
        endDate: "2019-07-15",
        startDate: "2019-07-09",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-13",
      },
    ],
    rates: [
      {
        price: 3575,
        startDate: "2019-07-01",
        endDate: "2019-09-03",
      },
      {
        price: 2850,
        startDate: "2019-05-26",
        endDate: "2019-06-18",
      },
      {
        price: 2850,
        startDate: "2019-06-17",
        endDate: "2019-07-02",
      },
      {
        price: 3450,
        startDate: "2018-07-30",
        endDate: "2018-08-06",
      },
      {
        price: 3450,
        startDate: "2018-08-06",
        endDate: "2018-08-13",
      },
      {
        price: 3450,
        startDate: "2018-08-13",
        endDate: "2018-08-20",
      },
      {
        price: 3450,
        startDate: "2018-08-20",
        endDate: "2018-08-27",
      },
      {
        price: 3450,
        startDate: "2018-08-27",
        endDate: "2018-09-03",
      },
      {
        price: 2650,
        startDate: "2018-09-03",
        endDate: "2018-09-10",
      },
      {
        price: 2650,
        startDate: "2018-09-10",
        endDate: "2018-09-17",
      },
      {
        price: 2650,
        startDate: "2018-09-17",
        endDate: "2018-09-24",
      },
      {
        price: 2650,
        startDate: "2018-09-24",
        endDate: "2018-10-01",
      },
    ],
    defaultImage: {
      dimensions: [1600, 900],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/27/16 oakdale 1.jpg",
    },
    location: {
      lat: 41.397683,
      lng: -70.530121,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "17 Blacksmith Valley Road",
    },
    features: ["Linens Provided"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/17-blacksmith-valley-road",
    bookings: [
      {
        endDate: "2019-08-11",
        startDate: "2019-07-13",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/29/Mahedy-1.jpg",
    },
    location: {
      lat: 41.321202,
      lng: -70.768988,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "19 Farm Pond Road",
    },
    features: ["A/C", "Dock", "Linens Provided", "Waterfront"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/19-farm-pond-road",
    bookings: [
      {
        endDate: "2022-10-02",
        startDate: "2022-08-27",
      },
      {
        endDate: "2019-08-10",
        startDate: "2019-07-20",
      },
      {
        endDate: "2020-09-14",
        startDate: "2020-09-02",
      },
      {
        endDate: "2020-09-03",
        startDate: "2020-08-29",
      },
      {
        endDate: "2021-08-01",
        startDate: "2021-07-03",
      },
      {
        endDate: "2020-10-02",
        startDate: "2020-09-25",
      },
      {
        endDate: "2020-09-21",
        startDate: "2020-09-15",
      },
      {
        endDate: "2018-09-22",
        startDate: "2018-09-15",
      },
      {
        endDate: "2019-07-21",
        startDate: "2019-07-06",
      },
    ],
    rates: [
      {
        price: 9000,
        startDate: "2018-12-01",
        endDate: "2018-12-08",
      },
      {
        price: 9000,
        startDate: "2018-12-08",
        endDate: "2018-12-15",
      },
      {
        price: 9000,
        startDate: "2018-12-15",
        endDate: "2018-12-22",
      },
      {
        price: 9000,
        startDate: "2018-12-22",
        endDate: "2018-12-29",
      },
      {
        price: 9000,
        startDate: "2018-12-29",
        endDate: "2019-01-05",
      },
      {
        price: 17500,
        startDate: "2020-07-18",
        endDate: "2020-08-02",
      },
      {
        price: 8000,
        startDate: "2019-05-25",
        endDate: "2019-06-23",
      },
      {
        price: 18500,
        startDate: "2019-06-29",
        endDate: "2019-07-06",
      },
      {
        price: 17500,
        startDate: "2019-07-20",
        endDate: "2019-08-03",
      },
      {
        price: 18500,
        startDate: "2019-08-03",
        endDate: "2019-08-24",
      },
      {
        price: 9500,
        startDate: "2019-09-07",
        endDate: "2019-09-28",
      },
      {
        price: 7000,
        startDate: "2019-04-28",
        endDate: "2019-05-25",
      },
      {
        price: 8750,
        startDate: "2021-01-02",
        endDate: "2021-06-13",
      },
      {
        price: 8750,
        startDate: "2020-09-26",
        endDate: "2021-01-03",
      },
      {
        price: 8750,
        startDate: "2022-01-01",
        endDate: "2022-05-22",
      },
      {
        price: 9000,
        startDate: "2018-11-03",
        endDate: "2018-11-10",
      },
      {
        price: 9000,
        startDate: "2018-11-10",
        endDate: "2018-11-17",
      },
      {
        price: 9000,
        startDate: "2018-11-17",
        endDate: "2018-11-24",
      },
      {
        price: 9000,
        startDate: "2018-11-24",
        endDate: "2018-12-01",
      },
      {
        price: 10000,
        startDate: "2022-05-21",
        endDate: "2022-06-19",
      },
      {
        price: 18000,
        startDate: "2021-07-17",
        endDate: "2021-08-01",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/33/Sullivan-1.jpg",
    },
    location: {
      lat: 41.443196,
      lng: -70.558068,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "191 Thumbpoint Road",
    },
    features: ["A/C", "Linens Provided", "Waterfront"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/191-thumbpoint-road",
    bookings: [
      {
        endDate: "2018-09-02",
        startDate: "2018-08-03",
      },
      {
        endDate: "2019-09-02",
        startDate: "2019-06-30",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-06-27",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2018-08-31",
        endDate: "2018-09-15",
      },
      {
        price: 6000,
        startDate: "2018-12-30",
        endDate: "2019-07-01",
      },
      {
        price: 6000,
        startDate: "2019-09-22",
        endDate: "2020-01-05",
      },
      {
        price: 6000,
        startDate: "2020-01-05",
        endDate: "2020-06-01",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1063],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/34/DSC_6210.jpg",
    },
    location: {
      lat: 41.363239,
      lng: -70.640957,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "2 Morse Street",
    },
    features: ["A/C", "Dock", "Linens Provided", "Waterfront"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/2-morse-street",
    bookings: [
      {
        endDate: "2022-10-03",
        startDate: "2022-09-18",
      },
      {
        endDate: "2021-05-24",
        startDate: "2021-05-02",
      },
      {
        endDate: "2021-07-05",
        startDate: "2021-06-05",
      },
      {
        endDate: "2022-08-08",
        startDate: "2022-07-03",
      },
      {
        endDate: "2021-10-28",
        startDate: "2021-09-26",
      },
      {
        endDate: "2022-06-27",
        startDate: "2022-06-12",
      },
      {
        endDate: "2019-07-22",
        startDate: "2019-06-27",
      },
      {
        endDate: "2022-10-24",
        startDate: "2022-10-16",
      },
      {
        endDate: "2022-10-17",
        startDate: "2022-10-09",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-06-27",
      },
      {
        endDate: "2020-04-06",
        startDate: "2020-03-29",
      },
      {
        endDate: "2020-04-20",
        startDate: "2020-04-12",
      },
      {
        endDate: "2018-10-01",
        startDate: "2018-09-23",
      },
    ],
    rates: [
      {
        price: 20000,
        startDate: "2019-04-28",
        endDate: "2019-06-30",
      },
      {
        price: 5000,
        startDate: "2021-05-02",
        endDate: "2021-05-17",
      },
    ],
    defaultImage: {
      dimensions: [1595, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/35/2 Dex Deck Final.jpg",
    },
    location: {
      lat: 41.390391,
      lng: -70.509334,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "2 Nonamessett Road",
    },
    features: ["A/C", "Hot Tub", "Linens Provided", "Pool"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/2-nonamessett-road",
    bookings: [
      {
        endDate: "2019-08-01",
        startDate: "2019-06-30",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-06-28",
      },
    ],
    rates: [
      {
        price: 14500,
        startDate: "2019-08-11",
        endDate: "2019-08-25",
      },
      {
        price: 8500,
        startDate: "2019-08-25",
        endDate: "2019-11-03",
      },
      {
        price: 14500,
        startDate: "2019-06-30",
        endDate: "2019-08-11",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/36/Alpert-18.jpg",
    },
    location: {
      lat: 41.3757885,
      lng: -70.5927592,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "2 Osprey Lane",
    },
    features: ["A/C", "Dock", "Linens Provided", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/2-osprey-lane",
    bookings: [
      {
        endDate: "2021-09-06",
        startDate: "2021-05-30",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-08-02",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-07-28",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2021-05-30",
        endDate: "2021-07-19",
      },
      {
        price: 18000,
        startDate: "2020-07-19",
        endDate: "2020-08-03",
      },
    ],
    defaultImage: {
      dimensions: [1600, 900],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/38/FIRST PHOTO.jpg",
    },
    location: {
      lat: 41.34438,
      lng: -70.71564,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "20 Old Barnes Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/20-old-barnes-road",
    bookings: [
      {
        endDate: "2021-10-03",
        startDate: "2021-08-21",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-05-30",
      },
    ],
    rates: [
      {
        price: 6000,
        startDate: "2021-06-26",
        endDate: "2021-07-18",
      },
      {
        price: 5500,
        startDate: "2019-06-30",
        endDate: "2019-07-21",
      },
      {
        price: 6500,
        startDate: "2019-07-21",
        endDate: "2019-08-25",
      },
      {
        price: 3500,
        startDate: "2020-05-30",
        endDate: "2020-06-21",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1066],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/40/20 Old Barnes Road  - for web.jpg",
    },
    location: {
      lat: 41.4413239,
      lng: -70.5889607,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "208 Katama Road",
    },
    features: ["A/C", "Linens Provided", "Pool"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/208-katama-road",
    bookings: [
      {
        endDate: "2019-08-11",
        startDate: "2019-06-30",
      },
      {
        endDate: "2022-07-25",
        startDate: "2022-07-03",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2020-06-27",
        endDate: "2020-09-05",
      },
      {
        price: 15000,
        startDate: "2021-12-26",
        endDate: "2022-12-26",
      },
    ],
    defaultImage: {
      dimensions: [1528, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/41/Thorne-Doyle-20.jpg",
    },
    location: {
      lat: 41.377443,
      lng: -70.515776,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "21 North Neck Road",
    },
    features: ["A/C", "Linens Provided", "Waterfront"],
    beds: 7,
    sleeps: 0,
    type: "rental",
    path: "/rentals/21-north-neck-road",
    bookings: [
      {
        endDate: "2022-08-28",
        startDate: "2022-06-25",
      },
    ],
    rates: [
      {
        price: 14500,
        startDate: "2022-01-01",
        endDate: "2022-05-16",
      },
      {
        price: 17500,
        startDate: "2019-07-07",
        endDate: "2019-07-28",
      },
      {
        price: 18500,
        startDate: "2022-05-15",
        endDate: "2023-01-01",
      },
      {
        price: 17500,
        startDate: "2019-08-18",
        endDate: "2019-09-08",
      },
      {
        price: 20000,
        startDate: "2019-07-28",
        endDate: "2019-08-18",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/42/8.jpg",
    },
    location: {
      lat: 41.39428,
      lng: -70.47094,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "22 Tilton Cove Way",
    },
    features: ["Linens Provided", "Waterfront"],
    beds: 2,
    sleeps: 0,
    type: "rental",
    path: "/rentals/22-tilton-cove-way",
    bookings: [
      {
        endDate: "2022-12-26",
        startDate: "2021-12-26",
      },
    ],
    rates: [
      {
        price: 8500,
        startDate: "2019-07-07",
        endDate: "2019-09-09",
      },
      {
        price: 7500,
        startDate: "2019-05-26",
        endDate: "2019-07-08",
      },
    ],
    defaultImage: {
      dimensions: [1443, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/45/1 photo.jpg",
    },
    location: {
      lat: 41.342428,
      lng: -70.721081,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "23 Cemetery Road",
    },
    features: [],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/23-cemetery-road",
    bookings: [
      {
        endDate: "2019-08-18",
        startDate: "2019-07-13",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2019-06-29",
        endDate: "2019-07-21",
      },
      {
        price: 10000,
        startDate: "2019-07-21",
        endDate: "2019-09-08",
      },
    ],
    defaultImage: {
      dimensions: [1600, 799],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/46/1 photo.jpg",
    },
    location: {
      lat: 41.386338,
      lng: -70.731677,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "230 Meetinghouse Way",
    },
    features: ["A/C", "Linens Provided", "Pool"],
    beds: 6,
    sleeps: 14,
    type: "rental",
    path: "/rentals/230-meetinghouse-way",
    bookings: [
      {
        endDate: "2019-09-09",
        startDate: "2019-09-05",
      },
      {
        endDate: "2019-05-25",
        startDate: "2019-05-20",
      },
      {
        endDate: "2020-05-25",
        startDate: "2020-05-20",
      },
      {
        endDate: "2019-10-07",
        startDate: "2019-10-02",
      },
      {
        endDate: "2019-06-24",
        startDate: "2019-06-15",
      },
      {
        endDate: "2019-06-09",
        startDate: "2019-06-01",
      },
      {
        endDate: "2021-12-27",
        startDate: "2021-09-15",
      },
      {
        endDate: "2018-10-06",
        startDate: "2018-10-02",
      },
      {
        endDate: "2021-08-09",
        startDate: "2021-07-04",
      },
      {
        endDate: "2020-09-08",
        startDate: "2020-08-30",
      },
      {
        endDate: "2022-09-19",
        startDate: "2022-07-03",
      },
      {
        endDate: "2021-09-16",
        startDate: "2021-09-05",
      },
      {
        endDate: "2022-05-23",
        startDate: "2022-05-15",
      },
      {
        endDate: "2022-07-04",
        startDate: "2022-06-26",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2020-04-26",
        endDate: "2020-05-04",
      },
      {
        price: 4000,
        startDate: "2019-09-29",
        endDate: "2019-10-28",
      },
      {
        price: 4000,
        startDate: "2020-01-01",
        endDate: "2020-04-27",
      },
      {
        price: 4000,
        startDate: "2019-10-27",
        endDate: "2019-12-30",
      },
      {
        price: 4000,
        startDate: "2019-01-06",
        endDate: "2019-05-05",
      },
      {
        price: 5000,
        startDate: "2019-05-05",
        endDate: "2019-05-26",
      },
      {
        price: 15000,
        startDate: "2019-07-21",
        endDate: "2019-08-12",
      },
      {
        price: 4000,
        startDate: "2018-12-30",
        endDate: "2019-01-06",
      },
      {
        price: 5000,
        startDate: "2020-05-03",
        endDate: "2020-05-18",
      },
      {
        price: 5000,
        startDate: "2020-10-04",
        endDate: "2020-10-26",
      },
      {
        price: 4000,
        startDate: "2020-10-25",
        endDate: "2020-12-28",
      },
      {
        price: 5000,
        startDate: "2021-04-25",
        endDate: "2021-05-10",
      },
      {
        price: 6500,
        startDate: "2021-05-16",
        endDate: "2021-05-24",
      },
      {
        price: 6000,
        startDate: "2022-09-18",
        endDate: "2022-10-03",
      },
      {
        price: 5000,
        startDate: "2022-10-02",
        endDate: "2022-10-24",
      },
      {
        price: 4000,
        startDate: "2022-10-23",
        endDate: "2023-01-01",
      },
    ],
    defaultImage: {
      dimensions: [951, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/47/230 meetinghouse-1.jpg",
    },
    location: {
      lat: 41.369109,
      lng: -70.525003,
    },
  },
  {
    baths: 7,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "24 Leah's Lane",
    },
    features: ["A/C", "Pool"],
    beds: 7,
    sleeps: 14,
    type: "rental",
    path: "/rentals/24-leah's-lane",
    bookings: [
      {
        endDate: "2021-07-04",
        startDate: "2021-01-02",
      },
      {
        endDate: "2021-10-03",
        startDate: "2021-07-03",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-06-30",
      },
    ],
    rates: [
      {
        price: 21000,
        startDate: "2022-01-01",
        endDate: "2023-01-01",
      },
      {
        price: 16800,
        startDate: "2021-01-02",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1600, 999],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/48/1 photo.jpg",
    },
    location: {
      lat: 41.37609,
      lng: -70.6059,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "243 Pond Road",
    },
    features: ["A/C", "Linens Provided", "Pool"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/243-pond-road",
    bookings: [
      {
        endDate: "2021-07-18",
        startDate: "2021-06-26",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-06-27",
      },
    ],
    rates: [
      {
        price: 14000,
        startDate: "2021-06-26",
        endDate: "2021-09-19",
      },
    ],
    defaultImage: {
      dimensions: [1024, 639],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/50/243 pond road-28.jpg",
    },
    location: {
      lat: 41.382298,
      lng: -70.642829,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "25 Knoll Drive",
    },
    features: ["A/C", "Pool"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/25-knoll-drive",
    bookings: [
      {
        endDate: "2019-09-03",
        startDate: "2019-06-16",
      },
      {
        endDate: "2021-05-23",
        startDate: "2021-05-15",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-07-24",
      },
      {
        endDate: "2020-09-21",
        startDate: "2020-06-21",
      },
    ],
    rates: [
      {
        price: 3000,
        startDate: "2018-05-06",
        endDate: "2018-05-27",
      },
      {
        price: 3500,
        startDate: "2018-05-27",
        endDate: "2018-06-03",
      },
      {
        price: 4000,
        startDate: "2018-06-03",
        endDate: "2018-06-24",
      },
      {
        price: 4500,
        startDate: "2018-06-24",
        endDate: "2018-07-01",
      },
      {
        price: 4000,
        startDate: "2019-09-08",
        endDate: "2019-09-30",
      },
      {
        price: 2500,
        startDate: "2018-04-29",
        endDate: "2018-05-06",
      },
      {
        price: 4000,
        startDate: "2021-05-16",
        endDate: "2021-06-21",
      },
      {
        price: 15000,
        startDate: "2022-07-23",
        endDate: "2022-08-07",
      },
      {
        price: 3000,
        startDate: "2020-09-27",
        endDate: "2020-11-09",
      },
      {
        price: 3000,
        startDate: "2019-09-29",
        endDate: "2019-11-04",
      },
      {
        price: 3000,
        startDate: "2020-12-27",
        endDate: "2021-05-10",
      },
      {
        price: 3500,
        startDate: "2021-05-09",
        endDate: "2021-05-17",
      },
      {
        price: 3500,
        startDate: "2021-09-19",
        endDate: "2021-12-27",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/51/1.jpg",
    },
    location: {
      lat: 41.373114,
      lng: -70.517404,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "27 Pierce Lane",
    },
    features: ["A/C", "Pool"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/27-pierce-lane",
    bookings: [
      {
        endDate: "2022-09-05",
        startDate: "2022-09-03",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-07-17",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-06-27",
      },
    ],
    rates: [
      {
        price: 22500,
        startDate: "2021-05-08",
        endDate: "2021-06-27",
      },
      {
        price: 22500,
        startDate: "2020-07-04",
        endDate: "2020-08-02",
      },
      {
        price: 30000,
        startDate: "2021-07-24",
        endDate: "2021-09-12",
      },
      {
        price: 22500,
        startDate: "2019-08-25",
        endDate: "2019-09-29",
      },
      {
        price: 15000,
        startDate: "2022-01-01",
        endDate: "2022-06-26",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/52/IMG_4257.jpg",
    },
    location: {
      lat: 41.3932655,
      lng: -70.5147542,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "4 Morse Street",
    },
    features: ["A/C", "Dock", "Waterfront"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/4-morse-street",
    bookings: [
      {
        endDate: "2021-11-01",
        startDate: "2021-10-24",
      },
      {
        endDate: "2021-10-18",
        startDate: "2021-10-10",
      },
      {
        endDate: "2021-10-25",
        startDate: "2021-10-17",
      },
      {
        endDate: "2021-05-02",
        startDate: "2021-04-24",
      },
      {
        endDate: "2021-04-18",
        startDate: "2021-04-11",
      },
      {
        endDate: "2022-06-20",
        startDate: "2022-06-05",
      },
      {
        endDate: "2022-10-17",
        startDate: "2022-09-11",
      },
      {
        endDate: "2022-08-15",
        startDate: "2022-07-03",
      },
      {
        endDate: "2018-08-20",
        startDate: "2018-08-19",
      },
      {
        endDate: "2018-09-30",
        startDate: "2018-09-23",
      },
      {
        endDate: "2020-07-16",
        startDate: "2020-06-27",
      },
      {
        endDate: "2021-10-11",
        startDate: "2021-10-03",
      },
      {
        endDate: "2021-04-12",
        startDate: "2021-04-02",
      },
      {
        endDate: "2020-03-21",
        startDate: "2020-03-13",
      },
      {
        endDate: "2020-09-01",
        startDate: "2020-07-15",
      },
      {
        endDate: "2021-04-25",
        startDate: "2021-04-17",
      },
      {
        endDate: "2021-05-17",
        startDate: "2021-05-09",
      },
      {
        endDate: "2022-12-05",
        startDate: "2022-10-30",
      },
      {
        endDate: "2022-05-16",
        startDate: "2022-05-01",
      },
      {
        endDate: "2022-06-06",
        startDate: "2022-05-29",
      },
      {
        endDate: "2022-05-30",
        startDate: "2022-05-22",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-08",
      },
      {
        endDate: "2022-06-27",
        startDate: "2022-06-19",
      },
      {
        endDate: "2019-08-19",
        startDate: "2019-07-28",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2021-09-19",
        endDate: "2021-09-27",
      },
      {
        price: 25000,
        startDate: "2022-07-03",
        endDate: "2022-08-29",
      },
      {
        price: 6000,
        startDate: "2022-10-02",
        endDate: "2022-10-31",
      },
      {
        price: 25000,
        startDate: "2020-06-27",
        endDate: "2020-09-07",
      },
      {
        price: 12500,
        startDate: "2021-09-12",
        endDate: "2021-09-20",
      },
      {
        price: 7500,
        startDate: "2021-09-26",
        endDate: "2021-10-04",
      },
      {
        price: 6500,
        startDate: "2021-10-03",
        endDate: "2021-10-18",
      },
      {
        price: 5000,
        startDate: "2021-10-17",
        endDate: "2021-12-27",
      },
      {
        price: 20000,
        startDate: "2019-12-29",
        endDate: "2020-06-28",
      },
    ],
    defaultImage: {
      dimensions: [480, 352],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/67/1 NightA1 Final.JPG",
    },
    location: {
      lat: 41.390342,
      lng: -70.509459,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "275 South Road",
    },
    features: ["A/C", "Hot Tub", "Linens Provided", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/275-south-road",
    bookings: [
      {
        endDate: "2020-08-31",
        startDate: "2020-05-31",
      },
    ],
    rates: [
      {
        price: 30000,
        startDate: "2020-05-31",
        endDate: "2020-09-28",
      },
    ],

    location: {
      lat: 41.3512421,
      lng: -70.7044804,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "135 South Water Street",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/135-south-water-street",
    bookings: [
      {
        endDate: "2019-08-04",
        startDate: "2019-07-21",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-08-20",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-07-17",
      },
      {
        endDate: "2021-07-04",
        startDate: "2021-06-16",
      },
      {
        endDate: "2018-09-14",
        startDate: "2018-09-13",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-08",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2019-07-06",
        endDate: "2019-07-21",
      },
      {
        price: 11500,
        startDate: "2019-07-20",
        endDate: "2019-08-04",
      },
      {
        price: 6000,
        startDate: "2019-09-14",
        endDate: "2019-09-22",
      },
      {
        price: 5500,
        startDate: "2019-09-21",
        endDate: "2019-11-24",
      },
      {
        price: 10000,
        startDate: "2021-07-03",
        endDate: "2021-07-18",
      },
      {
        price: 5500,
        startDate: "2021-10-02",
        endDate: "2021-12-05",
      },
      {
        price: 5500,
        startDate: "2021-04-03",
        endDate: "2021-05-23",
      },
      {
        price: 5500,
        startDate: "2020-09-26",
        endDate: "2020-11-29",
      },
      {
        price: 11500,
        startDate: "2020-07-18",
        endDate: "2020-07-26",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/19/Ratan-1.jpg",
    },
    location: {
      lat: 41.384912,
      lng: -70.517448,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "117 Herring Creek",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/117-herring-creek",
    bookings: [
      {
        endDate: "2021-01-03",
        startDate: "2020-09-07",
      },
      {
        endDate: "2022-07-10",
        startDate: "2022-06-04",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-07-24",
      },
    ],
    rates: [
      {
        price: 10500,
        startDate: "2021-06-05",
        endDate: "2021-09-05",
      },
      {
        price: 11500,
        startDate: "2022-06-04",
        endDate: "2022-09-04",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/16/117-herring-creek.jpg",
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Noras Lane",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/2-noras-lane",
    bookings: [
      {
        endDate: "2019-05-27",
        startDate: "2019-05-23",
      },
      {
        endDate: "2022-09-25",
        startDate: "2022-09-17",
      },
      {
        endDate: "2022-10-17",
        startDate: "2022-10-06",
      },
      {
        endDate: "2019-09-09",
        startDate: "2019-09-01",
      },
      {
        endDate: "2020-07-19",
        startDate: "2020-06-13",
      },
      {
        endDate: "2020-09-27",
        startDate: "2020-09-05",
      },
      {
        endDate: "2021-09-12",
        startDate: "2021-08-28",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-07-27",
      },
      {
        endDate: "2022-07-24",
        startDate: "2022-07-16",
      },
    ],
    rates: [
      {
        price: 30000,
        startDate: "2022-07-16",
        endDate: "2022-07-24",
      },
      {
        price: 8000,
        startDate: "2021-10-10",
        endDate: "2021-12-27",
      },
      {
        price: 8000,
        startDate: "2022-10-22",
        endDate: "2022-10-30",
      },
      {
        price: 8000,
        startDate: "2022-10-15",
        endDate: "2022-10-23",
      },
      {
        price: 8000,
        startDate: "2022-10-08",
        endDate: "2022-10-16",
      },
      {
        price: 7000,
        startDate: "2022-04-30",
        endDate: "2022-05-08",
      },
      {
        price: 22500,
        startDate: "2019-07-27",
        endDate: "2019-08-25",
      },
      {
        price: 8000,
        startDate: "2019-09-14",
        endDate: "2020-01-05",
      },
      {
        price: 25250,
        startDate: "2020-08-01",
        endDate: "2020-08-23",
      },
    ],

    location: {
      lat: 41.3820732,
      lng: -70.5243352,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Vineyard Haven",

      text: "55 Harbor View Lane",
    },
    features: ["A/C", "Waterfront"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/55-harbor-view-lane",
    bookings: [
      {
        endDate: "2020-09-01",
        startDate: "2020-08-17",
      },
      {
        endDate: "2020-09-13",
        startDate: "2020-09-04",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-06-19",
      },
      {
        endDate: "2019-09-02",
        startDate: "2019-07-06",
      },
      {
        endDate: "2020-07-19",
        startDate: "2020-05-31",
      },
      {
        endDate: "2020-08-18",
        startDate: "2020-07-18",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-06-11",
      },
      {
        endDate: "2022-08-14",
        startDate: "2022-07-16",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-06-29",
      },
      {
        endDate: "2019-06-23",
        startDate: "2019-06-15",
      },
    ],
    rates: [
      {
        price: 9000,
        startDate: "2020-05-30",
        endDate: "2020-08-02",
      },
      {
        price: 8000,
        startDate: "2019-04-28",
        endDate: "2019-06-03",
      },
      {
        price: 9000,
        startDate: "2019-09-08",
        endDate: "2019-11-04",
      },
      {
        price: 16000,
        startDate: "2019-06-30",
        endDate: "2019-08-05",
      },
      {
        price: 19000,
        startDate: "2019-08-04",
        endDate: "2019-09-02",
      },
      {
        price: 11000,
        startDate: "2019-06-16",
        endDate: "2019-06-24",
      },
      {
        price: 9000,
        startDate: "2019-06-02",
        endDate: "2019-06-17",
      },
    ],
    defaultImage: {
      dimensions: [1024, 512],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/77/harborview-1.jpg",
    },
    location: {
      lat: 41.469608,
      lng: -70.59671,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "5 Mercier Way",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/5-mercier-way",
    bookings: [
      {
        endDate: "2019-08-25",
        startDate: "2019-07-13",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-08-20",
      },
      {
        endDate: "2020-07-26",
        startDate: "2020-07-04",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-07-30",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-07-24",
      },
      {
        endDate: "2021-07-11",
        startDate: "2021-06-26",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2019-06-29",
        endDate: "2019-08-31",
      },
      {
        price: 5000,
        startDate: "2019-05-04",
        endDate: "2019-05-18",
      },
      {
        price: 5500,
        startDate: "2019-05-18",
        endDate: "2019-06-01",
      },
      {
        price: 6500,
        startDate: "2019-06-08",
        endDate: "2019-06-15",
      },
      {
        price: 5000,
        startDate: "2019-09-28",
        endDate: "2019-10-19",
      },
      {
        price: 4500,
        startDate: "2019-10-19",
        endDate: "2019-10-27",
      },
      {
        price: 7000,
        startDate: "2019-06-15",
        endDate: "2019-06-22",
      },
      {
        price: 6000,
        startDate: "2019-06-01",
        endDate: "2019-06-08",
      },
      {
        price: 7500,
        startDate: "2019-08-31",
        endDate: "2019-09-07",
      },
      {
        price: 6500,
        startDate: "2019-09-14",
        endDate: "2019-09-21",
      },
      {
        price: 6000,
        startDate: "2019-09-21",
        endDate: "2019-09-28",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/72/5 Mercier-1.jpg",
    },
    location: {
      lat: 41.372983,
      lng: -70.513882,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Vineyard Haven",

      text: "550 Chappaquonsett Road",
    },
    features: ["A/C", "Waterfront"],
    beds: 8,
    sleeps: 0,
    type: "rental",
    path: "/rentals/550-chappaquonsett-road",
    bookings: [
      {
        endDate: "2020-09-09",
        startDate: "2020-08-22",
      },
      {
        endDate: "2020-07-26",
        startDate: "2020-06-28",
      },
      {
        endDate: "2018-08-03",
        startDate: "2018-08-01",
      },
      {
        endDate: "2018-08-11",
        startDate: "2018-08-05",
      },
      {
        endDate: "2018-08-26",
        startDate: "2018-08-12",
      },
      {
        endDate: "2022-09-02",
        startDate: "2022-07-31",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-06-28",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-07-25",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-06-30",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-07-28",
      },
      {
        endDate: "2021-08-16",
        startDate: "2021-08-01",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2019-09-15",
        endDate: "2019-09-29",
      },
      {
        price: 10000,
        startDate: "2019-09-29",
        endDate: "2019-10-06",
      },
      {
        price: 15000,
        startDate: "2022-08-28",
        endDate: "2022-10-03",
      },
      {
        price: 12000,
        startDate: "2020-09-13",
        endDate: "2020-09-28",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/79/chappaquonsett-1.jpg",
    },
    location: {
      lat: 41.461679,
      lng: -70.643229,
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "77 Cooke Street",
    },
    features: ["A/C", "Hot Tub", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/77-cooke-street",
    bookings: [
      {
        endDate: "2022-06-27",
        startDate: "2022-06-18",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-06-30",
      },
      {
        endDate: "2022-09-18",
        startDate: "2022-09-10",
      },
      {
        endDate: "2022-04-03",
        startDate: "2022-01-01",
      },
      {
        endDate: "2021-08-01",
        startDate: "2021-06-26",
      },
      {
        endDate: "2020-07-26",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-29",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-07-02",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-18",
      },
      {
        endDate: "2018-09-03",
        startDate: "2018-07-28",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2022-04-02",
        endDate: "2022-06-26",
      },
      {
        price: 15000,
        startDate: "2021-04-03",
        endDate: "2021-06-27",
      },
      {
        price: 15000,
        startDate: "2019-03-31",
        endDate: "2019-06-02",
      },
      {
        price: 21500,
        startDate: "2019-06-23",
        endDate: "2019-09-08",
      },
      {
        price: 15000,
        startDate: "2020-04-04",
        endDate: "2020-06-07",
      },
      {
        price: 15000,
        startDate: "2020-09-05",
        endDate: "2020-11-29",
      },
      {
        price: 17500,
        startDate: "2019-06-02",
        endDate: "2019-06-23",
      },
      {
        price: 17500,
        startDate: "2019-09-08",
        endDate: "2019-09-29",
      },
      {
        price: 15000,
        startDate: "2019-09-29",
        endDate: "2019-12-01",
      },
      {
        price: 17500,
        startDate: "2020-06-06",
        endDate: "2020-06-28",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/93/cooke-1.jpg",
    },
    location: {
      lat: 41.389824,
      lng: -70.517894,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "18 Spruce Gate Road",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/18-spruce-gate-road",
    bookings: [
      {
        endDate: "2020-08-30",
        startDate: "2020-08-08",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2020-06-07",
        endDate: "2020-09-06",
      },
      {
        price: 25000,
        startDate: "2021-05-30",
        endDate: "2021-10-03",
      },
      {
        price: 25000,
        startDate: "2022-01-01",
        endDate: "2022-07-03",
      },
    ],
    defaultImage: {
      dimensions: [1023, 767],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/111/18 Spruce Gate-1.jpg",
    },
    location: {
      lat: 41.30816,
      lng: -70.771601,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "140 Merry Farm Road",
    },
    features: ["A/C", "Hot Tub", "Linens Provided", "Pool"],
    beds: 7,
    sleeps: 12,
    type: "rental",
    path: "/rentals/140-merry-farm-road",
    bookings: [
      {
        endDate: "2019-07-13",
        startDate: "2019-07-05",
      },
      {
        endDate: "2018-08-19",
        startDate: "2018-07-28",
      },
      {
        endDate: "2018-09-01",
        startDate: "2018-08-25",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2022-01-01",
        endDate: "2022-10-02",
      },
      {
        price: 15000,
        startDate: "2020-12-27",
        endDate: "2021-09-06",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/21/Screen Shot 2020-10-16 at 12.04.56 PM.jpg",
    },
    location: {
      lat: 41.435804,
      lng: -70.64659,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "6 Trails End",
    },
    features: ["A/C", "Pool"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/6-trails-end",
    bookings: [
      {
        endDate: "2019-09-08",
        startDate: "2019-06-15",
      },
      {
        endDate: "2022-05-30",
        startDate: "2022-05-25",
      },
      {
        endDate: "2022-07-12",
        startDate: "2022-07-04",
      },
      {
        endDate: "2022-08-09",
        startDate: "2022-07-25",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-08",
      },
      {
        endDate: "2022-09-15",
        startDate: "2022-09-10",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-07-03",
      },
      {
        endDate: "2018-08-28",
        startDate: "2018-08-11",
      },
      {
        endDate: "2020-06-14",
        startDate: "2020-06-06",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-06-28",
      },
      {
        endDate: "2018-08-04",
        startDate: "2018-07-28",
      },
    ],
    rates: [
      {
        price: 10150,
        startDate: "2019-06-15",
        endDate: "2020-01-05",
      },
      {
        price: 10150,
        startDate: "2020-01-04",
        endDate: "2020-02-02",
      },
      {
        price: 12400,
        startDate: "2022-06-25",
        endDate: "2022-07-05",
      },
      {
        price: 11700,
        startDate: "2021-07-17",
        endDate: "2021-09-05",
      },
      {
        price: 11700,
        startDate: "2020-07-18",
        endDate: "2020-09-06",
      },
      {
        price: 4000,
        startDate: "2020-05-02",
        endDate: "2020-06-07",
      },
      {
        price: 13000,
        startDate: "2022-07-04",
        endDate: "2022-09-11",
      },
      {
        price: 9000,
        startDate: "2021-07-03",
        endDate: "2021-07-11",
      },
      {
        price: 10000,
        startDate: "2021-07-10",
        endDate: "2021-07-18",
      },
      {
        price: 10000,
        startDate: "2020-07-11",
        endDate: "2020-07-19",
      },
      {
        price: 5000,
        startDate: "2020-09-26",
        endDate: "2020-10-04",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/88/trailsend-1.jpg",
    },
    location: {
      lat: 41.352229,
      lng: -70.718844,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "290 Lambert’s Cove Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 6,
    sleeps: 10,
    type: "rental",
    path: "/rentals/290-lambert's-cove-road",
    bookings: [
      {
        endDate: "2020-08-12",
        startDate: "2020-07-26",
      },
      {
        endDate: "2018-08-18",
        startDate: "2018-08-11",
      },
      {
        endDate: "2022-10-03",
        startDate: "2022-05-29",
      },
      {
        endDate: "2019-08-19",
        startDate: "2019-08-10",
      },
      {
        endDate: "2019-08-11",
        startDate: "2019-07-28",
      },
    ],
    rates: [
      {
        price: 6000,
        startDate: "2021-04-25",
        endDate: "2021-05-03",
      },
      {
        price: 6000,
        startDate: "2018-12-30",
        endDate: "2019-05-06",
      },
      {
        price: 7500,
        startDate: "2019-09-01",
        endDate: "2019-10-07",
      },
      {
        price: 7500,
        startDate: "2019-05-05",
        endDate: "2019-06-03",
      },
      {
        price: 9000,
        startDate: "2019-06-30",
        endDate: "2019-09-02",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/54/Andris-2.jpg",
    },
    location: {
      lat: 41.440452,
      lng: -70.667236,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "31 Road to the Plains",
    },
    features: [],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/31-road-to-the-plains",
    bookings: [
      {
        endDate: "2019-09-02",
        startDate: "2019-06-16",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-08-02",
      },
    ],
    rates: [
      {
        price: 2700,
        startDate: "2019-03-31",
        endDate: "2019-06-17",
      },
      {
        price: 5000,
        startDate: "2021-08-29",
        endDate: "2021-12-27",
      },
      {
        price: 3200,
        startDate: "2019-06-16",
        endDate: "2019-07-01",
      },
    ],

    location: {
      lat: 41.376089,
      lng: -70.528296,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "31 Sheep Hill Road",
    },
    features: [],
    beds: 4,
    sleeps: 12,
    type: "rental",
    path: "/rentals/31-sheep-hill-road",
    bookings: [
      {
        endDate: "2019-07-26",
        startDate: "2019-07-24",
      },
      {
        endDate: "2019-07-24",
        startDate: "2019-07-06",
      },
      {
        endDate: "2019-09-03",
        startDate: "2019-08-09",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-07-11",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-07-05",
      },
      {
        endDate: "2018-09-07",
        startDate: "2018-08-03",
      },
    ],
    rates: [
      {
        price: 10500,
        startDate: "2020-05-31",
        endDate: "2020-09-07",
      },
    ],

    location: {
      lat: 41.363958,
      lng: -70.690975,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "37 Simpsons Lane",
    },
    features: [],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/37-simpsons-lane",
    bookings: [
      {
        endDate: "2018-09-29",
        startDate: "2018-09-15",
      },
      {
        endDate: "2018-10-22",
        startDate: "2018-10-18",
      },
      {
        endDate: "2019-07-14",
        startDate: "2019-06-21",
      },
      {
        endDate: "2019-06-11",
        startDate: "2019-05-23",
      },
      {
        endDate: "2019-09-15",
        startDate: "2019-08-31",
      },
      {
        endDate: "2019-10-14",
        startDate: "2019-10-11",
      },
      {
        endDate: "2019-10-21",
        startDate: "2019-10-19",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2019-01-05",
        endDate: "2019-06-02",
      },
      {
        price: 6000,
        startDate: "2020-08-29",
        endDate: "2020-10-04",
      },
      {
        price: 6000,
        startDate: "2021-09-04",
        endDate: "2021-09-26",
      },
      {
        price: 6000,
        startDate: "2019-06-01",
        endDate: "2019-06-30",
      },
    ],

    location: {
      lat: 41.390954,
      lng: -70.512115,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      state: "Edgartown",
      text: "14 Mockingbird Drive",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/14-mockingbird-drive",
    bookings: [
      {
        endDate: "2022-09-01",
        startDate: "2022-07-30",
      },
      {
        endDate: "2021-09-02",
        startDate: "2021-08-01",
      },
      {
        endDate: "2021-07-05",
        startDate: "2021-06-19",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-07-11",
      },
    ],
    rates: [
      {
        price: 4500,
        startDate: "2021-01-03",
        endDate: "2021-03-29",
      },
      {
        price: 4500,
        startDate: "2021-03-28",
        endDate: "2021-06-28",
      },
      {
        price: 4500,
        startDate: "2019-09-22",
        endDate: "2019-12-30",
      },
      {
        price: 4700,
        startDate: "2020-09-06",
        endDate: "2020-09-21",
      },
      {
        price: 4500,
        startDate: "2020-09-20",
        endDate: "2020-12-28",
      },
      {
        price: 4700,
        startDate: "2019-09-08",
        endDate: "2019-09-23",
      },
      {
        price: 4500,
        startDate: "2020-12-27",
        endDate: "2021-01-04",
      },
    ],

    location: {
      lat: 41.412059,
      lng: -70.57844,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "41 Smith Hollow Road",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/41-smith-hollow-road",
    bookings: [
      {
        endDate: "2021-06-13",
        startDate: "2020-12-27",
      },
      {
        endDate: "2021-10-03",
        startDate: "2021-06-12",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-10-02",
      },
    ],
    rates: [
      {
        price: 3600,
        startDate: "2019-05-04",
        endDate: "2019-06-02",
      },
      {
        price: 3700,
        startDate: "2019-06-01",
        endDate: "2019-06-09",
      },
      {
        price: 5000,
        startDate: "2019-06-15",
        endDate: "2019-06-23",
      },
    ],

    location: {
      lat: 41.406019,
      lng: -70.563458,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "48 Mill Street",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/48-mill-street",
    bookings: [
      {
        endDate: "2019-08-19",
        startDate: "2019-06-30",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-07-03",
      },
      {
        endDate: "2019-09-03",
        startDate: "2019-08-18",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-07-02",
      },
      {
        endDate: "2020-07-06",
        startDate: "2020-06-21",
      },
      {
        endDate: "2022-09-11",
        startDate: "2022-09-03",
      },
    ],
    rates: [
      {
        price: 4900,
        startDate: "2019-09-15",
        endDate: "2019-12-30",
      },
      {
        price: 4900,
        startDate: "2019-12-29",
        endDate: "2020-06-08",
      },
      {
        price: 7250,
        startDate: "2019-06-30",
        endDate: "2019-08-26",
      },
      {
        price: 4900,
        startDate: "2019-05-26",
        endDate: "2019-06-17",
      },
      {
        price: 4800,
        startDate: "2022-10-09",
        endDate: "2023-01-01",
      },
      {
        price: 7650,
        startDate: "2022-07-23",
        endDate: "2022-08-29",
      },
      {
        price: 4900,
        startDate: "2020-09-13",
        endDate: "2020-12-28",
      },
    ],

    location: {
      lat: 41.392167,
      lng: -70.518255,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "6 Meshacket Road",
    },
    features: [],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/6-meshacket-road",
    bookings: [
      {
        endDate: "2022-06-05",
        startDate: "2022-04-30",
      },
      {
        endDate: "2022-09-13",
        startDate: "2022-09-07",
      },
      {
        endDate: "2022-09-19",
        startDate: "2022-09-14",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-06-18",
      },
      {
        endDate: "2021-12-20",
        startDate: "2021-12-17",
      },
      {
        endDate: "2022-01-01",
        startDate: "2021-12-24",
      },
      {
        endDate: "2022-01-03",
        startDate: "2021-12-31",
      },
      {
        endDate: "2022-09-27",
        startDate: "2022-09-23",
      },
      {
        endDate: "2022-06-17",
        startDate: "2022-06-10",
      },
      {
        endDate: "2021-02-19",
        startDate: "2021-02-14",
      },
      {
        endDate: "2021-06-07",
        startDate: "2021-06-02",
      },
      {
        endDate: "2021-06-15",
        startDate: "2021-06-09",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-07-03",
      },
      {
        endDate: "2020-05-19",
        startDate: "2020-05-14",
      },
      {
        endDate: "2020-06-08",
        startDate: "2020-05-22",
      },
      {
        endDate: "2020-06-22",
        startDate: "2020-06-14",
      },
      {
        endDate: "2020-09-08",
        startDate: "2020-06-27",
      },
      {
        endDate: "2020-10-26",
        startDate: "2020-10-22",
      },
      {
        endDate: "2019-06-23",
        startDate: "2019-06-02",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-06-29",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-03",
      },
    ],
    rates: [
      {
        price: 4430,
        startDate: "2020-05-23",
        endDate: "2020-06-07",
      },
      {
        price: 3625,
        startDate: "2020-09-19",
        endDate: "2020-10-04",
      },
      {
        price: 3625,
        startDate: "2020-05-02",
        endDate: "2020-05-17",
      },
      {
        price: 3625,
        startDate: "2020-05-16",
        endDate: "2020-05-24",
      },
    ],

    location: {
      lat: 41.379835,
      lng: -70.527922,
    },
  },
  {
    baths: 9,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "6 Tilton Cove",
    },
    features: [],
    beds: 6,
    sleeps: 0,
    type: "rental",
    path: "/rentals/6-tilton-cove",
    bookings: [
      {
        endDate: "2021-09-28",
        startDate: "2021-05-30",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-11",
      },
      {
        endDate: "2019-08-11",
        startDate: "2019-07-21",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-05-31",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2020-08-30",
        endDate: "2020-10-05",
      },
    ],

    location: {
      lat: 41.345623,
      lng: -70.719763,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "60 Witchwood Lane",
    },
    features: ["A/C", "Dock", "Waterfront"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/60-witchwood-lane",
    bookings: [
      {
        endDate: "2018-09-05",
        startDate: "2018-08-28",
      },
      {
        endDate: "2022-09-02",
        startDate: "2022-06-19",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-05-01",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-06-28",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-06-13",
      },
      {
        endDate: "2018-08-26",
        startDate: "2018-07-29",
      },
    ],
    rates: [
      {
        price: 23000,
        startDate: "2020-06-20",
        endDate: "2020-07-26",
      },
      {
        price: 25000,
        startDate: "2021-07-31",
        endDate: "2021-08-22",
      },
      {
        price: 23000,
        startDate: "2019-06-01",
        endDate: "2019-07-28",
      },
      {
        price: 15000,
        startDate: "2019-09-01",
        endDate: "2019-10-20",
      },
      {
        price: 10000,
        startDate: "2019-10-20",
        endDate: "2020-01-05",
      },
      {
        price: 15000,
        startDate: "2020-08-29",
        endDate: "2020-09-20",
      },
      {
        price: 10000,
        startDate: "2020-01-04",
        endDate: "2020-05-24",
      },
      {
        price: 10000,
        startDate: "2020-05-23",
        endDate: "2020-06-21",
      },
      {
        price: 15000,
        startDate: "2022-04-30",
        endDate: "2022-05-22",
      },
      {
        price: 25000,
        startDate: "2020-07-25",
        endDate: "2020-08-23",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/89/witchwood-1.jpg",
    },
    location: {
      lat: 41.374487,
      lng: -70.507202,
    },
  },
  {
    baths: 2,
    bathsHalf: 6,
    address: {
      city: "Edgartown",
      state: "MA",
      text: "66 Clevelandtown Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 0,
    type: "rental",
    path: "/rentals/66-clevelandtown-road",
    bookings: [
      {
        endDate: "2018-09-08",
        startDate: "2018-07-28",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-07-09",
      },
    ],
    rates: [
      {
        price: 2400,
        startDate: "2019-08-31",
        endDate: "2019-10-07",
      },
      {
        price: 2400,
        startDate: "2021-09-04",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1600, 959],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/90/exterior.jpg",
    },
    location: {
      lat: 41.3813546,
      lng: -70.5231878,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "69 Cape Higgon Way",
    },
    features: ["A/C", "Dock"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/69-cape-higgon-way",
    bookings: [
      {
        endDate: "2021-09-07",
        startDate: "2021-06-10",
      },
      {
        endDate: "2018-08-20",
        startDate: "2018-08-16",
      },
      {
        endDate: "2018-08-30",
        startDate: "2018-08-24",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-07-03",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-07-04",
      },
    ],
    rates: [
      {
        price: 20000,
        startDate: "2018-12-30",
        endDate: "2019-06-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/91/higgon-1.jpg",
    },
    location: {
      lat: 41.39553,
      lng: -70.72817,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "709 Old County Road",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/709-old-county-road",
    bookings: [
      {
        endDate: "2019-09-13",
        startDate: "2019-09-08",
      },
      {
        endDate: "2018-08-19",
        startDate: "2018-08-04",
      },
      {
        endDate: "2022-08-13",
        startDate: "2022-08-12",
      },
      {
        endDate: "2022-09-16",
        startDate: "2022-09-03",
      },
      {
        endDate: "2022-08-13",
        startDate: "2022-07-23",
      },
      {
        endDate: "2021-06-21",
        startDate: "2021-05-30",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-08",
      },
      {
        endDate: "2019-07-29",
        startDate: "2019-07-07",
      },
      {
        endDate: "2019-08-26",
        startDate: "2019-07-28",
      },
      {
        endDate: "2019-09-09",
        startDate: "2019-08-25",
      },
      {
        endDate: "2018-09-15",
        startDate: "2018-09-01",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-08-20",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-07-26",
      },
    ],
    rates: [
      {
        price: 1800,
        startDate: "2019-09-12",
        endDate: "2019-10-12",
      },
      {
        price: 4500,
        startDate: "2019-08-04",
        endDate: "2019-09-13",
      },
      {
        price: 5300,
        startDate: "2022-06-18",
        endDate: "2022-09-16",
      },
      {
        price: 3500,
        startDate: "2022-09-15",
        endDate: "2022-10-09",
      },
      {
        price: 2000,
        startDate: "2021-09-26",
        endDate: "2021-11-08",
      },
      {
        price: 4500,
        startDate: "2020-08-09",
        endDate: "2020-08-24",
      },
    ],
    defaultImage: {
      dimensions: [1024, 731],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/92/oldcounty-1.jpg",
    },
    location: {
      lat: 41.403744131125684,
      lng: -70.66072718334392,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "80 Mattakesett Way",
    },
    features: [],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/80-mattakesett-way",
    bookings: [
      {
        endDate: "2021-07-24",
        startDate: "2021-07-16",
      },
      {
        endDate: "2021-07-03",
        startDate: "2021-06-25",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-08-14",
      },
      {
        endDate: "2018-08-17",
        startDate: "2018-07-29",
      },
      {
        endDate: "2018-07-29",
        startDate: "2018-07-27",
      },
      {
        endDate: "2020-08-15",
        startDate: "2020-08-07",
      },
      {
        endDate: "2020-07-11",
        startDate: "2020-07-03",
      },
      {
        endDate: "2020-07-04",
        startDate: "2020-06-05",
      },
      {
        endDate: "2021-07-17",
        startDate: "2021-07-02",
      },
      {
        endDate: "2021-08-14",
        startDate: "2021-08-06",
      },
      {
        endDate: "2021-08-07",
        startDate: "2021-07-23",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-13",
      },
      {
        endDate: "2019-08-26",
        startDate: "2019-08-09",
      },
      {
        endDate: "2020-08-08",
        startDate: "2020-07-24",
      },
      {
        endDate: "2019-08-10",
        startDate: "2019-07-19",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-03-27",
      },
    ],
    rates: [
      {
        price: 5800,
        startDate: "2020-04-03",
        endDate: "2020-06-06",
      },
      {
        price: 5800,
        startDate: "2020-06-05",
        endDate: "2020-06-27",
      },
      {
        price: 6400,
        startDate: "2020-06-26",
        endDate: "2020-10-03",
      },
      {
        price: 6400,
        startDate: "2019-07-13",
        endDate: "2019-08-10",
      },
      {
        price: 6750,
        startDate: "2021-06-25",
        endDate: "2021-09-11",
      },
      {
        price: 6400,
        startDate: "2019-08-10",
        endDate: "2019-09-08",
      },
      {
        price: 5800,
        startDate: "2019-06-28",
        endDate: "2019-07-13",
      },
      {
        price: 6400,
        startDate: "2019-09-08",
        endDate: "2019-12-29",
      },
    ],

    location: {
      lat: 41.353517,
      lng: -70.51801,
    },
  },
  {
    baths: 1,
    bathsHalf: 1,
    address: {
      city: "Oak Bluffs",

      text: "8 Nantucket Avenue",
    },
    features: [],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/8-nantucket-avenue",
    bookings: [
      {
        endDate: "2019-08-04",
        startDate: "2019-07-25",
      },
      {
        endDate: "2022-07-18",
        startDate: "2022-07-10",
      },
      {
        endDate: "2018-08-12",
        startDate: "2018-08-05",
      },
      {
        endDate: "2018-08-19",
        startDate: "2018-08-12",
      },
      {
        endDate: "2018-08-26",
        startDate: "2018-08-19",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-08-01",
      },
      {
        endDate: "2020-08-03",
        startDate: "2020-07-23",
      },
      {
        endDate: "2020-07-24",
        startDate: "2020-07-11",
      },
      {
        endDate: "2022-07-11",
        startDate: "2022-07-03",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-07-10",
      },
      {
        endDate: "2019-08-19",
        startDate: "2019-08-11",
      },
    ],
    rates: [
      {
        price: 7000,
        startDate: "2022-06-26",
        endDate: "2022-08-22",
      },
      {
        price: 6000,
        startDate: "2021-06-26",
        endDate: "2021-08-30",
      },
    ],
    defaultImage: {
      dimensions: [1024, 738],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/94/nantucket-1.jpg",
    },
    location: {
      lat: 41.450984,
      lng: -70.554012,
    },
  },
  {
    baths: 7,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "80 North Water Street",
    },
    features: ["A/C"],
    beds: 12,
    sleeps: 0,
    type: "rental",
    path: "/rentals/80-north-water-street",
    bookings: [
      {
        endDate: "2019-06-16",
        startDate: "2019-06-10",
      },
      {
        endDate: "2020-06-28",
        startDate: "2020-05-30",
      },
      {
        endDate: "2019-03-01",
        startDate: "2019-01-01",
      },
      {
        endDate: "2019-06-10",
        startDate: "2019-05-25",
      },
      {
        endDate: "2019-07-08",
        startDate: "2019-06-23",
      },
      {
        endDate: "2018-09-09",
        startDate: "2018-07-29",
      },
      {
        endDate: "2019-07-21",
        startDate: "2019-07-07",
      },
      {
        endDate: "2019-03-11",
        startDate: "2019-03-07",
      },
      {
        endDate: "2019-09-18",
        startDate: "2019-08-25",
      },
      {
        endDate: "2019-10-22",
        startDate: "2019-10-17",
      },
      {
        endDate: "2022-10-10",
        startDate: "2022-09-08",
      },
      {
        endDate: "2022-07-18",
        startDate: "2022-07-09",
      },
      {
        endDate: "2022-10-17",
        startDate: "2022-10-13",
      },
      {
        endDate: "2021-04-05",
        startDate: "2021-04-01",
      },
      {
        endDate: "2021-02-07",
        startDate: "2021-01-02",
      },
      {
        endDate: "2021-02-16",
        startDate: "2021-02-11",
      },
      {
        endDate: "2021-07-11",
        startDate: "2021-06-22",
      },
      {
        endDate: "2021-10-19",
        startDate: "2021-08-26",
      },
      {
        endDate: "2020-03-05",
        startDate: "2019-12-29",
      },
      {
        endDate: "2020-11-30",
        startDate: "2020-11-22",
      },
      {
        endDate: "2019-12-16",
        startDate: "2019-12-12",
      },
      {
        endDate: "2020-08-10",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-10-01",
        startDate: "2020-09-23",
      },
      {
        endDate: "2019-11-09",
        startDate: "2019-11-01",
      },
      {
        endDate: "2021-11-29",
        startDate: "2021-11-21",
      },
      {
        endDate: "2021-12-13",
        startDate: "2021-12-10",
      },
      {
        endDate: "2022-05-13",
        startDate: "2022-05-05",
      },
      {
        endDate: "2022-06-15",
        startDate: "2022-05-16",
      },
      {
        endDate: "2022-07-10",
        startDate: "2022-06-16",
      },
      {
        endDate: "2021-04-12",
        startDate: "2021-04-09",
      },
      {
        endDate: "2021-04-19",
        startDate: "2021-04-15",
      },
      {
        endDate: "2021-04-25",
        startDate: "2021-04-21",
      },
      {
        endDate: "2021-05-05",
        startDate: "2021-04-29",
      },
      {
        endDate: "2021-05-24",
        startDate: "2021-05-09",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-07-25",
      },
      {
        endDate: "2021-06-14",
        startDate: "2021-05-23",
      },
      {
        endDate: "2019-07-29",
        startDate: "2019-07-21",
      },
      {
        endDate: "2022-08-15",
        startDate: "2022-07-31",
      },
      {
        endDate: "2020-07-13",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-09-08",
        startDate: "2020-09-03",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2020-11-01",
        endDate: "2020-11-23",
      },
      {
        price: 5000,
        startDate: "2019-01-01",
        endDate: "2019-03-03",
      },
      {
        price: 6000,
        startDate: "2019-03-03",
        endDate: "2019-05-05",
      },
      {
        price: 6000,
        startDate: "2019-05-05",
        endDate: "2019-05-12",
      },
      {
        price: 7000,
        startDate: "2019-05-12",
        endDate: "2019-05-19",
      },
      {
        price: 8000,
        startDate: "2019-05-19",
        endDate: "2019-05-26",
      },
      {
        price: 19000,
        startDate: "2019-08-25",
        endDate: "2019-09-16",
      },
      {
        price: 15000,
        startDate: "2019-09-15",
        endDate: "2019-09-30",
      },
      {
        price: 15000,
        startDate: "2019-09-29",
        endDate: "2019-10-21",
      },
      {
        price: 14000,
        startDate: "2019-10-20",
        endDate: "2019-10-28",
      },
      {
        price: 12000,
        startDate: "2019-10-27",
        endDate: "2019-11-04",
      },
      {
        price: 5000,
        startDate: "2019-11-03",
        endDate: "2019-11-18",
      },
      {
        price: 10000,
        startDate: "2020-11-22",
        endDate: "2020-11-30",
      },
      {
        price: 15000,
        startDate: "2020-08-30",
        endDate: "2020-10-12",
      },
      {
        price: 14000,
        startDate: "2020-10-11",
        endDate: "2020-10-19",
      },
      {
        price: 12000,
        startDate: "2020-10-18",
        endDate: "2020-10-26",
      },
      {
        price: 12000,
        startDate: "2020-10-25",
        endDate: "2020-11-02",
      },
      {
        price: 15000,
        startDate: "2021-10-10",
        endDate: "2021-10-18",
      },
      {
        price: 12000,
        startDate: "2021-10-17",
        endDate: "2021-11-01",
      },
      {
        price: 5000,
        startDate: "2019-11-17",
        endDate: "2019-11-25",
      },
      {
        price: 10000,
        startDate: "2019-11-24",
        endDate: "2019-12-09",
      },
      {
        price: 5000,
        startDate: "2019-12-08",
        endDate: "2019-12-30",
      },
      {
        price: 5000,
        startDate: "2021-12-26",
        endDate: "2022-03-28",
      },
      {
        price: 9000,
        startDate: "2022-04-24",
        endDate: "2022-05-30",
      },
      {
        price: 15000,
        startDate: "2022-09-25",
        endDate: "2022-10-10",
      },
      {
        price: 15000,
        startDate: "2022-10-16",
        endDate: "2022-10-31",
      },
      {
        price: 5000,
        startDate: "2022-10-30",
        endDate: "2022-11-21",
      },
      {
        price: 5000,
        startDate: "2022-11-27",
        endDate: "2022-12-12",
      },
      {
        price: 12000,
        startDate: "2019-06-02",
        endDate: "2019-06-09",
      },
      {
        price: 12000,
        startDate: "2019-06-09",
        endDate: "2019-06-16",
      },
      {
        price: 12000,
        startDate: "2021-10-03",
        endDate: "2021-10-11",
      },
      {
        price: 5000,
        startDate: "2020-12-27",
        endDate: "2021-05-03",
      },
      {
        price: 50000,
        startDate: "2021-10-31",
        endDate: "2021-11-22",
      },
      {
        price: 5000,
        startDate: "2021-11-28",
        endDate: "2021-12-20",
      },
      {
        price: 12000,
        startDate: "2021-05-30",
        endDate: "2021-06-07",
      },
      {
        price: 18000,
        startDate: "2021-06-13",
        endDate: "2021-06-28",
      },
      {
        price: 27000,
        startDate: "2021-08-01",
        endDate: "2021-09-06",
      },
      {
        price: 12000,
        startDate: "2018-09-30",
        endDate: "2018-10-07",
      },
      {
        price: 12000,
        startDate: "2018-10-07",
        endDate: "2018-10-14",
      },
      {
        price: 9000,
        startDate: "2018-10-14",
        endDate: "2018-10-21",
      },
      {
        price: 9000,
        startDate: "2018-10-21",
        endDate: "2018-10-28",
      },
      {
        price: 9000,
        startDate: "2018-10-28",
        endDate: "2018-11-04",
      },
      {
        price: 6000,
        startDate: "2018-11-04",
        endDate: "2018-11-11",
      },
      {
        price: 6000,
        startDate: "2018-11-11",
        endDate: "2018-11-18",
      },
      {
        price: 9000,
        startDate: "2018-11-18",
        endDate: "2018-11-25",
      },
      {
        price: 5000,
        startDate: "2018-11-25",
        endDate: "2018-12-02",
      },
      {
        price: 5000,
        startDate: "2018-12-02",
        endDate: "2018-12-09",
      },
      {
        price: 5000,
        startDate: "2018-12-09",
        endDate: "2018-12-16",
      },
      {
        price: 5000,
        startDate: "2018-12-16",
        endDate: "2018-12-23",
      },
      {
        price: 5000,
        startDate: "2018-12-23",
        endDate: "2018-12-30",
      },
      {
        price: 5000,
        startDate: "2019-12-29",
        endDate: "2020-05-04",
      },
      {
        price: 7000,
        startDate: "2022-03-27",
        endDate: "2022-04-25",
      },
    ],
    defaultImage: {
      dimensions: [1024, 576],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/96/northwater-1.jpg",
    },
    location: {
      lat: 41.391072,
      lng: -70.50982,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "80 Pease's Point Way",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/80-pease's-point-way",
    bookings: [
      {
        endDate: "2022-09-12",
        startDate: "2022-09-08",
      },
      {
        endDate: "2020-06-16",
        startDate: "2020-06-11",
      },
      {
        endDate: "2020-06-23",
        startDate: "2020-06-18",
      },
      {
        endDate: "2020-09-22",
        startDate: "2020-09-16",
      },
      {
        endDate: "2021-06-14",
        startDate: "2021-06-09",
      },
      {
        endDate: "2021-06-22",
        startDate: "2021-06-17",
      },
      {
        endDate: "2022-09-06",
        startDate: "2022-06-01",
      },
      {
        endDate: "2018-11-03",
        startDate: "2018-10-27",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-08-25",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-07-20",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-09-13",
        startDate: "2020-09-05",
      },
      {
        endDate: "2018-09-01",
        startDate: "2018-07-28",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-06-22",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-07-13",
      },
    ],
    rates: [
      {
        price: 6202,
        startDate: "2022-05-28",
        endDate: "2022-08-28",
      },
      {
        price: 4025,
        startDate: "2022-09-24",
        endDate: "2023-01-01",
      },
      {
        price: 2850,
        startDate: "2018-12-30",
        endDate: "2019-05-26",
      },
      {
        price: 2850,
        startDate: "2019-05-25",
        endDate: "2019-06-02",
      },
      {
        price: 4025,
        startDate: "2020-10-03",
        endDate: "2021-01-03",
      },
      {
        price: 3000,
        startDate: "2018-10-13",
        endDate: "2018-10-20",
      },
      {
        price: 3000,
        startDate: "2018-10-20",
        endDate: "2018-10-27",
      },
      {
        price: 3000,
        startDate: "2018-10-27",
        endDate: "2018-11-03",
      },
      {
        price: 4025,
        startDate: "2021-01-02",
        endDate: "2021-05-02",
      },
      {
        price: 6202,
        startDate: "2021-05-29",
        endDate: "2021-09-05",
      },
      {
        price: 4165,
        startDate: "2022-05-07",
        endDate: "2022-05-29",
      },
      {
        price: 3000,
        startDate: "2018-10-06",
        endDate: "2018-10-13",
      },
      {
        price: 6202,
        startDate: "2019-09-01",
        endDate: "2019-09-08",
      },
      {
        price: 4500,
        startDate: "2019-09-08",
        endDate: "2019-10-06",
      },
      {
        price: 4165,
        startDate: "2019-06-01",
        endDate: "2019-06-23",
      },
      {
        price: 6202,
        startDate: "2019-06-29",
        endDate: "2019-07-07",
      },
      {
        price: 6202,
        startDate: "2019-07-06",
        endDate: "2019-07-28",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/97/peases-1.jpg",
    },
    location: {
      lat: 41.392758,
      lng: -70.512079,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "81 South Water Street",
    },
    features: [],
    beds: 7,
    sleeps: 10,
    type: "rental",
    path: "/rentals/81-south-water-street",
    bookings: [
      {
        endDate: "2022-09-25",
        startDate: "2022-01-01",
      },
      {
        endDate: "2018-08-16",
        startDate: "2018-08-04",
      },
      {
        endDate: "2018-08-18",
        startDate: "2018-08-17",
      },
      {
        endDate: "2020-07-29",
        startDate: "2020-06-28",
      },
    ],
    rates: [
      {
        price: 30000,
        startDate: "2018-09-23",
        endDate: "2018-09-30",
      },
    ],

    location: {
      lat: 41.386916,
      lng: -70.514388,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "91 Plantingfield Way",
    },
    features: [],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/91-plantingfield-way",
    bookings: [
      {
        endDate: "2021-09-22",
        startDate: "2021-09-14",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-05-01",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-06-28",
      },
      {
        endDate: "2021-06-20",
        startDate: "2021-06-12",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2021-06-26",
        endDate: "2021-08-02",
      },
      {
        price: 10000,
        startDate: "2021-06-05",
        endDate: "2021-06-27",
      },
    ],

    location: {
      lat: 41.39772,
      lng: -70.516249,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "337 Barnes Road",
    },
    features: ["A/C", "Dock", "Linens Provided", "Waterfront"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/337-barnes-road",
    bookings: [
      {
        endDate: "2021-07-05",
        startDate: "2021-05-29",
      },
      {
        endDate: "2022-08-15",
        startDate: "2022-06-26",
      },
      {
        endDate: "2022-04-04",
        startDate: "2021-12-26",
      },
      {
        endDate: "2019-08-11",
        startDate: "2019-07-20",
      },
      {
        endDate: "2018-08-05",
        startDate: "2018-06-30",
      },
      {
        endDate: "2020-08-16",
        startDate: "2020-07-06",
      },
      {
        endDate: "2018-08-25",
        startDate: "2018-08-04",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-07-05",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-08-11",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2022-04-03",
        endDate: "2022-05-02",
      },
      {
        price: 12000,
        startDate: "2022-06-26",
        endDate: "2022-07-18",
      },
      {
        price: 14000,
        startDate: "2022-07-17",
        endDate: "2022-08-01",
      },
      {
        price: 6500,
        startDate: "2019-04-27",
        endDate: "2019-05-26",
      },
      {
        price: 6500,
        startDate: "2018-04-21",
        endDate: "2018-05-27",
      },
      {
        price: 6900,
        startDate: "2018-05-26",
        endDate: "2018-06-03",
      },
      {
        price: 6900,
        startDate: "2018-06-02",
        endDate: "2018-07-01",
      },
      {
        price: 9500,
        startDate: "2018-06-30",
        endDate: "2018-07-29",
      },
      {
        price: 10700,
        startDate: "2018-07-28",
        endDate: "2018-08-05",
      },
      {
        price: 12500,
        startDate: "2018-08-04",
        endDate: "2018-08-12",
      },
      {
        price: 15000,
        startDate: "2018-08-11",
        endDate: "2018-08-19",
      },
      {
        price: 12500,
        startDate: "2018-08-18",
        endDate: "2018-08-26",
      },
      {
        price: 9500,
        startDate: "2018-08-25",
        endDate: "2018-09-02",
      },
      {
        price: 7900,
        startDate: "2018-09-01",
        endDate: "2018-09-09",
      },
      {
        price: 6900,
        startDate: "2018-09-08",
        endDate: "2018-09-30",
      },
      {
        price: 6500,
        startDate: "2020-04-25",
        endDate: "2020-05-24",
      },
      {
        price: 10700,
        startDate: "2019-07-27",
        endDate: "2019-08-04",
      },
    ],
    defaultImage: {
      dimensions: [1024, 762],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/59/barnes-1.jpg",
    },
    location: {
      lat: 41.44690659394038,
      lng: -70.57506757654902,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "50 Pinehurst Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/50-pinehurst-road",
    bookings: [
      {
        endDate: "2020-08-03",
        startDate: "2020-07-05",
      },
      {
        endDate: "2020-10-05",
        startDate: "2020-09-20",
      },
      {
        endDate: "2020-06-29",
        startDate: "2020-06-18",
      },
      {
        endDate: "2021-09-20",
        startDate: "2021-08-22",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-06-26",
      },
      {
        endDate: "2021-06-03",
        startDate: "2021-04-25",
      },
      {
        endDate: "2019-07-29",
        startDate: "2019-06-30",
      },
      {
        endDate: "2018-08-25",
        startDate: "2018-07-29",
      },
      {
        endDate: "2018-09-16",
        startDate: "2018-09-05",
      },
      {
        endDate: "2018-09-23",
        startDate: "2018-09-20",
      },
      {
        endDate: "2018-10-01",
        startDate: "2018-09-26",
      },
      {
        endDate: "2020-09-14",
        startDate: "2020-08-23",
      },
    ],
    rates: [
      {
        price: 3000,
        startDate: "2021-04-25",
        endDate: "2021-06-28",
      },
      {
        price: 3000,
        startDate: "2021-09-05",
        endDate: "2021-12-20",
      },
      {
        price: 3750,
        startDate: "2020-06-28",
        endDate: "2020-07-20",
      },
      {
        price: 3000,
        startDate: "2020-04-26",
        endDate: "2020-06-01",
      },
      {
        price: 5500,
        startDate: "2022-06-26",
        endDate: "2022-09-05",
      },
      {
        price: 3000,
        startDate: "2019-09-01",
        endDate: "2019-11-03",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/75/pinehurst-1.jpg",
    },
    location: {
      lat: 41.392188,
      lng: -70.526171,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "46 High Street",
    },
    features: ["A/C", "Linens Provided"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/46-high-street",
    bookings: [
      {
        endDate: "2021-10-06",
        startDate: "2021-09-04",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-25",
      },
      {
        endDate: "2019-06-30",
        startDate: "2019-06-26",
      },
      {
        endDate: "2019-06-08",
        startDate: "2019-06-01",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-07-06",
      },
      {
        endDate: "2022-10-23",
        startDate: "2022-10-01",
      },
      {
        endDate: "2022-05-22",
        startDate: "2022-05-07",
      },
      {
        endDate: "2020-05-24",
        startDate: "2020-05-16",
      },
      {
        endDate: "2020-05-31",
        startDate: "2020-05-23",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-07-23",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-09-01",
      },
      {
        endDate: "2019-06-16",
        startDate: "2019-06-08",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-06-20",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-08-15",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-07-27",
      },
    ],
    rates: [
      {
        price: 6250,
        startDate: "2022-10-01",
        endDate: "2022-10-16",
      },
      {
        price: 5000,
        startDate: "2021-05-15",
        endDate: "2021-05-23",
      },
      {
        price: 6250,
        startDate: "2021-05-22",
        endDate: "2021-05-30",
      },
      {
        price: 5000,
        startDate: "2019-05-04",
        endDate: "2019-05-25",
      },
      {
        price: 6250,
        startDate: "2019-05-25",
        endDate: "2019-06-01",
      },
      {
        price: 12000,
        startDate: "2019-06-30",
        endDate: "2019-07-06",
      },
      {
        price: 11500,
        startDate: "2019-07-06",
        endDate: "2019-07-20",
      },
      {
        price: 12000,
        startDate: "2019-07-20",
        endDate: "2019-07-27",
      },
      {
        price: 12000,
        startDate: "2019-07-27",
        endDate: "2019-08-03",
      },
      {
        price: 12000,
        startDate: "2019-08-03",
        endDate: "2019-08-17",
      },
      {
        price: 12500,
        startDate: "2019-08-17",
        endDate: "2019-08-24",
      },
      {
        price: 12000,
        startDate: "2019-08-24",
        endDate: "2019-08-31",
      },
      {
        price: 6250,
        startDate: "2019-09-28",
        endDate: "2019-10-06",
      },
      {
        price: 5500,
        startDate: "2022-05-14",
        endDate: "2022-05-22",
      },
      {
        price: 8250,
        startDate: "2019-06-08",
        endDate: "2019-06-16",
      },
      {
        price: 5500,
        startDate: "2022-05-07",
        endDate: "2022-05-15",
      },
      {
        price: 13000,
        startDate: "2021-07-31",
        endDate: "2021-08-15",
      },
      {
        price: 12500,
        startDate: "2021-08-14",
        endDate: "2021-08-22",
      },
      {
        price: 6250,
        startDate: "2020-05-23",
        endDate: "2020-05-31",
      },
      {
        price: 8750,
        startDate: "2020-06-06",
        endDate: "2020-06-14",
      },
      {
        price: 12000,
        startDate: "2020-06-27",
        endDate: "2020-07-12",
      },
      {
        price: 8250,
        startDate: "2020-09-12",
        endDate: "2020-09-20",
      },
      {
        price: 7250,
        startDate: "2020-09-19",
        endDate: "2020-09-27",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/70/high-1.jpg",
    },
    location: {
      lat: 41.387455,
      lng: -70.518511,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "4 Plover Lane",
    },
    features: ["A/C", "Linens Provided"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/4-plover-lane",
    bookings: [
      {
        endDate: "2019-10-06",
        startDate: "2019-05-26",
      },
      {
        endDate: "2020-10-04",
        startDate: "2020-05-31",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/68/plover-1.jpg",
    },
    location: {
      lat: 41.3544638,
      lng: -70.5045739,
    },
  },
  {
    baths: 7,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "385 Barnes Road",
    },
    features: ["A/C", "Linens Provided", "Pool", "Waterfront"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/385-barnes-road",
    bookings: [
      {
        endDate: "2022-09-19",
        startDate: "2022-09-01",
      },
      {
        endDate: "2021-10-18",
        startDate: "2021-10-15",
      },
      {
        endDate: "2021-10-26",
        startDate: "2021-10-23",
      },
      {
        endDate: "2021-11-29",
        startDate: "2021-11-25",
      },
      {
        endDate: "2021-12-06",
        startDate: "2021-12-02",
      },
      {
        endDate: "2021-12-27",
        startDate: "2021-12-19",
      },
      {
        endDate: "2022-05-23",
        startDate: "2022-05-19",
      },
      {
        endDate: "2018-08-26",
        startDate: "2018-08-04",
      },
      {
        endDate: "2018-09-09",
        startDate: "2018-09-06",
      },
      {
        endDate: "2021-05-25",
        startDate: "2021-05-13",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-07-11",
      },
      {
        endDate: "2019-05-19",
        startDate: "2019-05-16",
      },
      {
        endDate: "2019-06-07",
        startDate: "2019-05-25",
      },
      {
        endDate: "2019-06-11",
        startDate: "2019-06-06",
      },
      {
        endDate: "2020-09-11",
        startDate: "2020-08-09",
      },
      {
        endDate: "2018-09-16",
        startDate: "2018-09-13",
      },
      {
        endDate: "2018-09-24",
        startDate: "2018-09-20",
      },
      {
        endDate: "2018-09-30",
        startDate: "2018-09-28",
      },
      {
        endDate: "2018-10-14",
        startDate: "2018-10-03",
      },
      {
        endDate: "2019-06-24",
        startDate: "2019-06-20",
      },
      {
        endDate: "2019-05-06",
        startDate: "2019-05-02",
      },
      {
        endDate: "2019-08-26",
        startDate: "2019-08-04",
      },
      {
        endDate: "2019-09-23",
        startDate: "2019-09-15",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-05-29",
      },
      {
        endDate: "2022-09-29",
        startDate: "2022-09-24",
      },
      {
        endDate: "2021-06-28",
        startDate: "2021-05-30",
      },
    ],
    rates: [
      {
        price: 3675,
        startDate: "2021-05-02",
        endDate: "2021-05-10",
      },
      {
        price: 3150,
        startDate: "2020-12-27",
        endDate: "2021-03-29",
      },
      {
        price: 6000,
        startDate: "2019-04-28",
        endDate: "2019-05-13",
      },
      {
        price: 8000,
        startDate: "2019-05-12",
        endDate: "2019-05-27",
      },
      {
        price: 2800,
        startDate: "2022-02-27",
        endDate: "2022-03-28",
      },
      {
        price: 2475,
        startDate: "2022-01-30",
        endDate: "2022-02-28",
      },
      {
        price: 2425,
        startDate: "2022-01-02",
        endDate: "2022-01-31",
      },
      {
        price: 16000,
        startDate: "2019-07-27",
        endDate: "2019-08-26",
      },
      {
        price: 10000,
        startDate: "2019-09-01",
        endDate: "2019-09-16",
      },
      {
        price: 2100,
        startDate: "2019-10-06",
        endDate: "2020-01-05",
      },
      {
        price: 2100,
        startDate: "2020-01-05",
        endDate: "2020-03-30",
      },
      {
        price: 3000,
        startDate: "2020-03-29",
        endDate: "2020-04-27",
      },
      {
        price: 6000,
        startDate: "2020-04-26",
        endDate: "2020-05-11",
      },
      {
        price: 8000,
        startDate: "2020-05-10",
        endDate: "2020-05-25",
      },
      {
        price: 4200,
        startDate: "2021-05-23",
        endDate: "2021-05-31",
      },
      {
        price: 2625,
        startDate: "2021-10-03",
        endDate: "2021-11-01",
      },
      {
        price: 3325,
        startDate: "2021-05-09",
        endDate: "2021-05-24",
      },
      {
        price: 5000,
        startDate: "2019-09-29",
        endDate: "2019-10-07",
      },
    ],
    defaultImage: {
      dimensions: [1024, 681],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/65/barnes-1.jpg",
    },
    location: {
      lat: 41.44690659394038,
      lng: -70.57506757654902,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "95 Hammett Lane",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/95-hammett-lane",
    bookings: [
      {
        endDate: "2021-10-03",
        startDate: "2021-05-01",
      },
      {
        endDate: "2019-07-21",
        startDate: "2019-06-30",
      },
      {
        endDate: "2018-09-01",
        startDate: "2018-08-04",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-10",
      },
    ],
    rates: [
      {
        price: 5800,
        startDate: "2020-06-27",
        endDate: "2020-08-30",
      },
      {
        price: 5000,
        startDate: "2020-08-29",
        endDate: "2020-09-13",
      },
      {
        price: 4500,
        startDate: "2020-09-12",
        endDate: "2020-09-27",
      },
      {
        price: 5000,
        startDate: "2021-08-28",
        endDate: "2021-09-12",
      },
      {
        price: 4500,
        startDate: "2019-05-25",
        endDate: "2019-06-30",
      },
      {
        price: 5800,
        startDate: "2019-06-29",
        endDate: "2019-09-01",
      },
    ],

    location: {
      lat: 41.375244,
      lng: -70.719765,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "Turtle Pond Farm",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/turtle-pond-farm",
    bookings: [
      {
        endDate: "2022-06-01",
        startDate: "2022-05-27",
      },
      {
        endDate: "2021-04-20",
        startDate: "2021-04-16",
      },
      {
        endDate: "2021-06-01",
        startDate: "2021-05-27",
      },
      {
        endDate: "2021-07-12",
        startDate: "2021-06-27",
      },
      {
        endDate: "2021-11-29",
        startDate: "2021-11-24",
      },
      {
        endDate: "2022-07-11",
        startDate: "2022-06-22",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-07-17",
      },
      {
        endDate: "2021-05-24",
        startDate: "2021-05-19",
      },
      {
        endDate: "2021-09-14",
        startDate: "2021-09-07",
      },
      {
        endDate: "2021-06-17",
        startDate: "2021-06-10",
      },
      {
        endDate: "2020-09-28",
        startDate: "2020-09-12",
      },
      {
        endDate: "2021-09-08",
        startDate: "2021-08-29",
      },
      {
        endDate: "2021-12-19",
        startDate: "2021-12-14",
      },
      {
        endDate: "2019-09-26",
        startDate: "2019-09-18",
      },
      {
        endDate: "2019-07-14",
        startDate: "2019-06-26",
      },
      {
        endDate: "2021-10-11",
        startDate: "2021-09-26",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-09-19",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-07-18",
      },
      {
        endDate: "2018-08-19",
        startDate: "2018-08-05",
      },
      {
        endDate: "2018-09-02",
        startDate: "2018-08-26",
      },
      {
        endDate: "2019-07-29",
        startDate: "2019-07-14",
      },
      {
        endDate: "2019-08-19",
        startDate: "2019-08-04",
      },
    ],
    rates: [
      {
        price: 4200,
        startDate: "2021-10-31",
        endDate: "2021-12-20",
      },
      {
        price: 5250,
        startDate: "2022-09-18",
        endDate: "2022-11-21",
      },
      {
        price: 5250,
        startDate: "2022-11-27",
        endDate: "2022-12-19",
      },
      {
        price: 5950,
        startDate: "2022-12-18",
        endDate: "2022-12-26",
      },
      {
        price: 5250,
        startDate: "2021-09-05",
        endDate: "2021-11-01",
      },
      {
        price: 3200,
        startDate: "2019-03-31",
        endDate: "2019-05-26",
      },
      {
        price: 5250,
        startDate: "2019-09-08",
        endDate: "2019-11-03",
      },
      {
        price: 3200,
        startDate: "2018-12-30",
        endDate: "2019-03-31",
      },
      {
        price: 6500,
        startDate: "2022-09-04",
        endDate: "2022-09-19",
      },
      {
        price: 5250,
        startDate: "2021-12-19",
        endDate: "2021-12-27",
      },
      {
        price: 5950,
        startDate: "2022-11-20",
        endDate: "2022-11-28",
      },
      {
        price: 3200,
        startDate: "2020-12-27",
        endDate: "2021-04-26",
      },
      {
        price: 5000,
        startDate: "2018-09-09",
        endDate: "2018-09-16",
      },
      {
        price: 5000,
        startDate: "2018-09-16",
        endDate: "2018-09-23",
      },
      {
        price: 7500,
        startDate: "2018-07-29",
        endDate: "2018-08-05",
      },
      {
        price: 7500,
        startDate: "2018-08-05",
        endDate: "2018-08-12",
      },
      {
        price: 7500,
        startDate: "2018-08-12",
        endDate: "2018-08-19",
      },
      {
        price: 7500,
        startDate: "2018-08-19",
        endDate: "2018-08-26",
      },
      {
        price: 6500,
        startDate: "2018-08-26",
        endDate: "2018-09-02",
      },
      {
        price: 5000,
        startDate: "2018-09-02",
        endDate: "2018-09-09",
      },
      {
        price: 7000,
        startDate: "2019-06-30",
        endDate: "2019-07-29",
      },
      {
        price: 7500,
        startDate: "2019-07-28",
        endDate: "2019-08-26",
      },
      {
        price: 3200,
        startDate: "2019-05-26",
        endDate: "2019-06-02",
      },
      {
        price: 6000,
        startDate: "2019-08-25",
        endDate: "2019-09-08",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/104/DSC09260_edited-1.jpg",
    },
    location: {
      lat: 41.437414,
      lng: -70.652807,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "31 Mill Hill Road",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 9,
    type: "rental",
    path: "/rentals/31-mill-hill-road",
    bookings: [
      {
        endDate: "2019-10-06",
        startDate: "2019-06-30",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-08-10",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-06-20",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2022-06-19",
        endDate: "2022-09-05",
      },
      {
        price: 10000,
        startDate: "2019-07-28",
        endDate: "2019-09-08",
      },
      {
        price: 10000,
        startDate: "2021-06-20",
        endDate: "2021-08-30",
      },
      {
        price: 10000,
        startDate: "2020-06-28",
        endDate: "2020-09-06",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/109/millhill-1.jpg",
    },
    location: {
      lat: 41.380138,
      lng: -70.519471,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",
      state: "MA",
      text: "12 Swan Neck Road",
    },
    features: ["Waterfront"],
    beds: 5,
    sleeps: 11,
    type: "rental",
    path: "/rentals/12-swan-neck-road",
    bookings: [
      {
        endDate: "2021-07-20",
        startDate: "2021-06-06",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-02",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-01",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2022-07-24",
        endDate: "2022-09-05",
      },
      {
        price: 10000,
        startDate: "2021-06-06",
        endDate: "2021-09-06",
      },
      {
        price: 10000,
        startDate: "2022-06-05",
        endDate: "2022-06-27",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/18/swan-1.jpg",
    },
    location: {
      lat: 41.359546,
      lng: -70.563622,
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Town Lot Circle",
    },
    features: ["A/C", "Hot Tub"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/2-town-lot-circle",
    bookings: [
      {
        endDate: "2019-07-15",
        startDate: "2019-06-23",
      },
      {
        endDate: "2019-06-24",
        startDate: "2019-04-28",
      },
      {
        endDate: "2019-10-06",
        startDate: "2019-09-08",
      },
      {
        endDate: "2019-08-05",
        startDate: "2019-07-21",
      },
      {
        endDate: "2022-07-18",
        startDate: "2021-12-26",
      },
      {
        endDate: "2021-01-03",
        startDate: "2020-08-23",
      },
      {
        endDate: "2022-12-26",
        startDate: "2022-07-24",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2021-12-26",
        endDate: "2022-06-20",
      },
      {
        price: 13000,
        startDate: "2022-06-19",
        endDate: "2022-08-29",
      },
      {
        price: 9000,
        startDate: "2022-08-28",
        endDate: "2022-12-26",
      },
      {
        price: 6500,
        startDate: "2021-01-03",
        endDate: "2021-06-21",
      },
      {
        price: 11000,
        startDate: "2021-06-20",
        endDate: "2021-07-26",
      },
      {
        price: 12000,
        startDate: "2021-07-25",
        endDate: "2021-08-30",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/39/towncirlce-1.jpg",
    },
    location: {
      lat: 41.3539462,
      lng: -70.5031413,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "29 Pine Street",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 9,
    type: "rental",
    path: "/rentals/29-pine-street",
    bookings: [
      {
        endDate: "2019-10-15",
        startDate: "2019-10-11",
      },
      {
        endDate: "2019-06-17",
        startDate: "2019-06-13",
      },
      {
        endDate: "2019-10-01",
        startDate: "2019-09-27",
      },
      {
        endDate: "2019-10-07",
        startDate: "2019-10-04",
      },
      {
        endDate: "2020-06-08",
        startDate: "2020-06-04",
      },
      {
        endDate: "2022-09-12",
        startDate: "2022-08-28",
      },
      {
        endDate: "2022-05-31",
        startDate: "2022-05-18",
      },
      {
        endDate: "2022-06-06",
        startDate: "2022-06-02",
      },
      {
        endDate: "2022-10-12",
        startDate: "2022-10-06",
      },
      {
        endDate: "2019-09-28",
        startDate: "2019-09-25",
      },
      {
        endDate: "2019-06-02",
        startDate: "2019-05-25",
      },
      {
        endDate: "2020-05-18",
        startDate: "2020-05-15",
      },
      {
        endDate: "2020-05-26",
        startDate: "2020-05-22",
      },
      {
        endDate: "2020-06-15",
        startDate: "2020-06-12",
      },
      {
        endDate: "2020-06-05",
        startDate: "2020-05-31",
      },
      {
        endDate: "2020-06-22",
        startDate: "2020-06-18",
      },
      {
        endDate: "2021-06-07",
        startDate: "2021-06-04",
      },
      {
        endDate: "2022-06-13",
        startDate: "2022-06-09",
      },
      {
        endDate: "2021-11-19",
        startDate: "2021-10-13",
      },
      {
        endDate: "2021-10-04",
        startDate: "2021-09-05",
      },
      {
        endDate: "2019-06-24",
        startDate: "2019-06-16",
      },
      {
        endDate: "2019-09-16",
        startDate: "2019-09-12",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-07-12",
      },
      {
        endDate: "2022-07-18",
        startDate: "2022-06-19",
      },
      {
        endDate: "2019-09-09",
        startDate: "2019-08-31",
      },
      {
        endDate: "2019-07-14",
        startDate: "2019-07-06",
      },
      {
        endDate: "2019-07-21",
        startDate: "2019-07-13",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-07-20",
      },
      {
        endDate: "2019-07-01",
        startDate: "2019-06-23",
      },
      {
        endDate: "2021-08-09",
        startDate: "2021-07-25",
      },
      {
        endDate: "2021-07-19",
        startDate: "2021-07-11",
      },
      {
        endDate: "2021-07-05",
        startDate: "2021-06-27",
      },
      {
        endDate: "2021-06-01",
        startDate: "2021-05-28",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-08-14",
      },
      {
        endDate: "2021-05-24",
        startDate: "2021-05-20",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-07-24",
      },
      {
        endDate: "2022-07-25",
        startDate: "2022-07-17",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2019-04-28",
        endDate: "2019-06-02",
      },
      {
        price: 4500,
        startDate: "2019-06-02",
        endDate: "2019-06-16",
      },
      {
        price: 7000,
        startDate: "2019-07-13",
        endDate: "2019-08-04",
      },
      {
        price: 4000,
        startDate: "2020-12-27",
        endDate: "2021-06-07",
      },
      {
        price: 4000,
        startDate: "2019-12-29",
        endDate: "2020-05-18",
      },
      {
        price: 9500,
        startDate: "2022-07-03",
        endDate: "2022-09-05",
      },
      {
        price: 6300,
        startDate: "2021-10-31",
        endDate: "2021-11-29",
      },
      {
        price: 6300,
        startDate: "2022-09-25",
        endDate: "2022-11-28",
      },
      {
        price: 5900,
        startDate: "2021-11-28",
        endDate: "2021-12-27",
      },
      {
        price: 5500,
        startDate: "2019-06-16",
        endDate: "2019-06-23",
      },
      {
        price: 7000,
        startDate: "2019-06-23",
        endDate: "2019-06-30",
      },
      {
        price: 5500,
        startDate: "2019-08-31",
        endDate: "2019-09-08",
      },
      {
        price: 5500,
        startDate: "2019-09-07",
        endDate: "2019-09-15",
      },
      {
        price: 7500,
        startDate: "2019-08-17",
        endDate: "2019-08-25",
      },
      {
        price: 7500,
        startDate: "2019-08-24",
        endDate: "2019-09-01",
      },
      {
        price: 8000,
        startDate: "2019-08-03",
        endDate: "2019-08-18",
      },
      {
        price: 4500,
        startDate: "2019-09-14",
        endDate: "2019-10-06",
      },
      {
        price: 5250,
        startDate: "2020-05-17",
        endDate: "2020-05-25",
      },
      {
        price: 3850,
        startDate: "2020-05-24",
        endDate: "2020-06-01",
      },
      {
        price: 3850,
        startDate: "2020-05-31",
        endDate: "2020-06-08",
      },
      {
        price: 3850,
        startDate: "2020-06-07",
        endDate: "2020-06-15",
      },
      {
        price: 7150,
        startDate: "2021-07-18",
        endDate: "2021-08-02",
      },
      {
        price: 6000,
        startDate: "2020-06-14",
        endDate: "2020-06-22",
      },
      {
        price: 7000,
        startDate: "2020-07-05",
        endDate: "2020-07-13",
      },
      {
        price: 7000,
        startDate: "2020-07-12",
        endDate: "2020-07-20",
      },
      {
        price: 7000,
        startDate: "2020-07-19",
        endDate: "2020-07-27",
      },
      {
        price: 7000,
        startDate: "2020-07-26",
        endDate: "2020-08-03",
      },
      {
        price: 8000,
        startDate: "2020-08-02",
        endDate: "2020-08-10",
      },
      {
        price: 8000,
        startDate: "2020-08-09",
        endDate: "2020-08-17",
      },
      {
        price: 5750,
        startDate: "2019-07-06",
        endDate: "2019-07-14",
      },
      {
        price: 4000,
        startDate: "2020-10-04",
        endDate: "2020-12-28",
      },
      {
        price: 5250,
        startDate: "2022-01-02",
        endDate: "2022-05-02",
      },
      {
        price: 7100,
        startDate: "2021-07-11",
        endDate: "2021-07-19",
      },
      {
        price: 5950,
        startDate: "2021-12-26",
        endDate: "2022-01-03",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/107/pine-1.jpg",
    },
    location: {
      lat: 41.39293,
      lng: -70.519214,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "93 South Water Street",
    },
    features: ["A/C", "Pool", "Waterfront"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/93-south-water-street",
    bookings: [
      {
        endDate: "2020-09-14",
        startDate: "2020-08-30",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-07-19",
      },
      {
        endDate: "2021-08-16",
        startDate: "2021-07-25",
      },
      {
        endDate: "2021-07-26",
        startDate: "2021-06-27",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-15",
      },
      {
        endDate: "2019-08-20",
        startDate: "2019-07-06",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-07-05",
      },
    ],
    rates: [
      {
        price: 32500,
        startDate: "2022-07-02",
        endDate: "2022-09-11",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/102/93sw-1.jpg",
    },
    location: {
      lat: 41.386314,
      lng: -70.514908,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",
      state: "MA",
      text: "1 North Neck Road",
    },
    features: ["A/C"],
    beds: 6,
    sleeps: 14,
    type: "rental",
    path: "/rentals/1-north-neck-road",
    bookings: [
      {
        endDate: "2019-08-11",
        startDate: "2019-07-27",
      },
      {
        endDate: "2020-08-22",
        startDate: "2020-08-17",
      },
      {
        endDate: "2018-08-20",
        startDate: "2018-07-28",
      },
      {
        endDate: "2018-09-14",
        startDate: "2018-09-09",
      },
      {
        endDate: "2021-06-07",
        startDate: "2021-05-27",
      },
      {
        endDate: "2021-07-12",
        startDate: "2021-06-25",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2020-06-13",
        endDate: "2020-09-06",
      },
      {
        price: 25000,
        startDate: "2019-06-08",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/6/northnecknew-1.jpg",
    },
    location: {
      lat: 41.40064,
      lng: -70.46465,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Orchard Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/2-orchard-lane",
    bookings: [
      {
        endDate: "2021-07-04",
        startDate: "2021-06-19",
      },
      {
        endDate: "2020-07-08",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-08-16",
        startDate: "2020-07-07",
      },
      {
        endDate: "2020-09-13",
        startDate: "2020-08-29",
      },
      {
        endDate: "2019-08-11",
        startDate: "2019-08-03",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-08-17",
      },
      {
        endDate: "2021-08-08",
        startDate: "2021-07-03",
      },
    ],
    rates: [
      {
        price: 7500,
        startDate: "2022-06-18",
        endDate: "2022-09-11",
      },
      {
        price: 6500,
        startDate: "2022-05-07",
        endDate: "2022-06-19",
      },
      {
        price: 6500,
        startDate: "2021-05-29",
        endDate: "2021-07-04",
      },
      {
        price: 7000,
        startDate: "2018-05-27",
        endDate: "2018-07-29",
      },
      {
        price: 7000,
        startDate: "2018-07-29",
        endDate: "2018-09-02",
      },
      {
        price: 6500,
        startDate: "2018-09-02",
        endDate: "2018-10-07",
      },
      {
        price: 5500,
        startDate: "2022-01-01",
        endDate: "2022-05-08",
      },
      {
        price: 6500,
        startDate: "2022-09-10",
        endDate: "2022-10-30",
      },
      {
        price: 5000,
        startDate: "2020-01-04",
        endDate: "2020-06-28",
      },
      {
        price: 7000,
        startDate: "2020-08-01",
        endDate: "2020-08-16",
      },
      {
        price: 5500,
        startDate: "2020-08-22",
        endDate: "2020-09-06",
      },
      {
        price: 6500,
        startDate: "2021-07-03",
        endDate: "2021-08-01",
      },
      {
        price: 7000,
        startDate: "2019-08-03",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1024, 678],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/110/orchard-1.jpg",
    },
    location: {
      lat: 41.396356,
      lng: -70.52165,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "24 Temahigan Avenue",
    },
    features: ["A/C", "Dock", "Hot Tub", "Pool", "Waterfront"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/24-temahigan-avenue",
    bookings: [
      {
        endDate: "2021-08-01",
        startDate: "2021-06-19",
      },
      {
        endDate: "2019-06-29",
        startDate: "2019-06-22",
      },
      {
        endDate: "2020-09-20",
        startDate: "2020-09-11",
      },
      {
        endDate: "2018-09-01",
        startDate: "2018-07-29",
      },
      {
        endDate: "2020-06-28",
        startDate: "2020-06-20",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2019-05-26",
        endDate: "2019-07-07",
      },
      {
        price: 12000,
        startDate: "2019-07-07",
        endDate: "2019-09-01",
      },
      {
        price: 10000,
        startDate: "2020-09-13",
        endDate: "2020-10-05",
      },
      {
        price: 12000,
        startDate: "2020-05-30",
        endDate: "2020-09-07",
      },
      {
        price: 12000,
        startDate: "2021-05-29",
        endDate: "2021-09-12",
      },
      {
        price: 14500,
        startDate: "2022-05-28",
        endDate: "2022-09-11",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/49/clancyt-12.jpg",
    },
    location: {
      lat: 41.464368,
      lng: -70.5770651,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "5 Whistling Swan Circle",
    },
    features: ["A/C", "Pool"],
    beds: 5,
    sleeps: 14,
    type: "rental",
    path: "/rentals/5-whistling-swan-circle",
    bookings: [
      {
        endDate: "2019-07-29",
        startDate: "2019-07-20",
      },
      {
        endDate: "2020-10-04",
        startDate: "2020-09-03",
      },
      {
        endDate: "2020-09-04",
        startDate: "2020-08-30",
      },
      {
        endDate: "2021-07-04",
        startDate: "2021-05-02",
      },
      {
        endDate: "2019-07-20",
        startDate: "2019-07-07",
      },
      {
        endDate: "2022-06-13",
        startDate: "2022-06-05",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-07-17",
      },
      {
        endDate: "2020-08-03",
        startDate: "2020-07-19",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-08-28",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2020-05-03",
        endDate: "2020-06-15",
      },
      {
        price: 13000,
        startDate: "2020-07-26",
        endDate: "2020-08-10",
      },
      {
        price: 13000,
        startDate: "2021-08-01",
        endDate: "2021-08-09",
      },
      {
        price: 6500,
        startDate: "2021-05-02",
        endDate: "2021-06-14",
      },
      {
        price: 11000,
        startDate: "2019-07-01",
        endDate: "2019-07-07",
      },
      {
        price: 9000,
        startDate: "2020-08-30",
        endDate: "2020-09-14",
      },
      {
        price: 13000,
        startDate: "2019-08-04",
        endDate: "2019-08-11",
      },
      {
        price: 14000,
        startDate: "2019-08-11",
        endDate: "2019-08-18",
      },
      {
        price: 12000,
        startDate: "2019-07-21",
        endDate: "2019-07-28",
      },
      {
        price: 10000,
        startDate: "2022-09-18",
        endDate: "2022-10-31",
      },
      {
        price: 8000,
        startDate: "2022-10-30",
        endDate: "2022-12-26",
      },
    ],
    defaultImage: {
      dimensions: [1023, 682],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/73/5 Whistling Swan Circle-web-15.jpg",
    },
    location: {
      lat: 41.379939,
      lng: -70.540726,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "10 Katama Farm South",
    },
    features: ["A/C", "Pool"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/10-katama-farm-south",
    bookings: [
      {
        endDate: "2020-09-02",
        startDate: "2020-08-09",
      },
      {
        endDate: "2020-08-10",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-10-09",
        startDate: "2020-10-01",
      },
      {
        endDate: "2021-07-11",
        startDate: "2021-06-19",
      },
      {
        endDate: "2019-08-03",
        startDate: "2019-06-09",
      },
      {
        endDate: "2019-05-24",
        startDate: "2019-05-16",
      },
      {
        endDate: "2019-09-04",
        startDate: "2019-08-03",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-07-24",
      },
      {
        endDate: "2021-09-08",
        startDate: "2021-09-06",
      },
      {
        endDate: "2022-09-07",
        startDate: "2022-08-30",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-09-06",
      },
      {
        endDate: "2022-08-31",
        startDate: "2022-07-23",
      },
    ],
    rates: [
      {
        price: 7500,
        startDate: "2019-08-31",
        endDate: "2019-12-29",
      },
      {
        price: 5900,
        startDate: "2019-05-12",
        endDate: "2019-06-17",
      },
      {
        price: 13800,
        startDate: "2019-06-30",
        endDate: "2019-07-22",
      },
      {
        price: 16900,
        startDate: "2019-07-21",
        endDate: "2019-08-26",
      },
      {
        price: 17600,
        startDate: "2021-07-24",
        endDate: "2021-08-22",
      },
      {
        price: 2900,
        startDate: "2019-12-27",
        endDate: "2020-01-05",
      },
      {
        price: 18700,
        startDate: "2022-08-20",
        endDate: "2022-08-31",
      },
      {
        price: 7500,
        startDate: "2022-09-06",
        endDate: "2022-09-11",
      },
      {
        price: 18700,
        startDate: "2022-08-30",
        endDate: "2022-09-07",
      },
      {
        price: 18700,
        startDate: "2022-07-23",
        endDate: "2022-08-21",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/7/klas-0060.jpg",
    },
    location: {
      lat: 41.35431,
      lng: -70.51525,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "36 Hamblen Way",
    },
    features: ["A/C", "Pool"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/36-hamblen-way",
    bookings: [
      {
        endDate: "2020-10-04",
        startDate: "2020-08-22",
      },
      {
        endDate: "2018-08-05",
        startDate: "2018-07-29",
      },
      {
        endDate: "2018-08-27",
        startDate: "2018-08-06",
      },
      {
        endDate: "2021-08-08",
        startDate: "2021-06-26",
      },
      {
        endDate: "2018-12-02",
        startDate: "2018-11-25",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-13",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-07-25",
      },
      {
        endDate: "2022-08-14",
        startDate: "2022-07-30",
      },
    ],
    rates: [
      {
        price: 5495,
        startDate: "2021-07-10",
        endDate: "2021-07-25",
      },
      {
        price: 7700,
        startDate: "2019-08-17",
        endDate: "2019-09-01",
      },
      {
        price: 7700,
        startDate: "2020-07-25",
        endDate: "2020-08-16",
      },
      {
        price: 5495,
        startDate: "2019-07-13",
        endDate: "2019-07-28",
      },
      {
        price: 7700,
        startDate: "2019-07-28",
        endDate: "2019-08-03",
      },
      {
        price: 7700,
        startDate: "2019-06-30",
        endDate: "2019-07-13",
      },
      {
        price: 3360,
        startDate: "2018-11-17",
        endDate: "2018-11-25",
      },
      {
        price: 2520,
        startDate: "2018-11-24",
        endDate: "2018-12-23",
      },
      {
        price: 3360,
        startDate: "2018-12-22",
        endDate: "2018-12-30",
      },
      {
        price: 2520,
        startDate: "2018-12-29",
        endDate: "2019-01-06",
      },
      {
        price: 2520,
        startDate: "2019-01-05",
        endDate: "2019-05-25",
      },
      {
        price: 3360,
        startDate: "2019-05-24",
        endDate: "2019-06-01",
      },
      {
        price: 2520,
        startDate: "2019-06-01",
        endDate: "2019-06-15",
      },
      {
        price: 4000,
        startDate: "2019-09-07",
        endDate: "2020-01-05",
      },
      {
        price: 4000,
        startDate: "2020-01-04",
        endDate: "2020-06-21",
      },
      {
        price: 7700,
        startDate: "2019-08-03",
        endDate: "2019-08-11",
      },
      {
        price: 8400,
        startDate: "2019-08-10",
        endDate: "2019-08-18",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/61/36-hamblen-3.jpg",
    },
    location: {
      lat: 41.394912,
      lng: -70.539767,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "69 Cobbs Hill Road",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/69-cobbs-hill-road",
    bookings: [
      {
        endDate: "2019-08-13",
        startDate: "2019-07-29",
      },
      {
        endDate: "2019-07-22",
        startDate: "2019-07-19",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-06-21",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2019-09-21",
        endDate: "2019-09-29",
      },
      {
        price: 6000,
        startDate: "2019-09-28",
        endDate: "2019-10-27",
      },
      {
        price: 15000,
        startDate: "2020-06-21",
        endDate: "2020-08-31",
      },
      {
        price: 10000,
        startDate: "2019-09-07",
        endDate: "2019-09-22",
      },
      {
        price: 8000,
        startDate: "2020-09-13",
        endDate: "2020-09-21",
      },
      {
        price: 6000,
        startDate: "2020-09-20",
        endDate: "2020-09-28",
      },
      {
        price: 6000,
        startDate: "2020-09-27",
        endDate: "2020-10-05",
      },
    ],
    defaultImage: {
      dimensions: [1600, 847],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/105/cobbshill-13.jpg",
    },
    location: {
      lat: 41.36923,
      lng: -70.673167,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "16 Plover Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/16-plover-lane",
    bookings: [
      {
        endDate: "2021-09-07",
        startDate: "2021-08-14",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-06-18",
      },
      {
        endDate: "2020-09-13",
        startDate: "2020-08-22",
      },
      {
        endDate: "2022-07-17",
        startDate: "2022-06-18",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-08-13",
      },
    ],
    rates: [
      {
        price: 7750,
        startDate: "2020-06-20",
        endDate: "2020-07-05",
      },
      {
        price: 8250,
        startDate: "2020-07-04",
        endDate: "2020-07-26",
      },
      {
        price: 7000,
        startDate: "2020-08-29",
        endDate: "2020-10-25",
      },
      {
        price: 7000,
        startDate: "2019-09-01",
        endDate: "2019-10-26",
      },
      {
        price: 6500,
        startDate: "2019-10-27",
        endDate: "2019-12-29",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/28/16 Plover-1.jpg",
    },
    location: {
      lat: 41.355345,
      lng: -70.502814,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "11 Loon Cove Way",
    },
    features: [],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/11-loon-cove-way",
    bookings: [
      {
        endDate: "2022-08-15",
        startDate: "2022-07-17",
      },
      {
        endDate: "2019-07-29",
        startDate: "2019-07-22",
      },
      {
        endDate: "2019-09-30",
        startDate: "2019-09-22",
      },
      {
        endDate: "2022-06-20",
        startDate: "2022-05-29",
      },
      {
        endDate: "2021-07-19",
        startDate: "2021-07-04",
      },
      {
        endDate: "2018-09-09",
        startDate: "2018-09-02",
      },
    ],
    rates: [
      {
        price: 3000,
        startDate: "2022-01-01",
        endDate: "2022-06-20",
      },
      {
        price: 4700,
        startDate: "2022-06-19",
        endDate: "2022-07-04",
      },
      {
        price: 5800,
        startDate: "2022-08-07",
        endDate: "2022-08-22",
      },
      {
        price: 2200,
        startDate: "2022-09-11",
        endDate: "2023-01-01",
      },
      {
        price: 4600,
        startDate: "2019-07-21",
        endDate: "2019-08-05",
      },
      {
        price: 4900,
        startDate: "2019-08-04",
        endDate: "2019-08-26",
      },
      {
        price: 2700,
        startDate: "2019-12-29",
        endDate: "2020-06-22",
      },
    ],
    defaultImage: {
      dimensions: [1493, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/13/pizzano-16.jpg",
    },
    location: {
      lat: 41.36422,
      lng: -70.53885,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Vineyard Haven",

      text: "13 Reynolds Lane",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/13-reynolds-lane",
    bookings: [
      {
        endDate: "2022-02-22",
        startDate: "2022-02-19",
      },
      {
        endDate: "2022-06-06",
        startDate: "2022-06-03",
      },
      {
        endDate: "2022-06-13",
        startDate: "2022-06-07",
      },
      {
        endDate: "2021-10-24",
        startDate: "2021-10-02",
      },
      {
        endDate: "2021-11-28",
        startDate: "2021-11-24",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-12-27",
      },
      {
        endDate: "2022-05-01",
        startDate: "2022-04-23",
      },
      {
        endDate: "2022-05-31",
        startDate: "2022-05-27",
      },
      {
        endDate: "2022-06-20",
        startDate: "2022-06-17",
      },
      {
        endDate: "2022-09-18",
        startDate: "2022-07-02",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-07-05",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-08-16",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-08-11",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-07-11",
      },
      {
        endDate: "2021-09-20",
        startDate: "2021-09-17",
      },
      {
        endDate: "2019-07-22",
        startDate: "2019-07-07",
      },
      {
        endDate: "2019-05-21",
        startDate: "2019-05-16",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-07-12",
      },
      {
        endDate: "2019-05-28",
        startDate: "2019-05-24",
      },
      {
        endDate: "2019-08-05",
        startDate: "2019-07-28",
      },
      {
        endDate: "2019-08-12",
        startDate: "2019-08-04",
      },
    ],
    rates: [
      {
        price: 2000,
        startDate: "2019-02-03",
        endDate: "2019-05-05",
      },
      {
        price: 2500,
        startDate: "2019-05-05",
        endDate: "2019-06-02",
      },
      {
        price: 2000,
        startDate: "2019-10-06",
        endDate: "2019-12-29",
      },
      {
        price: 2750,
        startDate: "2021-09-26",
        endDate: "2022-01-02",
      },
      {
        price: 3750,
        startDate: "2022-06-04",
        endDate: "2022-07-03",
      },
      {
        price: 2750,
        startDate: "2020-05-03",
        endDate: "2020-06-01",
      },
      {
        price: 3750,
        startDate: "2021-07-18",
        endDate: "2021-07-26",
      },
      {
        price: 3500,
        startDate: "2019-07-28",
        endDate: "2019-08-04",
      },
      {
        price: 4000,
        startDate: "2019-08-18",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1066],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/106/13-reynolds-web-8.jpg",
    },
    location: {
      lat: 41.452176,
      lng: -70.606353,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "15 Cummings Way",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/15-cummings-way",
    bookings: [
      {
        endDate: "2022-07-11",
        startDate: "2022-06-26",
      },
      {
        endDate: "2022-06-27",
        startDate: "2022-05-22",
      },
      {
        endDate: "2021-06-21",
        startDate: "2021-06-06",
      },
      {
        endDate: "2018-08-31",
        startDate: "2018-08-03",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-07-10",
      },
      {
        endDate: "2022-12-26",
        startDate: "2022-12-04",
      },
    ],
    rates: [
      {
        price: 7500,
        startDate: "2020-07-05",
        endDate: "2020-07-20",
      },
      {
        price: 8800,
        startDate: "2021-07-25",
        endDate: "2021-08-23",
      },
      {
        price: 4000,
        startDate: "2019-10-06",
        endDate: "2019-11-04",
      },
      {
        price: 4000,
        startDate: "2020-10-04",
        endDate: "2020-11-02",
      },
      {
        price: 8500,
        startDate: "2019-07-28",
        endDate: "2019-08-19",
      },
      {
        price: 8250,
        startDate: "2022-07-10",
        endDate: "2022-07-25",
      },
      {
        price: 4000,
        startDate: "2022-09-25",
        endDate: "2022-12-05",
      },
      {
        price: 4000,
        startDate: "2022-12-04",
        endDate: "2022-12-26",
      },
      {
        price: 7500,
        startDate: "2019-07-07",
        endDate: "2019-07-22",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1066],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/23/15-cummings-web-5.jpg",
    },
    location: {
      lat: 41.384295,
      lng: -70.516992,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "16 Knoll Drive",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/16-knoll-drive",
    bookings: [
      {
        endDate: "2019-08-07",
        startDate: "2019-07-29",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-07-16",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-06-26",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-06-28",
      },
      {
        endDate: "2018-08-11",
        startDate: "2018-07-29",
      },
      {
        endDate: "2021-06-27",
        startDate: "2021-06-15",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-08-08",
      },
    ],
    rates: [
      {
        price: 9000,
        startDate: "2019-07-16",
        endDate: "2019-08-11",
      },
      {
        price: 8500,
        startDate: "2022-06-11",
        endDate: "2022-07-03",
      },
      {
        price: 9000,
        startDate: "2021-06-26",
        endDate: "2021-09-12",
      },
      {
        price: 6000,
        startDate: "2021-09-11",
        endDate: "2021-11-07",
      },
      {
        price: 5000,
        startDate: "2021-11-06",
        endDate: "2021-12-05",
      },
      {
        price: 5000,
        startDate: "2021-12-04",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/25/knoll-1.jpg",
    },
    location: {
      lat: 41.372905,
      lng: -70.516512,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "16 Major's Cove Lane",
    },
    features: ["A/C", "Dock"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/16-major's-cove-lane",
    bookings: [
      {
        endDate: "2021-08-02",
        startDate: "2020-12-27",
      },
      {
        endDate: "2021-12-27",
        startDate: "2021-09-05",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-06-25",
      },
      {
        endDate: "2022-10-03",
        startDate: "2022-08-14",
      },
    ],
    rates: [
      {
        price: 3600,
        startDate: "2020-06-20",
        endDate: "2020-08-30",
      },
      {
        price: 2500,
        startDate: "2021-05-22",
        endDate: "2021-06-20",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/26/mccone-25.jpg",
    },
    location: {
      lat: 41.412033,
      lng: -70.574141,
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "17 Round Pond Road",
    },
    features: ["A/C", "Hot Tub"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/17-round-pond-road",
    bookings: [
      {
        endDate: "2019-08-13",
        startDate: "2019-07-27",
      },
      {
        endDate: "2022-08-13",
        startDate: "2022-07-01",
      },
      {
        endDate: "2022-09-12",
        startDate: "2022-08-27",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-12",
      },
      {
        endDate: "2019-08-20",
        startDate: "2019-08-12",
      },
      {
        endDate: "2020-07-28",
        startDate: "2020-07-10",
      },
      {
        endDate: "2020-08-14",
        startDate: "2020-07-30",
      },
      {
        endDate: "2020-06-11",
        startDate: "2020-04-10",
      },
      {
        endDate: "2021-08-13",
        startDate: "2021-07-01",
      },
      {
        endDate: "2021-08-28",
        startDate: "2021-08-12",
      },
    ],
    rates: [
      {
        price: 29500,
        startDate: "2022-07-30",
        endDate: "2022-09-11",
      },
      {
        price: 15000,
        startDate: "2020-05-28",
        endDate: "2020-06-28",
      },
      {
        price: 24000,
        startDate: "2020-06-27",
        endDate: "2020-08-03",
      },
      {
        price: 15000,
        startDate: "2020-12-27",
        endDate: "2021-05-30",
      },
    ],
    defaultImage: {
      dimensions: [1422, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/31/hornblower-r-1.jpg",
    },
    location: {
      lat: 41.311395,
      lng: -70.77495,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "20 Pinkletink Road",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/20-pinkletink-road",
    bookings: [
      {
        endDate: "2021-12-27",
        startDate: "2021-10-03",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-05-29",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-07-04",
      },
      {
        endDate: "2022-05-30",
        startDate: "2021-12-26",
      },
      {
        endDate: "2019-07-11",
        startDate: "2019-07-03",
      },
      {
        endDate: "2019-07-19",
        startDate: "2019-07-12",
      },
      {
        endDate: "2021-07-12",
        startDate: "2021-05-30",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-10-02",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-07-31",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-24",
      },
      {
        endDate: "2019-08-26",
        startDate: "2019-08-18",
      },
    ],
    rates: [
      {
        price: 13260,
        startDate: "2022-05-29",
        endDate: "2022-08-01",
      },
      {
        price: 13200,
        startDate: "2021-08-01",
        endDate: "2021-09-21",
      },
      {
        price: 12750,
        startDate: "2021-09-20",
        endDate: "2021-10-03",
      },
      {
        price: 13728,
        startDate: "2022-07-31",
        endDate: "2022-10-03",
      },
      {
        price: 10000,
        startDate: "2019-06-29",
        endDate: "2019-08-04",
      },
      {
        price: 12750,
        startDate: "2021-05-30",
        endDate: "2021-08-02",
      },
      {
        price: 12000,
        startDate: "2018-07-01",
        endDate: "2018-09-02",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/108/seferian-1.jpg",
    },
    location: {
      lat: 41.356873,
      lng: -70.756722,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "22 High Mark Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/22-high-mark-road",
    bookings: [
      {
        endDate: "2018-08-26",
        startDate: "2018-07-27",
      },
      {
        endDate: "2021-07-04",
        startDate: "2021-06-25",
      },
      {
        endDate: "2020-09-27",
        startDate: "2020-08-29",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-07-18",
      },
    ],
    rates: [
      {
        price: 4100,
        startDate: "2020-06-27",
        endDate: "2020-10-04",
      },
      {
        price: 2500,
        startDate: "2018-10-05",
        endDate: "2018-10-12",
      },
      {
        price: 2500,
        startDate: "2018-10-12",
        endDate: "2018-10-19",
      },
      {
        price: 2500,
        startDate: "2018-10-19",
        endDate: "2018-10-26",
      },
      {
        price: 2500,
        startDate: "2018-10-26",
        endDate: "2018-11-02",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/43/gilday-3.jpg",
    },
    location: {
      lat: 41.350804,
      lng: -70.73668,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "22 Schoolhouse Road",
    },
    features: [],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/22-schoolhouse-road",
    bookings: [
      {
        endDate: "2023-01-01",
        startDate: "2022-09-04",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-08-14",
      },
      {
        endDate: "2021-03-01",
        startDate: "2021-02-12",
      },
      {
        endDate: "2021-05-03",
        startDate: "2021-04-16",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-06-10",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-08-26",
      },
      {
        endDate: "2022-08-27",
        startDate: "2022-01-01",
      },
      {
        endDate: "2019-09-09",
        startDate: "2019-09-06",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-06-27",
      },
    ],
    rates: [
      {
        price: 3900,
        startDate: "2022-08-26",
        endDate: "2022-09-04",
      },
      {
        price: 2500,
        startDate: "2021-04-03",
        endDate: "2021-06-06",
      },
      {
        price: 2000,
        startDate: "2021-01-02",
        endDate: "2021-04-04",
      },
      {
        price: 3100,
        startDate: "2019-06-23",
        endDate: "2019-07-07",
      },
      {
        price: 3100,
        startDate: "2019-07-14",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/44/schoolhouse-1.jpg",
    },
    location: {
      lat: 41.373125,
      lng: -70.524776,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "3 Mill Hill Farms Road",
    },
    features: ["A/C"],
    beds: 6,
    sleeps: 10,
    type: "rental",
    path: "/rentals/3-mill-hill-farms-road",
    bookings: [
      {
        endDate: "2019-08-13",
        startDate: "2019-07-26",
      },
      {
        endDate: "2022-07-07",
        startDate: "2022-06-28",
      },
      {
        endDate: "2018-08-15",
        startDate: "2018-08-12",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-07-19",
      },
    ],
    rates: [
      {
        price: 11770,
        startDate: "2020-06-21",
        endDate: "2020-09-07",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/55/millhillfarms-1.jpg",
    },
    location: {
      lat: 41.3751339,
      lng: -70.5193945,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "36 Knoll Drive",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/36-knoll-drive",
    bookings: [
      {
        endDate: "2019-09-23",
        startDate: "2019-09-19",
      },
      {
        endDate: "2019-10-01",
        startDate: "2019-09-26",
      },
      {
        endDate: "2019-08-03",
        startDate: "2019-07-28",
      },
      {
        endDate: "2019-09-18",
        startDate: "2019-09-13",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-07-03",
      },
      {
        endDate: "2020-08-15",
        startDate: "2020-08-01",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-07-14",
      },
      {
        endDate: "2021-10-03",
        startDate: "2021-09-11",
      },
      {
        endDate: "2020-09-09",
        startDate: "2020-09-03",
      },
      {
        endDate: "2020-09-04",
        startDate: "2020-08-15",
      },
      {
        endDate: "2019-06-30",
        startDate: "2019-06-22",
      },
      {
        endDate: "2019-07-14",
        startDate: "2019-06-30",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-07-31",
      },
      {
        endDate: "2018-08-26",
        startDate: "2018-07-28",
      },
    ],
    rates: [
      {
        price: 2600,
        startDate: "2019-09-29",
        endDate: "2019-11-10",
      },
      {
        price: 2600,
        startDate: "2020-03-14",
        endDate: "2020-05-10",
      },
      {
        price: 4500,
        startDate: "2020-05-09",
        endDate: "2020-06-28",
      },
      {
        price: 2600,
        startDate: "2019-11-09",
        endDate: "2020-01-05",
      },
      {
        price: 2600,
        startDate: "2020-01-04",
        endDate: "2020-03-15",
      },
      {
        price: 2600,
        startDate: "2019-03-15",
        endDate: "2019-05-12",
      },
      {
        price: 4500,
        startDate: "2019-05-12",
        endDate: "2019-06-30",
      },
      {
        price: 3400,
        startDate: "2020-09-12",
        endDate: "2020-10-04",
      },
      {
        price: 7900,
        startDate: "2019-07-28",
        endDate: "2019-08-11",
      },
      {
        price: 4500,
        startDate: "2021-05-01",
        endDate: "2021-06-06",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/62/hoffman36-4.jpg",
    },
    location: {
      lat: 41.372068,
      lng: -70.51937,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "50 Edgartown Bay Road",
    },
    features: ["A/C", "Pool"],
    beds: 3,
    sleeps: 12,
    type: "rental",
    path: "/rentals/50-edgartown-bay-road",
    bookings: [
      {
        endDate: "2022-05-02",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-05-07",
        startDate: "2022-05-01",
      },
      {
        endDate: "2022-08-27",
        startDate: "2022-08-05",
      },
      {
        endDate: "2021-08-16",
        startDate: "2021-07-18",
      },
      {
        endDate: "2021-06-28",
        startDate: "2020-12-27",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-09-05",
      },
      {
        endDate: "2022-08-06",
        startDate: "2022-07-11",
      },
      {
        endDate: "2022-07-02",
        startDate: "2022-05-05",
      },
      {
        endDate: "2018-09-05",
        startDate: "2018-08-26",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-06-28",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-15",
      },
      {
        endDate: "2018-08-19",
        startDate: "2018-07-29",
      },
      {
        endDate: "2019-07-15",
        startDate: "2019-07-07",
      },
      {
        endDate: "2019-07-22",
        startDate: "2019-07-14",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2022-01-01",
        endDate: "2022-06-04",
      },
      {
        price: 15000,
        startDate: "2022-06-03",
        endDate: "2022-07-02",
      },
      {
        price: 35000,
        startDate: "2022-07-01",
        endDate: "2022-07-11",
      },
      {
        price: 25000,
        startDate: "2022-07-10",
        endDate: "2022-08-06",
      },
      {
        price: 15000,
        startDate: "2022-09-02",
        endDate: "2022-12-31",
      },
      {
        price: 9000,
        startDate: "2020-08-30",
        endDate: "2020-09-21",
      },
      {
        price: 7000,
        startDate: "2020-09-20",
        endDate: "2020-11-02",
      },
      {
        price: 9000,
        startDate: "2019-09-01",
        endDate: "2019-09-30",
      },
      {
        price: 11000,
        startDate: "2019-06-02",
        endDate: "2019-07-01",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/74/edgartownbay-1.jpg",
    },
    location: {
      lat: 41.35555,
      lng: -70.502151,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Vineyard Haven",

      text: "63 Harbor View Lane",
    },
    features: ["A/C", "Waterfront"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/63-harbor-view-lane",
    bookings: [],
    rates: [],
    defaultImage: {
      dimensions: [1023, 767],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/112/Smith-22.jpg",
    },
    location: {
      lat: 41.469639,
      lng: -70.596479,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "55 Slough Cove Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/55-slough-cove-road",
    bookings: [
      {
        endDate: "2021-09-26",
        startDate: "2021-09-11",
      },
      {
        endDate: "2022-12-04",
        startDate: "2022-07-02",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-12-03",
      },
      {
        endDate: "2020-07-30",
        startDate: "2020-07-11",
      },
      {
        endDate: "2018-09-24",
        startDate: "2018-09-13",
      },
      {
        endDate: "2019-08-02",
        startDate: "2019-07-18",
      },
      {
        endDate: "2021-09-12",
        startDate: "2021-08-21",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-07-10",
      },
      {
        endDate: "2021-10-03",
        startDate: "2021-09-25",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-07-29",
      },
      {
        endDate: "2019-07-07",
        startDate: "2019-06-21",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-08-03",
      },
      {
        endDate: "2021-06-20",
        startDate: "2021-06-05",
      },
      {
        endDate: "2020-06-28",
        startDate: "2020-06-13",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-08-08",
      },
    ],
    rates: [
      {
        price: 2000,
        startDate: "2022-05-07",
        endDate: "2022-06-12",
      },
      {
        price: 5000,
        startDate: "2022-07-09",
        endDate: "2022-08-21",
      },
      {
        price: 1800,
        startDate: "2018-12-30",
        endDate: "2019-05-12",
      },
      {
        price: 2000,
        startDate: "2019-05-12",
        endDate: "2019-06-16",
      },
      {
        price: 2200,
        startDate: "2019-06-16",
        endDate: "2019-06-30",
      },
      {
        price: 4100,
        startDate: "2019-06-30",
        endDate: "2019-07-14",
      },
      {
        price: 5000,
        startDate: "2019-07-14",
        endDate: "2019-08-18",
      },
      {
        price: 2750,
        startDate: "2019-09-01",
        endDate: "2019-09-15",
      },
      {
        price: 1900,
        startDate: "2019-09-15",
        endDate: "2019-12-29",
      },
      {
        price: 2000,
        startDate: "2021-05-08",
        endDate: "2021-06-06",
      },
      {
        price: 5000,
        startDate: "2021-07-10",
        endDate: "2021-08-22",
      },
      {
        price: 1900,
        startDate: "2019-12-28",
        endDate: "2020-01-05",
      },
      {
        price: 1900,
        startDate: "2020-01-04",
        endDate: "2020-05-10",
      },
      {
        price: 2000,
        startDate: "2020-05-09",
        endDate: "2020-06-14",
      },
      {
        price: 4100,
        startDate: "2022-06-25",
        endDate: "2022-07-10",
      },
      {
        price: 4100,
        startDate: "2020-06-27",
        endDate: "2020-07-19",
      },
      {
        price: 5000,
        startDate: "2020-07-18",
        endDate: "2020-08-23",
      },
      {
        price: 1900,
        startDate: "2020-09-12",
        endDate: "2021-01-03",
      },
      {
        price: 1900,
        startDate: "2021-01-02",
        endDate: "2021-05-09",
      },
      {
        price: 2000,
        startDate: "2021-06-05",
        endDate: "2021-06-13",
      },
      {
        price: 2200,
        startDate: "2020-06-13",
        endDate: "2020-06-28",
      },
    ],
    defaultImage: {
      dimensions: [1422, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/78/mcculloch-1.jpg",
    },
    location: {
      lat: 41.361909,
      lng: -70.533917,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "51 Squibnocket Farm Rd",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/51-squibnocket-farm-rd",
    bookings: [
      {
        endDate: "2021-08-21",
        startDate: "2021-08-08",
      },
      {
        endDate: "2021-08-09",
        startDate: "2021-06-27",
      },
      {
        endDate: "2022-09-03",
        startDate: "2022-07-01",
      },
      {
        endDate: "2018-09-01",
        startDate: "2018-08-18",
      },
      {
        endDate: "2020-08-26",
        startDate: "2020-08-18",
      },
    ],
    rates: [
      {
        price: 22000,
        startDate: "2022-07-01",
        endDate: "2022-09-03",
      },
      {
        price: 15000,
        startDate: "2019-08-31",
        endDate: "2019-09-15",
      },
      {
        price: 10000,
        startDate: "2019-09-14",
        endDate: "2019-09-29",
      },
      {
        price: 22000,
        startDate: "2020-07-25",
        endDate: "2020-08-30",
      },
      {
        price: 10000,
        startDate: "2020-05-30",
        endDate: "2020-06-14",
      },
      {
        price: 10000,
        startDate: "2021-05-30",
        endDate: "2021-06-14",
      },
      {
        price: 15000,
        startDate: "2019-06-15",
        endDate: "2019-06-30",
      },
      {
        price: 10000,
        startDate: "2019-06-01",
        endDate: "2019-06-16",
      },
    ],
    defaultImage: {
      dimensions: [1494, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/76/phornblower-5.jpg",
    },
    location: {
      lat: 41.311995,
      lng: -70.770794,
    },
  },
  {
    baths: 7,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "103 South Summer Street",
    },
    features: ["A/C", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/103-south-summer-street",
    bookings: [
      {
        endDate: "2019-08-11",
        startDate: "2019-07-07",
      },
      {
        endDate: "2020-01-01",
        startDate: "2019-12-29",
      },
      {
        endDate: "2021-12-26",
        startDate: "2021-09-04",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-12-25",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-08-27",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-01-01",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/10/Yelenak-3.jpg",
    },
    location: {
      lat: 41.386082,
      lng: -70.517387,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "85 Peases Point Way North",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/85-peases-point-way-north",
    bookings: [
      {
        endDate: "2022-09-01",
        startDate: "2022-07-31",
      },
      {
        endDate: "2020-06-21",
        startDate: "2020-06-06",
      },
      {
        endDate: "2021-09-01",
        startDate: "2021-07-03",
      },
      {
        endDate: "2022-09-01",
        startDate: "2022-08-31",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-09-17",
      },
      {
        endDate: "2022-06-19",
        startDate: "2022-06-04",
      },
      {
        endDate: "2021-07-04",
        startDate: "2021-05-29",
      },
      {
        endDate: "2018-08-25",
        startDate: "2018-07-28",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-07-18",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-06-18",
      },
    ],
    rates: [
      {
        price: 8800,
        startDate: "2020-03-28",
        endDate: "2020-06-28",
      },
      {
        price: 8800,
        startDate: "2019-12-29",
        endDate: "2020-03-29",
      },
      {
        price: 8800,
        startDate: "2020-12-27",
        endDate: "2021-06-27",
      },
      {
        price: 14000,
        startDate: "2022-06-25",
        endDate: "2022-10-02",
      },
      {
        price: 8800,
        startDate: "2021-09-25",
        endDate: "2022-01-02",
      },
      {
        price: 10800,
        startDate: "2019-09-01",
        endDate: "2019-12-30",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/99/85peases-1.jpg",
    },
    location: {
      lat: 41.392644,
      lng: -70.511631,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "107 Washque Avenue",
    },
    features: ["A/C", "Waterfront"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/107-washque-avenue",
    bookings: [
      {
        endDate: "2018-08-18",
        startDate: "2018-08-03",
      },
      {
        endDate: "2020-06-29",
        startDate: "2020-05-31",
      },
      {
        endDate: "2021-05-18",
        startDate: "2021-05-13",
      },
      {
        endDate: "2022-07-25",
        startDate: "2022-06-19",
      },
      {
        endDate: "2021-09-18",
        startDate: "2021-09-07",
      },
      {
        endDate: "2021-11-28",
        startDate: "2021-11-23",
      },
      {
        endDate: "2022-06-20",
        startDate: "2022-05-22",
      },
      {
        endDate: "2021-10-14",
        startDate: "2021-10-07",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2020-01-04",
        endDate: "2020-04-05",
      },
      {
        price: 6900,
        startDate: "2020-04-04",
        endDate: "2020-05-31",
      },
      {
        price: 6000,
        startDate: "2020-11-01",
        endDate: "2020-12-28",
      },
      {
        price: 8000,
        startDate: "2020-09-06",
        endDate: "2020-11-02",
      },
      {
        price: 12000,
        startDate: "2020-08-16",
        endDate: "2020-08-31",
      },
      {
        price: 8900,
        startDate: "2019-06-23",
        endDate: "2019-07-08",
      },
      {
        price: 8900,
        startDate: "2019-07-07",
        endDate: "2019-08-05",
      },
      {
        price: 7000,
        startDate: "2021-12-26",
        endDate: "2022-04-04",
      },
      {
        price: 10500,
        startDate: "2022-04-10",
        endDate: "2022-04-25",
      },
      {
        price: 12000,
        startDate: "2022-05-22",
        endDate: "2022-06-06",
      },
      {
        price: 13300,
        startDate: "2022-06-05",
        endDate: "2022-06-20",
      },
      {
        price: 18000,
        startDate: "2022-07-31",
        endDate: "2022-09-05",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/12/washque-1.jpg",
    },
    location: {
      lat: 41.353337,
      lng: -70.466423,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Aquinnah",

      text: "515 State Road",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/515-state-road",
    bookings: [
      {
        endDate: "2019-07-08",
        startDate: "2019-07-03",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-06-04",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-07-27",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-08-03",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-01",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/118/Walkush-1.jpg",
    },
    location: {
      lat: 41.3344309,
      lng: -70.7938346,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "50 Gaines Way",
    },
    features: ["A/C", "Linens Provided", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/50-gaines-way",
    bookings: [
      {
        endDate: "2019-08-10",
        startDate: "2019-06-30",
      },
      {
        endDate: "2019-09-08",
        startDate: "2019-08-11",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-06-25",
      },
      {
        endDate: "2020-08-26",
        startDate: "2020-08-11",
      },
      {
        endDate: "2020-08-12",
        startDate: "2020-06-27",
      },
      {
        endDate: "2022-06-26",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-09-04",
      },
    ],
    rates: [
      {
        price: 35000,
        startDate: "2022-06-25",
        endDate: "2022-09-25",
      },
      {
        price: 25000,
        startDate: "2019-06-30",
        endDate: "2019-09-08",
      },
    ],
    defaultImage: {
      dimensions: [1401, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/122/bean-1.jpg",
    },
    location: {
      lat: 41.395042,
      lng: -70.507881,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "20 Braley Way",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/20-braley-way",
    bookings: [],
    rates: [],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/155/angevin-1.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "106 Mattakesett Way",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/106-mattakesett-way",
    bookings: [
      {
        endDate: "2022-07-10",
        startDate: "2022-06-29",
      },
      {
        endDate: "2021-06-29",
        startDate: "2021-06-25",
      },
      {
        endDate: "2021-08-25",
        startDate: "2021-07-11",
      },
      {
        endDate: "2020-08-27",
        startDate: "2020-08-15",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-26",
      },
      {
        endDate: "2020-09-26",
        startDate: "2020-09-12",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-07-05",
      },
      {
        endDate: "2022-06-27",
        startDate: "2022-06-22",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2021-05-01",
        endDate: "2021-06-20",
      },
      {
        price: 12500,
        startDate: "2022-07-02",
        endDate: "2022-07-31",
      },
      {
        price: 7500,
        startDate: "2021-09-04",
        endDate: "2021-09-19",
      },
      {
        price: 5000,
        startDate: "2020-09-26",
        endDate: "2020-11-01",
      },
      {
        price: 8500,
        startDate: "2020-08-29",
        endDate: "2020-09-06",
      },
      {
        price: 8000,
        startDate: "2022-06-04",
        endDate: "2022-06-12",
      },
      {
        price: 7000,
        startDate: "2022-09-24",
        endDate: "2022-10-02",
      },
    ],
    defaultImage: {
      dimensions: [1023, 767],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/138/106 Mattakesett - 1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "22 Crackatuxet Cove Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/22-crackatuxet-cove-road",
    bookings: [
      {
        endDate: "2022-12-26",
        startDate: "2022-08-28",
      },
      {
        endDate: "2022-06-27",
        startDate: "2021-12-26",
      },
      {
        endDate: "2022-08-30",
        startDate: "2022-07-25",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/165/22 Crackatuxet Cove-1.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "West Tisbury",

      text: "35 Nat's Farm Lane",
    },
    features: [],
    beds: 4,
    sleeps: 7,
    type: "rental",
    path: "/rentals/35-nat's-farm-lane",
    bookings: [
      {
        endDate: "2021-09-22",
        startDate: "2021-08-21",
      },
      {
        endDate: "2020-07-19",
        startDate: "2020-07-03",
      },
      {
        endDate: "2021-08-17",
        startDate: "2021-08-02",
      },
      {
        endDate: "2021-07-20",
        startDate: "2021-06-27",
      },
      {
        endDate: "2020-09-09",
        startDate: "2020-08-08",
      },
      {
        endDate: "2021-08-03",
        startDate: "2021-07-19",
      },
      {
        endDate: "2019-07-28",
        startDate: "2019-06-30",
      },
    ],
    rates: [
      {
        price: 2800,
        startDate: "2021-09-19",
        endDate: "2021-10-04",
      },
      {
        price: 7000,
        startDate: "2019-07-28",
        endDate: "2019-08-05",
      },
      {
        price: 7500,
        startDate: "2019-08-04",
        endDate: "2019-08-12",
      },
      {
        price: 4000,
        startDate: "2020-08-23",
        endDate: "2020-09-21",
      },
      {
        price: 2800,
        startDate: "2020-09-20",
        endDate: "2020-10-26",
      },
      {
        price: 2800,
        startDate: "2021-12-26",
        endDate: "2022-05-09",
      },
      {
        price: 4000,
        startDate: "2021-08-29",
        endDate: "2021-09-20",
      },
      {
        price: 7500,
        startDate: "2019-08-11",
        endDate: "2019-08-19",
      },
      {
        price: 7000,
        startDate: "2019-09-01",
        endDate: "2019-09-09",
      },
      {
        price: 6000,
        startDate: "2019-09-08",
        endDate: "2019-09-16",
      },
      {
        price: 5500,
        startDate: "2019-09-15",
        endDate: "2019-09-23",
      },
      {
        price: 5500,
        startDate: "2019-09-22",
        endDate: "2019-09-30",
      },
      {
        price: 4500,
        startDate: "2019-09-29",
        endDate: "2020-01-05",
      },
      {
        price: 7000,
        startDate: "2019-08-25",
        endDate: "2019-09-02",
      },
      {
        price: 7000,
        startDate: "2019-07-21",
        endDate: "2019-07-29",
      },
      {
        price: 7000,
        startDate: "2019-07-14",
        endDate: "2019-07-22",
      },
      {
        price: 7000,
        startDate: "2019-07-07",
        endDate: "2019-07-15",
      },
      {
        price: 7000,
        startDate: "2019-08-18",
        endDate: "2019-08-26",
      },
      {
        price: 7000,
        startDate: "2019-06-30",
        endDate: "2019-07-08",
      },
      {
        price: 2800,
        startDate: "2022-09-18",
        endDate: "2022-12-26",
      },
    ],
    defaultImage: {
      dimensions: [1777, 1333],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/127/DSC_0434.jpg",
    },
    location: {
      lat: 41.3986,
      lng: -70.66335,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "2 Wades Field Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/2-wades-field-lane",
    bookings: [
      {
        endDate: "2022-08-23",
        startDate: "2022-07-30",
      },
      {
        endDate: "2020-08-27",
        startDate: "2020-08-19",
      },
      {
        endDate: "2019-09-18",
        startDate: "2019-09-09",
      },
      {
        endDate: "2021-06-15",
        startDate: "2021-06-05",
      },
      {
        endDate: "2022-08-30",
        startDate: "2022-08-22",
      },
      {
        endDate: "2021-08-17",
        startDate: "2021-08-09",
      },
      {
        endDate: "2022-09-06",
        startDate: "2022-08-29",
      },
      {
        endDate: "2022-06-21",
        startDate: "2022-06-13",
      },
      {
        endDate: "2020-08-08",
        startDate: "2020-07-28",
      },
      {
        endDate: "2020-07-29",
        startDate: "2020-07-23",
      },
      {
        endDate: "2020-07-10",
        startDate: "2020-07-02",
      },
      {
        endDate: "2020-08-20",
        startDate: "2020-08-07",
      },
      {
        endDate: "2020-09-05",
        startDate: "2020-08-26",
      },
      {
        endDate: "2021-08-10",
        startDate: "2021-07-26",
      },
      {
        endDate: "2021-07-27",
        startDate: "2021-06-21",
      },
      {
        endDate: "2021-09-02",
        startDate: "2021-08-25",
      },
      {
        endDate: "2021-08-24",
        startDate: "2021-08-16",
      },
      {
        endDate: "2019-07-08",
        startDate: "2019-06-30",
      },
      {
        endDate: "2019-09-09",
        startDate: "2019-08-18",
      },
    ],
    rates: [
      {
        price: 7000,
        startDate: "2022-04-23",
        endDate: "2022-06-26",
      },
      {
        price: 7000,
        startDate: "2019-06-02",
        endDate: "2019-06-30",
      },
      {
        price: 7000,
        startDate: "2019-09-01",
        endDate: "2019-09-29",
      },
      {
        price: 10000,
        startDate: "2020-06-28",
        endDate: "2020-07-27",
      },
      {
        price: 12000,
        startDate: "2020-07-26",
        endDate: "2020-08-31",
      },
      {
        price: 7000,
        startDate: "2020-08-30",
        endDate: "2020-09-28",
      },
      {
        price: 7000,
        startDate: "2021-08-29",
        endDate: "2021-10-04",
      },
    ],
    defaultImage: {
      dimensions: [1023, 767],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/116/IMG_7402.jpg",
    },
    location: {
      lat: 41.35949686149344,
      lng: -70.69022198929646,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "17 Boldwater Road",
    },
    features: ["A/C", "Pool", "Waterfront"],
    beds: 4,
    sleeps: 9,
    type: "rental",
    path: "/rentals/17-boldwater-road",
    bookings: [
      {
        endDate: "2020-09-07",
        startDate: "2020-08-30",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-06-27",
      },
      {
        endDate: "2020-08-10",
        startDate: "2020-07-26",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-08-09",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-06-26",
      },
      {
        endDate: "2021-06-28",
        startDate: "2021-06-20",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2022-05-29",
        endDate: "2022-06-20",
      },
      {
        price: 12000,
        startDate: "2019-12-29",
        endDate: "2020-06-29",
      },
      {
        price: 12000,
        startDate: "2020-12-27",
        endDate: "2021-05-31",
      },
      {
        price: 15000,
        startDate: "2022-09-04",
        endDate: "2022-12-26",
      },
      {
        price: 12000,
        startDate: "2020-09-06",
        endDate: "2020-12-28",
      },
      {
        price: 19000,
        startDate: "2020-07-05",
        endDate: "2020-08-03",
      },
      {
        price: 20000,
        startDate: "2020-08-02",
        endDate: "2020-08-24",
      },
      {
        price: 12000,
        startDate: "2021-09-05",
        endDate: "2021-12-27",
      },
      {
        price: 20000,
        startDate: "2021-07-04",
        endDate: "2021-08-02",
      },
    ],
    defaultImage: {
      dimensions: [2607, 1738],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/133/Morizio-2.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "13 Cyprien Way",
    },
    features: ["A/C"],
    beds: 2,
    sleeps: 5,
    type: "rental",
    path: "/rentals/13-cyprien-way",
    bookings: [
      {
        endDate: "2021-08-28",
        startDate: "2021-07-24",
      },
      {
        endDate: "2021-09-13",
        startDate: "2021-09-06",
      },
      {
        endDate: "2021-07-02",
        startDate: "2021-06-19",
      },
      {
        endDate: "2021-09-20",
        startDate: "2021-09-16",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-07-01",
      },
      {
        endDate: "2021-09-07",
        startDate: "2021-08-27",
      },
      {
        endDate: "2021-12-27",
        startDate: "2021-12-05",
      },
      {
        endDate: "2022-05-22",
        startDate: "2022-05-17",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-06-01",
      },
      {
        endDate: "2022-09-16",
        startDate: "2022-08-28",
      },
      {
        endDate: "2021-06-14",
        startDate: "2021-06-06",
      },
      {
        endDate: "2021-06-07",
        startDate: "2021-05-30",
      },
      {
        endDate: "2022-05-02",
        startDate: "2021-12-26",
      },
    ],
    rates: [
      {
        price: 3150,
        startDate: "2021-10-03",
        endDate: "2021-11-22",
      },
      {
        price: 3150,
        startDate: "2021-11-28",
        endDate: "2021-12-06",
      },
      {
        price: 3150,
        startDate: "2021-12-05",
        endDate: "2021-12-27",
      },
      {
        price: 3150,
        startDate: "2021-05-30",
        endDate: "2021-06-28",
      },
      {
        price: 4000,
        startDate: "2021-08-29",
        endDate: "2021-09-06",
      },
      {
        price: 3150,
        startDate: "2021-09-05",
        endDate: "2021-10-04",
      },
      {
        price: 3500,
        startDate: "2021-11-21",
        endDate: "2021-11-29",
      },
      {
        price: 3150,
        startDate: "2022-05-01",
        endDate: "2022-05-30",
      },
      {
        price: 4750,
        startDate: "2022-06-26",
        endDate: "2022-08-29",
      },
      {
        price: 3150,
        startDate: "2022-09-11",
        endDate: "2022-12-26",
      },
      {
        price: 4500,
        startDate: "2021-08-01",
        endDate: "2021-08-30",
      },
      {
        price: 4500,
        startDate: "2021-06-27",
        endDate: "2021-08-02",
      },
    ],
    defaultImage: {
      dimensions: [5600, 3733],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/158/13 Cyprien Way-63hydrangeaSky.JPG",
    },
    location: {
      lat: 41.39465,
      lng: -70.52461,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "15 Hammett Road",
    },
    features: [],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/15-hammett-road",
    bookings: [
      {
        endDate: "2022-08-30",
        startDate: "2022-06-27",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-07-04",
      },
      {
        endDate: "2020-08-17",
        startDate: "2020-07-26",
      },
      {
        endDate: "2021-10-04",
        startDate: "2021-05-30",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2022-03-27",
        endDate: "2022-05-23",
      },
      {
        price: 7000,
        startDate: "2019-05-26",
        endDate: "2019-06-24",
      },
      {
        price: 7000,
        startDate: "2020-05-31",
        endDate: "2020-06-22",
      },
      {
        price: 8500,
        startDate: "2020-06-21",
        endDate: "2020-06-29",
      },
      {
        price: 9500,
        startDate: "2022-06-26",
        endDate: "2022-07-25",
      },
      {
        price: 9500,
        startDate: "2022-08-28",
        endDate: "2022-09-26",
      },
      {
        price: 7500,
        startDate: "2022-05-22",
        endDate: "2022-06-20",
      },
      {
        price: 10000,
        startDate: "2022-07-24",
        endDate: "2022-08-29",
      },
      {
        price: 7000,
        startDate: "2021-09-12",
        endDate: "2021-10-04",
      },
      {
        price: 8500,
        startDate: "2019-06-23",
        endDate: "2019-07-01",
      },
      {
        price: 8500,
        startDate: "2019-07-07",
        endDate: "2019-07-29",
      },
      {
        price: 9500,
        startDate: "2019-07-28",
        endDate: "2019-09-02",
      },
      {
        price: 7000,
        startDate: "2019-09-01",
        endDate: "2019-09-23",
      },
      {
        price: 9500,
        startDate: "2020-08-02",
        endDate: "2020-08-31",
      },
    ],

    location: {
      lat: 41.38251,
      lng: -70.732783,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Vineyard Haven",
      state: "MA",
      text: "137 Massasoit Ave",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/137-massasoit-ave",
    bookings: [
      {
        endDate: "2019-08-25",
        startDate: "2019-06-16",
      },
      {
        endDate: "2020-09-14",
        startDate: "2020-08-29",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-05-21",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-07-30",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-08-01",
      },
      {
        endDate: "2020-06-27",
        startDate: "2020-06-15",
      },
      {
        endDate: "2020-10-25",
        startDate: "2020-10-10",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-07-02",
      },
      {
        endDate: "2021-06-28",
        startDate: "2021-06-13",
      },
      {
        endDate: "2020-07-26",
        startDate: "2020-07-18",
      },
      {
        endDate: "2020-08-16",
        startDate: "2020-08-01",
      },
      {
        endDate: "2020-09-25",
        startDate: "2020-09-12",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2019-05-18",
        endDate: "2019-06-30",
      },
      {
        price: 4200,
        startDate: "2020-09-12",
        endDate: "2020-11-01",
      },
      {
        price: 5000,
        startDate: "2019-09-08",
        endDate: "2019-09-15",
      },
      {
        price: 5600,
        startDate: "2020-09-05",
        endDate: "2020-09-13",
      },
      {
        price: 5600,
        startDate: "2021-04-25",
        endDate: "2021-05-31",
      },
      {
        price: 4200,
        startDate: "2021-09-26",
        endDate: "2021-12-27",
      },
      {
        price: 5600,
        startDate: "2021-05-30",
        endDate: "2021-06-21",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/120/massasoit-1.jpg",
    },
    location: {
      lat: 41.481206,
      lng: -70.6025,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Vineyard Haven",

      text: "16 Frog Hollow",
    },
    features: ["A/C", "Dock", "Waterfront"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/16-frog-hollow",
    bookings: [
      {
        endDate: "2022-09-05",
        startDate: "2022-07-30",
      },
      {
        endDate: "2019-08-04",
        startDate: "2019-06-30",
      },
      {
        endDate: "2019-11-03",
        startDate: "2019-09-01",
      },
      {
        endDate: "2019-06-30",
        startDate: "2019-05-26",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-08-03",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-08-17",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-01-01",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-09-03",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2022-06-25",
        endDate: "2022-09-11",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/126/frog-1.jpg",
    },
    location: {
      lat: 41.464165,
      lng: -70.600881,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Oak Bluffs",

      text: "60 Pinewood Lane",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/60-pinewood-lane",
    bookings: [
      {
        endDate: "2020-08-01",
        startDate: "2020-07-24",
      },
      {
        endDate: "2021-01-03",
        startDate: "2020-09-19",
      },
      {
        endDate: "2021-06-13",
        startDate: "2021-01-02",
      },
      {
        endDate: "2021-07-18",
        startDate: "2021-07-03",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-08-21",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-08-28",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-06-30",
      },
      {
        endDate: "2021-06-27",
        startDate: "2021-06-19",
      },
      {
        endDate: "2020-07-05",
        startDate: "2020-06-27",
      },
      {
        endDate: "2020-07-19",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-07-04",
      },
      {
        endDate: "2021-08-08",
        startDate: "2021-07-31",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2020-06-13",
        endDate: "2020-06-21",
      },
      {
        price: 5000,
        startDate: "2020-06-20",
        endDate: "2020-06-28",
      },
      {
        price: 7000,
        startDate: "2020-06-27",
        endDate: "2020-07-05",
      },
      {
        price: 7000,
        startDate: "2020-07-04",
        endDate: "2020-07-12",
      },
      {
        price: 8000,
        startDate: "2020-07-11",
        endDate: "2020-07-26",
      },
      {
        price: 9000,
        startDate: "2020-07-25",
        endDate: "2020-08-02",
      },
      {
        price: 10000,
        startDate: "2020-08-01",
        endDate: "2020-08-09",
      },
      {
        price: 10000,
        startDate: "2020-08-08",
        endDate: "2020-08-16",
      },
      {
        price: 10000,
        startDate: "2020-08-15",
        endDate: "2020-08-23",
      },
      {
        price: 9000,
        startDate: "2020-08-22",
        endDate: "2020-08-30",
      },
      {
        price: 5000,
        startDate: "2021-06-12",
        endDate: "2021-06-20",
      },
      {
        price: 7000,
        startDate: "2020-09-05",
        endDate: "2020-09-20",
      },
      {
        price: 12000,
        startDate: "2021-07-31",
        endDate: "2021-08-08",
      },
      {
        price: 12000,
        startDate: "2021-08-07",
        endDate: "2021-08-22",
      },
      {
        price: 10000,
        startDate: "2021-08-21",
        endDate: "2021-08-29",
      },
    ],
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "88 Oyster Pond Road",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/88-oyster-pond-road",
    bookings: [
      {
        endDate: "2023-09-10",
        startDate: "2023-09-02",
      },
      {
        endDate: "2023-07-23",
        startDate: "2023-07-15",
      },
      {
        endDate: "2020-07-05",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-07-25",
        startDate: "2020-07-18",
      },
      {
        endDate: "2021-07-13",
        startDate: "2021-07-01",
      },
      {
        endDate: "2020-10-04",
        startDate: "2020-09-05",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-07-02",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-07-25",
      },
      {
        endDate: "2020-07-19",
        startDate: "2020-07-04",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-22",
      },
      {
        endDate: "2021-06-21",
        startDate: "2021-06-13",
      },
      {
        endDate: "2020-06-29",
        startDate: "2020-06-21",
      },
      {
        endDate: "2020-06-08",
        startDate: "2020-05-31",
      },
      {
        endDate: "2021-08-09",
        startDate: "2021-07-18",
      },
    ],
    rates: [
      {
        price: 6615,
        startDate: "2023-05-20",
        endDate: "2023-05-28",
      },
      {
        price: 9261,
        startDate: "2023-07-22",
        endDate: "2023-07-30",
      },
      {
        price: 6615,
        startDate: "2023-09-02",
        endDate: "2023-10-01",
      },
      {
        price: 9923,
        startDate: "2023-07-29",
        endDate: "2023-08-20",
      },
      {
        price: 7630,
        startDate: "2022-05-26",
        endDate: "2022-06-12",
      },
      {
        price: 9450,
        startDate: "2022-07-30",
        endDate: "2022-08-14",
      },
      {
        price: 8820,
        startDate: "2022-08-13",
        endDate: "2022-09-04",
      },
      {
        price: 6300,
        startDate: "2022-09-17",
        endDate: "2022-12-18",
      },
      {
        price: 6930,
        startDate: "2022-12-17",
        endDate: "2023-01-01",
      },
      {
        price: 6300,
        startDate: "2022-01-01",
        endDate: "2022-05-27",
      },
      {
        price: 6615,
        startDate: "2023-05-13",
        endDate: "2023-05-21",
      },
      {
        price: 6615,
        startDate: "2023-01-07",
        endDate: "2023-05-14",
      },
      {
        price: 8012,
        startDate: "2023-05-27",
        endDate: "2023-06-11",
      },
      {
        price: 8012,
        startDate: "2023-06-10",
        endDate: "2023-06-18",
      },
      {
        price: 9261,
        startDate: "2023-06-17",
        endDate: "2023-07-23",
      },
      {
        price: 9261,
        startDate: "2023-08-19",
        endDate: "2023-09-03",
      },
      {
        price: 6615,
        startDate: "2023-09-30",
        endDate: "2023-11-19",
      },
      {
        price: 8012,
        startDate: "2023-11-18",
        endDate: "2023-11-26",
      },
      {
        price: 6615,
        startDate: "2023-11-25",
        endDate: "2023-12-17",
      },
      {
        price: 8012,
        startDate: "2023-12-16",
        endDate: "2023-12-31",
      },
      {
        price: 5000,
        startDate: "2020-05-02",
        endDate: "2020-05-24",
      },
      {
        price: 7500,
        startDate: "2020-08-22",
        endDate: "2020-09-07",
      },
      {
        price: 8400,
        startDate: "2021-06-27",
        endDate: "2021-08-09",
      },
      {
        price: 8820,
        startDate: "2022-06-18",
        endDate: "2022-07-24",
      },
      {
        price: 7500,
        startDate: "2020-06-27",
        endDate: "2020-08-09",
      },
      {
        price: 6000,
        startDate: "2019-09-07",
        endDate: "2019-10-06",
      },
      {
        price: 8000,
        startDate: "2020-08-08",
        endDate: "2020-08-23",
      },
      {
        price: 6000,
        startDate: "2020-05-23",
        endDate: "2020-06-28",
      },
      {
        price: 5000,
        startDate: "2019-10-05",
        endDate: "2020-01-05",
      },
      {
        price: 5000,
        startDate: "2020-01-04",
        endDate: "2020-05-03",
      },
      {
        price: 5124,
        startDate: "2020-09-27",
        endDate: "2020-12-28",
      },
      {
        price: 5698,
        startDate: "2021-05-16",
        endDate: "2021-05-31",
      },
      {
        price: 8554,
        startDate: "2021-08-08",
        endDate: "2021-08-23",
      },
      {
        price: 5124,
        startDate: "2021-10-03",
        endDate: "2021-12-27",
      },
      {
        price: 5124,
        startDate: "2020-12-27",
        endDate: "2021-05-17",
      },
    ],
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "15 Tilton Way",
    },
    features: ["A/C", "Hot Tub", "Linens Provided", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/15-tilton-way",
    bookings: [
      {
        endDate: "2020-08-15",
        startDate: "2020-07-12",
      },
      {
        endDate: "2020-08-17",
        startDate: "2020-08-14",
      },
      {
        endDate: "2022-09-08",
        startDate: "2022-08-14",
      },
      {
        endDate: "2022-06-20",
        startDate: "2022-06-12",
      },
      {
        endDate: "2021-09-03",
        startDate: "2021-08-29",
      },
      {
        endDate: "2019-09-04",
        startDate: "2019-08-04",
      },
      {
        endDate: "2018-08-18",
        startDate: "2018-07-28",
      },
      {
        endDate: "2020-07-13",
        startDate: "2020-06-21",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-08-16",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-07-25",
      },
      {
        endDate: "2022-08-08",
        startDate: "2022-07-24",
      },
      {
        endDate: "2021-07-26",
        startDate: "2021-07-18",
      },
      {
        endDate: "2021-07-19",
        startDate: "2021-06-27",
      },
    ],
    rates: [
      {
        price: 18000,
        startDate: "2021-10-04",
        endDate: "2021-12-20",
      },
      {
        price: 20000,
        startDate: "2021-12-19",
        endDate: "2022-01-02",
      },
      {
        price: 18000,
        startDate: "2021-01-03",
        endDate: "2021-05-03",
      },
      {
        price: 27500,
        startDate: "2021-06-27",
        endDate: "2021-09-14",
      },
      {
        price: 25000,
        startDate: "2020-06-21",
        endDate: "2020-07-27",
      },
      {
        price: 27500,
        startDate: "2020-07-26",
        endDate: "2020-09-14",
      },
      {
        price: 30000,
        startDate: "2022-06-26",
        endDate: "2022-09-12",
      },
      {
        price: 23000,
        startDate: "2020-01-05",
        endDate: "2020-06-22",
      },
      {
        price: 23000,
        startDate: "2018-12-30",
        endDate: "2019-06-30",
      },
      {
        price: 25000,
        startDate: "2019-06-30",
        endDate: "2019-07-28",
      },
      {
        price: 27500,
        startDate: "2019-07-28",
        endDate: "2019-09-01",
      },
      {
        price: 23000,
        startDate: "2019-09-01",
        endDate: "2020-01-05",
      },
      {
        price: 20000,
        startDate: "2018-07-28",
        endDate: "2018-08-04",
      },
      {
        price: 25000,
        startDate: "2018-08-04",
        endDate: "2018-08-11",
      },
      {
        price: 25000,
        startDate: "2018-08-11",
        endDate: "2018-08-18",
      },
      {
        price: 20000,
        startDate: "2018-08-18",
        endDate: "2018-08-25",
      },
      {
        price: 20000,
        startDate: "2018-08-25",
        endDate: "2018-09-01",
      },
      {
        price: 20000,
        startDate: "2018-09-01",
        endDate: "2018-09-08",
      },
      {
        price: 20000,
        startDate: "2018-09-08",
        endDate: "2018-09-15",
      },
      {
        price: 17500,
        startDate: "2018-09-15",
        endDate: "2018-09-22",
      },
      {
        price: 17500,
        startDate: "2018-09-22",
        endDate: "2018-09-29",
      },
      {
        price: 17500,
        startDate: "2018-09-29",
        endDate: "2018-10-06",
      },
      {
        price: 23000,
        startDate: "2022-01-02",
        endDate: "2022-05-30",
      },
      {
        price: 27500,
        startDate: "2022-05-29",
        endDate: "2022-06-27",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/125/tilton-1.jpg",
    },
    location: {
      lat: 41.390063,
      lng: -70.518249,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "West Tisbury",

      text: "29 Naushon Road",
    },
    features: ["A/C", "Linens Provided"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/29-naushon-road",
    bookings: [
      {
        endDate: "2020-07-25",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-10-05",
        startDate: "2020-08-14",
      },
      {
        endDate: "2022-10-16",
        startDate: "2022-09-10",
      },
      {
        endDate: "2022-05-16",
        startDate: "2021-12-26",
      },
      {
        endDate: "2019-08-22",
        startDate: "2019-07-27",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-07-09",
      },
      {
        endDate: "2021-10-25",
        startDate: "2021-10-02",
      },
      {
        endDate: "2021-09-07",
        startDate: "2021-08-28",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-07-31",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2019-04-28",
        endDate: "2019-06-23",
      },
      {
        price: 9500,
        startDate: "2020-05-30",
        endDate: "2020-08-09",
      },
      {
        price: 10000,
        startDate: "2020-08-08",
        endDate: "2020-08-30",
      },
      {
        price: 9500,
        startDate: "2021-09-11",
        endDate: "2021-09-19",
      },
      {
        price: 8500,
        startDate: "2021-09-18",
        endDate: "2021-09-26",
      },
      {
        price: 7500,
        startDate: "2021-09-25",
        endDate: "2021-10-03",
      },
      {
        price: 6500,
        startDate: "2020-09-05",
        endDate: "2021-01-03",
      },
      {
        price: 9500,
        startDate: "2019-06-22",
        endDate: "2019-06-30",
      },
      {
        price: 6500,
        startDate: "2019-08-31",
        endDate: "2019-09-29",
      },
      {
        price: 6500,
        startDate: "2020-01-04",
        endDate: "2020-05-31",
      },
      {
        price: 13000,
        startDate: "2022-07-30",
        endDate: "2022-09-04",
      },
    ],
    defaultImage: {
      dimensions: [1024, 682],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/119/naushon-1.jpg",
    },
    location: {
      lat: 41.459599,
      lng: -70.658,
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "68 North Water Street",
    },
    features: ["A/C", "Pool"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/68-north-water-street",
    bookings: [
      {
        endDate: "2022-01-02",
        startDate: "2021-09-26",
      },
      {
        endDate: "2022-07-24",
        startDate: "2022-06-18",
      },
      {
        endDate: "2022-05-01",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-08-27",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-07-23",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-07-30",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2022-05-14",
        endDate: "2022-05-29",
      },
      {
        price: 20000,
        startDate: "2022-10-15",
        endDate: "2022-10-30",
      },
      {
        price: 20000,
        startDate: "2022-04-30",
        endDate: "2022-05-15",
      },
      {
        price: 40000,
        startDate: "2022-07-02",
        endDate: "2022-08-28",
      },
      {
        price: 30000,
        startDate: "2022-09-03",
        endDate: "2022-09-25",
      },
      {
        price: 25000,
        startDate: "2022-09-24",
        endDate: "2022-10-16",
      },
    ],
    defaultImage: {
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/164/68 North Water Street-web-112.jpg",
    },
  },
  {
    baths: 7,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "30 Crackatuxet Cove Road",
    },
    features: ["A/C", "Pool"],
    beds: 7,
    sleeps: 16,
    type: "rental",
    path: "/rentals/30-crackatuxet-cove-road",
    bookings: [
      {
        endDate: "2020-08-03",
        startDate: "2020-06-27",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-08-13",
      },
      {
        endDate: "2022-07-10",
        startDate: "2022-05-28",
      },
      {
        endDate: "2020-08-17",
        startDate: "2020-08-02",
      },
    ],
    rates: [
      {
        price: 65000,
        startDate: "2022-07-30",
        endDate: "2022-10-02",
      },
      {
        price: 55000,
        startDate: "2021-09-25",
        endDate: "2021-10-31",
      },
      {
        price: 60000,
        startDate: "2020-08-01",
        endDate: "2020-09-06",
      },
      {
        price: 50000,
        startDate: "2020-06-27",
        endDate: "2020-08-02",
      },
      {
        price: 40000,
        startDate: "2020-09-05",
        endDate: "2020-10-04",
      },
      {
        price: 40000,
        startDate: "2020-05-30",
        endDate: "2020-06-28",
      },
      {
        price: 65000,
        startDate: "2021-07-31",
        endDate: "2021-09-12",
      },
      {
        price: 30000,
        startDate: "2022-10-29",
        endDate: "2023-01-01",
      },
      {
        price: 30000,
        startDate: "2022-01-01",
        endDate: "2022-05-29",
      },
      {
        price: 65000,
        startDate: "2021-09-11",
        endDate: "2021-09-26",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/140/crack-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "44 Jeremiah Way",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 7,
    type: "rental",
    path: "/rentals/44-jeremiah-way",
    bookings: [
      {
        endDate: "2020-07-26",
        startDate: "2020-06-20",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-11-05",
      },
      {
        endDate: "2022-08-12",
        startDate: "2022-06-29",
      },
      {
        endDate: "2023-04-30",
        startDate: "2023-01-07",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-05-30",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-07-25",
      },
    ],
    rates: [
      {
        price: 4500,
        startDate: "2021-04-25",
        endDate: "2021-10-04",
      },
      {
        price: 2500,
        startDate: "2020-05-31",
        endDate: "2020-06-29",
      },
      {
        price: 5250,
        startDate: "2022-05-28",
        endDate: "2022-09-04",
      },
      {
        price: 3850,
        startDate: "2022-10-01",
        endDate: "2022-11-06",
      },
    ],
    defaultImage: {
      dimensions: [1024, 762],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/142/jeremiah-1.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Beach Street",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/2-beach-street",
    bookings: [
      {
        endDate: "2022-08-14",
        startDate: "2022-07-02",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-06-26",
      },
      {
        endDate: "2022-06-05",
        startDate: "2022-01-01",
      },
      {
        endDate: "2021-06-27",
        startDate: "2021-06-12",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-08-13",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-08-14",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2022-01-01",
        endDate: "2022-06-12",
      },
      {
        price: 10000,
        startDate: "2022-09-03",
        endDate: "2022-10-16",
      },
      {
        price: 8000,
        startDate: "2022-10-15",
        endDate: "2023-01-01",
      },
      {
        price: 12000,
        startDate: "2022-06-11",
        endDate: "2022-06-26",
      },
      {
        price: 16000,
        startDate: "2022-07-23",
        endDate: "2022-08-28",
      },
      {
        price: 8000,
        startDate: "2021-01-02",
        endDate: "2021-05-23",
      },
      {
        price: 8000,
        startDate: "2021-05-22",
        endDate: "2021-06-13",
      },
      {
        price: 10000,
        startDate: "2021-06-12",
        endDate: "2021-06-27",
      },
      {
        price: 12000,
        startDate: "2021-06-26",
        endDate: "2021-07-25",
      },
      {
        price: 14000,
        startDate: "2021-07-24",
        endDate: "2021-08-29",
      },
      {
        price: 12000,
        startDate: "2021-08-28",
        endDate: "2021-09-05",
      },
      {
        price: 8000,
        startDate: "2021-10-02",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 731],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/153/beach-1.jpg",
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Boldwater Road",
    },
    features: ["A/C", "Hot Tub", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/2-boldwater-road",
    bookings: [
      {
        endDate: "2022-09-04",
        startDate: "2022-07-22",
      },
      {
        endDate: "2022-06-27",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-01-02",
        startDate: "2020-12-27",
      },
    ],
    rates: [
      {
        price: 27500,
        startDate: "2022-06-26",
        endDate: "2022-09-04",
      },
      {
        price: 27500,
        startDate: "2021-06-27",
        endDate: "2021-09-06",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/163/massa-45.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "6 Milikin Way",
    },
    features: ["A/C"],
    beds: 2,
    sleeps: 5,
    type: "rental",
    path: "/rentals/6-milikin-way",
    bookings: [
      {
        endDate: "2021-08-05",
        startDate: "2021-07-31",
      },
      {
        endDate: "2021-07-02",
        startDate: "2021-06-23",
      },
      {
        endDate: "2021-08-15",
        startDate: "2021-08-07",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-08-21",
      },
      {
        endDate: "2022-08-07",
        startDate: "2022-07-23",
      },
      {
        endDate: "2022-07-10",
        startDate: "2022-06-25",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-08-13",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-08-14",
      },
      {
        endDate: "2022-07-24",
        startDate: "2022-07-09",
      },
      {
        endDate: "2022-08-14",
        startDate: "2022-08-06",
      },
    ],
    rates: [
      {
        price: 4500,
        startDate: "2021-06-20",
        endDate: "2021-09-13",
      },
      {
        price: 4000,
        startDate: "2021-12-26",
        endDate: "2022-06-13",
      },
      {
        price: 4500,
        startDate: "2022-06-12",
        endDate: "2022-09-05",
      },
      {
        price: 4000,
        startDate: "2021-09-12",
        endDate: "2021-12-27",
      },
      {
        price: 4000,
        startDate: "2022-09-25",
        endDate: "2022-12-26",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/160/milikin-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "23 Uncas Avenue",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/23-uncas-avenue",
    bookings: [
      {
        endDate: "2022-07-19",
        startDate: "2022-05-01",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-08-02",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2022-07-18",
        endDate: "2022-08-03",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/172/uncasnew-1.jpg",
    },
    location: {
      lat: 41.451778,
      lng: -70.560944,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "16 Haystack Lane",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 5,
    type: "rental",
    path: "/rentals/16-haystack-lane",
    bookings: [],
    rates: [
      {
        price: 6500,
        startDate: "2022-07-16",
        endDate: "2022-07-31",
      },
      {
        price: 5000,
        startDate: "2022-05-28",
        endDate: "2022-06-05",
      },
      {
        price: 5000,
        startDate: "2022-06-04",
        endDate: "2022-06-19",
      },
      {
        price: 5500,
        startDate: "2022-06-18",
        endDate: "2022-07-03",
      },
      {
        price: 6000,
        startDate: "2022-07-02",
        endDate: "2022-07-17",
      },
      {
        price: 7500,
        startDate: "2022-08-20",
        endDate: "2022-08-28",
      },
      {
        price: 6500,
        startDate: "2022-08-27",
        endDate: "2022-09-04",
      },
      {
        price: 6000,
        startDate: "2022-09-03",
        endDate: "2022-09-11",
      },
      {
        price: 5500,
        startDate: "2022-09-10",
        endDate: "2022-09-18",
      },
      {
        price: 5000,
        startDate: "2022-09-17",
        endDate: "2022-10-02",
      },
    ],
    defaultImage: {
      dimensions: [1365, 1024],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/170/Lillis-1.jpg",
    },
    location: {
      lat: 41.4072,
      lng: -70.55019,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",
      state: "MA",
      text: "8 Pamela Way",
    },
    features: ["A/C", "Hot Tub"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/8-pamela-way",
    bookings: [],
    rates: [
      {
        price: 6500,
        startDate: "2022-05-27",
        endDate: "2022-07-02",
      },
      {
        price: 8000,
        startDate: "2022-07-01",
        endDate: "2022-08-06",
      },
      {
        price: 6000,
        startDate: "2022-05-06",
        endDate: "2022-05-28",
      },
      {
        price: 6500,
        startDate: "2022-09-02",
        endDate: "2022-09-10",
      },
      {
        price: 6000,
        startDate: "2022-09-09",
        endDate: "2022-10-01",
      },
      {
        price: 8000,
        startDate: "2022-08-05",
        endDate: "2022-09-03",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/173/8 Pamela Way-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "248 Meetinghouse Way",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/248-meetinghouse-way",
    bookings: [
      {
        endDate: "2020-07-26",
        startDate: "2020-06-27",
      },
    ],
    rates: [
      {
        price: 3750,
        startDate: "2020-12-27",
        endDate: "2021-06-20",
      },
      {
        price: 8000,
        startDate: "2021-06-19",
        endDate: "2021-08-29",
      },
      {
        price: 4500,
        startDate: "2021-08-28",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/134/meetinghouse-1.jpg",
    },
  },
  {
    baths: 1,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "51 West Tisbury Road",
    },
    features: ["A/C"],
    beds: 2,
    sleeps: 5,
    type: "rental",
    path: "/rentals/51-west-tisbury-road",
    bookings: [
      {
        endDate: "2021-07-25",
        startDate: "2021-07-03",
      },
      {
        endDate: "2022-04-27",
        startDate: "2022-04-20",
      },
      {
        endDate: "2022-05-29",
        startDate: "2022-05-19",
      },
      {
        endDate: "2020-09-21",
        startDate: "2020-09-17",
      },
      {
        endDate: "2020-05-28",
        startDate: "2020-05-22",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-09-21",
      },
      {
        endDate: "2020-09-18",
        startDate: "2020-09-06",
      },
      {
        endDate: "2020-09-28",
        startDate: "2020-09-20",
      },
      {
        endDate: "2021-07-04",
        startDate: "2021-06-26",
      },
      {
        endDate: "2022-06-05",
        startDate: "2022-05-28",
      },
      {
        endDate: "2022-09-11",
        startDate: "2022-08-27",
      },
      {
        endDate: "2020-08-03",
        startDate: "2020-07-12",
      },
      {
        endDate: "2020-07-06",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-07-13",
        startDate: "2020-07-05",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-08-07",
      },
      {
        endDate: "2020-08-17",
        startDate: "2020-08-09",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-08-23",
      },
      {
        endDate: "2020-08-24",
        startDate: "2020-08-16",
      },
      {
        endDate: "2020-08-10",
        startDate: "2020-08-02",
      },
    ],
    rates: [
      {
        price: 4500,
        startDate: "2022-06-25",
        endDate: "2022-08-07",
      },
      {
        price: 3500,
        startDate: "2022-10-08",
        endDate: "2022-10-30",
      },
      {
        price: 3200,
        startDate: "2020-06-28",
        endDate: "2020-07-06",
      },
      {
        price: 3500,
        startDate: "2020-07-05",
        endDate: "2020-07-27",
      },
      {
        price: 3900,
        startDate: "2020-07-26",
        endDate: "2020-08-24",
      },
      {
        price: 3500,
        startDate: "2020-08-23",
        endDate: "2020-08-31",
      },
      {
        price: 2750,
        startDate: "2020-09-06",
        endDate: "2020-09-14",
      },
      {
        price: 2842,
        startDate: "2020-09-19",
        endDate: "2021-01-03",
      },
      {
        price: 2800,
        startDate: "2021-09-11",
        endDate: "2022-01-02",
      },
      {
        price: 2500,
        startDate: "2019-12-29",
        endDate: "2020-06-01",
      },
      {
        price: 3900,
        startDate: "2022-04-30",
        endDate: "2022-06-05",
      },
      {
        price: 3900,
        startDate: "2022-10-01",
        endDate: "2022-10-09",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/135/exterior-1.jpg",
    },
    location: {
      lat: 41.390591,
      lng: -70.523122,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "20 Blackberry Lane",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/20-blackberry-lane",
    bookings: [
      {
        endDate: "2020-07-31",
        startDate: "2020-06-27",
      },
      {
        endDate: "2020-09-28",
        startDate: "2020-08-30",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-07-30",
      },
      {
        endDate: "2020-06-29",
        startDate: "2019-12-29",
      },
    ],
    rates: [
      {
        price: 6000,
        startDate: "2020-12-27",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/136/blackberry-1.jpg",
    },
    location: {
      lat: 41.381807,
      lng: -70.712942,
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "46 Slough Cove Road",
    },
    features: ["A/C", "Hot Tub", "Pool"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/46-slough-cove-road",
    bookings: [
      {
        endDate: "2022-05-29",
        startDate: "2022-05-07",
      },
      {
        endDate: "2021-06-21",
        startDate: "2020-12-27",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-09-12",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-10-01",
      },
      {
        endDate: "2022-07-17",
        startDate: "2022-07-02",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-06-20",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-07-16",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-07-26",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-06-28",
      },
      {
        endDate: "2021-09-13",
        startDate: "2021-09-05",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-08-29",
      },
    ],
    rates: [
      {
        price: 11000,
        startDate: "2022-09-17",
        endDate: "2023-01-01",
      },
      {
        price: 21000,
        startDate: "2020-12-27",
        endDate: "2021-12-27",
      },
      {
        price: 11000,
        startDate: "2022-01-01",
        endDate: "2022-06-05",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/137/slough-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "8 Caleb Pond Lane",
    },
    features: [],
    beds: 6,
    sleeps: 10,
    type: "rental",
    path: "/rentals/8-caleb-pond-lane",
    bookings: [
      {
        endDate: "2021-06-30",
        startDate: "2021-06-19",
      },
      {
        endDate: "2022-11-06",
        startDate: "2022-03-27",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-07-31",
      },
      {
        endDate: "2021-07-18",
        startDate: "2021-07-10",
      },
      {
        endDate: "2021-08-01",
        startDate: "2021-07-17",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2022-09-10",
        endDate: "2022-09-25",
      },
      {
        price: 6500,
        startDate: "2022-09-24",
        endDate: "2022-10-30",
      },
      {
        price: 6500,
        startDate: "2021-01-02",
        endDate: "2021-06-27",
      },
      {
        price: 9000,
        startDate: "2021-06-26",
        endDate: "2021-07-11",
      },
      {
        price: 7500,
        startDate: "2021-07-10",
        endDate: "2021-08-01",
      },
      {
        price: 5500,
        startDate: "2021-09-18",
        endDate: "2022-01-02",
      },
      {
        price: 5500,
        startDate: "2022-01-01",
        endDate: "2022-05-01",
      },
      {
        price: 6500,
        startDate: "2022-04-30",
        endDate: "2022-06-12",
      },
      {
        price: 7500,
        startDate: "2022-07-09",
        endDate: "2022-07-31",
      },
      {
        price: 9000,
        startDate: "2022-07-30",
        endDate: "2022-08-28",
      },
      {
        price: 7000,
        startDate: "2022-08-27",
        endDate: "2022-09-11",
      },
    ],
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "3 Marjos Way",
    },
    features: ["Waterfront"],
    beds: 4,
    sleeps: 9,
    type: "rental",
    path: "/rentals/3-marjos-way",
    bookings: [
      {
        endDate: "2022-09-12",
        startDate: "2022-07-17",
      },
      {
        endDate: "2020-08-03",
        startDate: "2020-06-28",
      },
      {
        endDate: "2020-11-01",
        startDate: "2020-09-03",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-08-02",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-06-27",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2020-09-06",
        endDate: "2020-09-28",
      },
      {
        price: 7000,
        startDate: "2020-09-27",
        endDate: "2020-11-02",
      },
      {
        price: 9000,
        startDate: "2020-08-30",
        endDate: "2020-09-07",
      },
      {
        price: 10000,
        startDate: "2020-06-28",
        endDate: "2020-08-31",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/145/marjos-1.jpg",
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "9 Wilbur Lane",
    },
    features: ["A/C"],
    beds: 6,
    sleeps: 10,
    type: "rental",
    path: "/rentals/9-wilbur-lane",
    bookings: [
      {
        endDate: "2021-07-03",
        startDate: "2021-06-12",
      },
      {
        endDate: "2021-07-26",
        startDate: "2021-07-15",
      },
      {
        endDate: "2021-09-27",
        startDate: "2021-09-05",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-07-25",
      },
      {
        endDate: "2021-07-16",
        startDate: "2021-07-02",
      },
      {
        endDate: "2022-07-21",
        startDate: "2022-03-27",
      },
      {
        endDate: "2021-10-04",
        startDate: "2021-09-26",
      },
      {
        endDate: "2022-09-04",
        startDate: "2022-08-06",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2021-01-02",
        endDate: "2021-06-20",
      },
      {
        price: 12000,
        startDate: "2022-01-01",
        endDate: "2022-06-19",
      },
      {
        price: 12000,
        startDate: "2022-09-03",
        endDate: "2023-01-01",
      },
      {
        price: 20000,
        startDate: "2021-06-19",
        endDate: "2021-07-04",
      },
      {
        price: 20000,
        startDate: "2021-07-03",
        endDate: "2021-09-05",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1066],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/147/Getz - 1.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "5 Wauwompauque Trail",
    },
    features: ["A/C"],
    beds: 7,
    sleeps: 10,
    type: "rental",
    path: "/rentals/5-wauwompauque-trail",
    bookings: [
      {
        endDate: "2022-05-22",
        startDate: "2022-01-01",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-07-31",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-08-06",
      },
    ],
    rates: [
      {
        price: 14000,
        startDate: "2022-05-21",
        endDate: "2022-06-26",
      },
      {
        price: 16000,
        startDate: "2022-06-25",
        endDate: "2022-08-28",
      },
      {
        price: 16000,
        startDate: "2021-06-27",
        endDate: "2021-08-30",
      },
      {
        price: 14000,
        startDate: "2021-08-29",
        endDate: "2021-09-27",
      },
      {
        price: 14000,
        startDate: "2022-08-27",
        endDate: "2022-10-02",
      },
    ],
    defaultImage: {
      dimensions: [1024, 682],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/148/wauw-1.jpg",
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "West Tisbury",

      text: "40 Plum Bush Point",
    },
    features: ["A/C", "Dock", "Hot Tub", "Waterfront"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/40-plum-bush-point",
    bookings: [
      {
        endDate: "2022-07-31",
        startDate: "2021-12-26",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-08-20",
      },
    ],
    rates: [
      {
        price: 15000,
        startDate: "2022-07-30",
        endDate: "2022-08-21",
      },
      {
        price: 15000,
        startDate: "2022-06-25",
        endDate: "2022-07-31",
      },
    ],
    defaultImage: {
      dimensions: [1422, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/171/Segal-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "95 Whaler's Walk",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/95-whaler's-walk",
    bookings: [
      {
        endDate: "2021-07-11",
        startDate: "2021-06-12",
      },
      {
        endDate: "2021-08-29",
        startDate: "2021-07-24",
      },
      {
        endDate: "2022-09-26",
        startDate: "2022-05-29",
      },
    ],
    rates: [
      {
        price: 3304,
        startDate: "2021-05-29",
        endDate: "2021-06-27",
      },
      {
        price: 6600,
        startDate: "2021-07-31",
        endDate: "2021-09-05",
      },
      {
        price: 3304,
        startDate: "2021-10-02",
        endDate: "2021-11-07",
      },
      {
        price: 6045,
        startDate: "2021-06-26",
        endDate: "2021-08-01",
      },
      {
        price: 3304,
        startDate: "2021-09-04",
        endDate: "2021-10-03",
      },
    ],
    defaultImage: {
      dimensions: [1494, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/154/maloney-1.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "16 Shotnaigher Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 10,
    type: "rental",
    path: "/rentals/16-shotnaigher-lane",
    bookings: [],
    rates: [
      {
        price: 25000,
        startDate: "2022-07-02",
        endDate: "2022-09-04",
      },
    ],
    defaultImage: {
      dimensions: [1422, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/168/annie-7.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "24 Jennie Lane",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/24-jennie-lane",
    bookings: [
      {
        endDate: "2021-09-06",
        startDate: "2021-03-28",
      },
      {
        endDate: "2021-09-21",
        startDate: "2021-09-16",
      },
      {
        endDate: "2021-10-12",
        startDate: "2021-10-07",
      },
      {
        endDate: "2022-07-22",
        startDate: "2022-07-14",
      },
      {
        endDate: "2022-06-26",
        startDate: "2022-04-04",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-06-25",
      },
    ],
    rates: [
      {
        price: 5250,
        startDate: "2021-10-04",
        endDate: "2021-11-02",
      },
      {
        price: 5000,
        startDate: "2021-11-07",
        endDate: "2021-12-27",
      },
      {
        price: 5000,
        startDate: "2022-10-02",
        endDate: "2022-12-26",
      },
      {
        price: 6650,
        startDate: "2021-09-13",
        endDate: "2021-10-05",
      },
      {
        price: 5000,
        startDate: "2021-12-26",
        endDate: "2022-05-02",
      },
      {
        price: 5000,
        startDate: "2022-05-01",
        endDate: "2022-05-23",
      },
      {
        price: 10000,
        startDate: "2022-07-03",
        endDate: "2022-08-01",
      },
      {
        price: 12000,
        startDate: "2022-07-31",
        endDate: "2022-08-22",
      },
      {
        price: 10000,
        startDate: "2021-06-20",
        endDate: "2021-08-02",
      },
      {
        price: 12000,
        startDate: "2021-08-01",
        endDate: "2021-08-23",
      },
      {
        price: 10000,
        startDate: "2021-08-22",
        endDate: "2021-09-06",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/162/Valle-39.jpg",
    },
    location: {
      lat: 41.379829,
      lng: -70.60302,
    },
  },
  {
    baths: 5,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "2 Oyster Pond Lane",
    },
    features: [],
    beds: 7,
    sleeps: 14,
    type: "rental",
    path: "/rentals/2-oyster-pond-lane",
    bookings: [
      {
        endDate: "2019-08-12",
        startDate: "2019-07-28",
      },
      {
        endDate: "2019-09-02",
        startDate: "2019-08-25",
      },
      {
        endDate: "2020-08-17",
        startDate: "2020-06-28",
      },
    ],
    rates: [
      {
        price: 18000,
        startDate: "2020-08-02",
        endDate: "2020-08-17",
      },
      {
        price: 10000,
        startDate: "2020-05-31",
        endDate: "2020-06-15",
      },
      {
        price: 18000,
        startDate: "2020-08-16",
        endDate: "2020-08-24",
      },
      {
        price: 16000,
        startDate: "2020-08-23",
        endDate: "2020-09-07",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/114/oyster-1.jpg",
    },
    location: {
      lat: 41.376856,
      lng: -70.5950529,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Oak Bluffs",

      text: "5 Hudson Avenue",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/5-hudson-avenue",
    bookings: [
      {
        endDate: "2022-08-08",
        startDate: "2022-07-31",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-08-07",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2022-02-27",
        endDate: "2022-03-07",
      },
      {
        price: 4000,
        startDate: "2022-02-06",
        endDate: "2022-02-14",
      },
      {
        price: 4000,
        startDate: "2022-04-10",
        endDate: "2022-04-18",
      },
      {
        price: 4000,
        startDate: "2022-04-17",
        endDate: "2022-04-25",
      },
      {
        price: 4000,
        startDate: "2022-02-13",
        endDate: "2022-02-21",
      },
      {
        price: 4000,
        startDate: "2022-02-20",
        endDate: "2022-02-28",
      },
      {
        price: 4000,
        startDate: "2022-03-06",
        endDate: "2022-03-14",
      },
      {
        price: 4000,
        startDate: "2022-03-13",
        endDate: "2022-03-21",
      },
      {
        price: 4000,
        startDate: "2022-03-20",
        endDate: "2022-03-28",
      },
      {
        price: 4000,
        startDate: "2022-03-27",
        endDate: "2022-04-04",
      },
      {
        price: 6000,
        startDate: "2022-10-16",
        endDate: "2022-10-24",
      },
      {
        price: 6000,
        startDate: "2022-10-23",
        endDate: "2022-10-31",
      },
      {
        price: 7000,
        startDate: "2022-06-26",
        endDate: "2022-07-04",
      },
      {
        price: 7000,
        startDate: "2022-07-03",
        endDate: "2022-07-11",
      },
      {
        price: 7000,
        startDate: "2022-07-10",
        endDate: "2022-07-18",
      },
      {
        price: 7000,
        startDate: "2022-07-24",
        endDate: "2022-08-01",
      },
      {
        price: 5000,
        startDate: "2022-05-01",
        endDate: "2022-05-09",
      },
      {
        price: 5000,
        startDate: "2022-05-08",
        endDate: "2022-05-16",
      },
      {
        price: 5000,
        startDate: "2022-05-15",
        endDate: "2022-05-23",
      },
      {
        price: 5000,
        startDate: "2022-05-22",
        endDate: "2022-05-30",
      },
      {
        price: 7000,
        startDate: "2022-07-17",
        endDate: "2022-07-25",
      },
      {
        price: 7000,
        startDate: "2022-09-04",
        endDate: "2022-09-12",
      },
      {
        price: 7000,
        startDate: "2022-09-11",
        endDate: "2022-09-19",
      },
      {
        price: 7000,
        startDate: "2022-09-18",
        endDate: "2022-09-26",
      },
      {
        price: 7000,
        startDate: "2022-09-25",
        endDate: "2022-10-03",
      },
      {
        price: 6000,
        startDate: "2022-10-02",
        endDate: "2022-10-10",
      },
      {
        price: 6000,
        startDate: "2022-10-09",
        endDate: "2022-10-17",
      },
      {
        price: 4000,
        startDate: "2022-04-03",
        endDate: "2022-04-11",
      },
      {
        price: 8000,
        startDate: "2022-07-31",
        endDate: "2022-08-08",
      },
      {
        price: 8000,
        startDate: "2022-08-07",
        endDate: "2022-08-15",
      },
      {
        price: 8000,
        startDate: "2022-08-14",
        endDate: "2022-08-22",
      },
      {
        price: 8000,
        startDate: "2022-08-21",
        endDate: "2022-08-29",
      },
      {
        price: 7000,
        startDate: "2022-08-28",
        endDate: "2022-09-05",
      },
      {
        price: 4000,
        startDate: "2022-04-24",
        endDate: "2022-05-02",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/166/Williams-1.jpg",
    },
    location: {
      lat: 41.44398,
      lng: -70.57474,
    },
  },
  {
    baths: 6,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "31 South Water Street",
    },
    features: [],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/31-south-water-street",
    bookings: [
      {
        endDate: "2021-05-30",
        startDate: "2021-05-22",
      },
      {
        endDate: "2020-09-18",
        startDate: "2020-09-12",
      },
      {
        endDate: "2020-06-01",
        startDate: "2020-05-18",
      },
      {
        endDate: "2020-06-28",
        startDate: "2020-06-06",
      },
      {
        endDate: "2019-09-01",
        startDate: "2019-06-29",
      },
      {
        endDate: "2021-09-19",
        startDate: "2021-09-04",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-07-11",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-15",
      },
      {
        endDate: "2020-07-12",
        startDate: "2020-06-27",
      },
      {
        endDate: "2022-05-29",
        startDate: "2022-05-21",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-07-03",
      },
      {
        endDate: "2019-05-26",
        startDate: "2019-05-18",
      },
    ],
    rates: [
      {
        price: 20000,
        startDate: "2022-01-01",
        endDate: "2022-04-24",
      },
      {
        price: 31500,
        startDate: "2019-06-08",
        endDate: "2019-06-22",
      },
      {
        price: 48000,
        startDate: "2019-06-29",
        endDate: "2019-07-27",
      },
      {
        price: 25000,
        startDate: "2019-05-25",
        endDate: "2019-06-08",
      },
      {
        price: 49000,
        startDate: "2019-07-27",
        endDate: "2019-09-07",
      },
      {
        price: 31500,
        startDate: "2019-09-14",
        endDate: "2019-09-28",
      },
      {
        price: 53000,
        startDate: "2022-07-23",
        endDate: "2022-09-04",
      },
      {
        price: 51000,
        startDate: "2021-07-24",
        endDate: "2021-09-05",
      },
      {
        price: 20000,
        startDate: "2021-04-24",
        endDate: "2021-05-30",
      },
      {
        price: 25000,
        startDate: "2021-05-29",
        endDate: "2021-06-06",
      },
      {
        price: 49500,
        startDate: "2020-06-27",
        endDate: "2020-07-26",
      },
      {
        price: 51000,
        startDate: "2020-07-25",
        endDate: "2020-09-06",
      },
      {
        price: 20000,
        startDate: "2020-10-03",
        endDate: "2020-11-01",
      },
      {
        price: 20000,
        startDate: "2020-04-25",
        endDate: "2020-05-31",
      },
      {
        price: 25000,
        startDate: "2020-05-30",
        endDate: "2020-06-07",
      },
      {
        price: 32500,
        startDate: "2020-06-06",
        endDate: "2020-06-21",
      },
      {
        price: 45000,
        startDate: "2019-06-22",
        endDate: "2019-06-29",
      },
      {
        price: 20000,
        startDate: "2018-12-30",
        endDate: "2019-05-25",
      },
      {
        price: 35000,
        startDate: "2019-09-07",
        endDate: "2019-09-14",
      },
      {
        price: 20000,
        startDate: "2019-09-28",
        endDate: "2020-01-05",
      },
      {
        price: 22000,
        startDate: "2022-04-23",
        endDate: "2022-05-29",
      },
    ],

    location: {
      lat: 41.388441,
      lng: -70.51346,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "10 Dunham Road",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/10-dunham-road",
    bookings: [
      {
        endDate: "2021-08-29",
        startDate: "2021-06-05",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-06-11",
      },
    ],
    rates: [
      {
        price: 4000,
        startDate: "2022-05-07",
        endDate: "2022-05-22",
      },
      {
        price: 10000,
        startDate: "2021-09-04",
        endDate: "2021-09-12",
      },
      {
        price: 6000,
        startDate: "2022-05-21",
        endDate: "2022-06-05",
      },
      {
        price: 12000,
        startDate: "2022-06-18",
        endDate: "2022-09-04",
      },
      {
        price: 6000,
        startDate: "2022-09-10",
        endDate: "2022-10-02",
      },
      {
        price: 6000,
        startDate: "2021-09-11",
        endDate: "2021-10-03",
      },
      {
        price: 4000,
        startDate: "2021-10-02",
        endDate: "2021-10-31",
      },
      {
        price: 4000,
        startDate: "2021-05-01",
        endDate: "2021-05-23",
      },
      {
        price: 6000,
        startDate: "2021-05-22",
        endDate: "2021-06-06",
      },
      {
        price: 6000,
        startDate: "2021-06-05",
        endDate: "2021-06-20",
      },
      {
        price: 12000,
        startDate: "2021-06-19",
        endDate: "2021-09-05",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/156/dunham-1.jpg",
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "9 Ridge Hill Road",
    },
    features: ["A/C", "Pool"],
    beds: 6,
    sleeps: 12,
    type: "rental",
    path: "/rentals/9-ridge-hill-road",
    bookings: [
      {
        endDate: "2020-01-05",
        startDate: "2018-12-30",
      },
      {
        endDate: "2020-06-28",
        startDate: "2020-01-04",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-01-02",
        startDate: "2021-01-02",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-06-27",
      },
      {
        endDate: "2021-01-03",
        startDate: "2020-09-05",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2019-06-30",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/131/Ridge Hill Road-41.jpg",
    },
    location: {
      lat: 41.372953,
      lng: -70.685478,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Oak Bluffs",

      text: "348 Seaview Ave",
    },
    features: [],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/348-seaview-ave",
    bookings: [
      {
        endDate: "2021-12-27",
        startDate: "2021-09-12",
      },
      {
        endDate: "2021-09-13",
        startDate: "2021-08-01",
      },
      {
        endDate: "2023-01-01",
        startDate: "2021-12-26",
      },
      {
        endDate: "2021-07-12",
        startDate: "2021-07-04",
      },
      {
        endDate: "2021-07-05",
        startDate: "2021-06-20",
      },
      {
        endDate: "2021-07-26",
        startDate: "2021-07-11",
      },
    ],
    rates: [
      {
        price: 6500,
        startDate: "2021-07-18",
        endDate: "2021-08-23",
      },
      {
        price: 4500,
        startDate: "2021-08-22",
        endDate: "2021-12-27",
      },
      {
        price: 4500,
        startDate: "2020-12-27",
        endDate: "2021-06-28",
      },
      {
        price: 6000,
        startDate: "2021-06-27",
        endDate: "2021-07-19",
      },
    ],
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "6 Mariners Circle",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/6-mariners-circle",
    bookings: [
      {
        endDate: "2022-09-05",
        startDate: "2022-05-28",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-05-30",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-01",
      },
    ],
    rates: [
      {
        price: 5500,
        startDate: "2021-05-30",
        endDate: "2021-09-06",
      },
      {
        price: 4500,
        startDate: "2021-09-05",
        endDate: "2021-10-11",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/159/blackinton-2.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "11 Sparrow Lane",
    },
    features: ["A/C", "Hot Tub", "Pool"],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/11-sparrow-lane",
    bookings: [
      {
        endDate: "2022-07-25",
        startDate: "2022-07-10",
      },
      {
        endDate: "2022-08-22",
        startDate: "2022-07-31",
      },
      {
        endDate: "2022-08-29",
        startDate: "2022-08-21",
      },
    ],
    rates: [
      {
        price: 7400,
        startDate: "2022-08-28",
        endDate: "2022-09-12",
      },
      {
        price: 7400,
        startDate: "2022-06-19",
        endDate: "2022-06-27",
      },
      {
        price: 7400,
        startDate: "2022-06-26",
        endDate: "2022-08-01",
      },
      {
        price: 7400,
        startDate: "2022-07-31",
        endDate: "2022-08-29",
      },
      {
        price: 6800,
        startDate: "2022-05-29",
        endDate: "2022-06-06",
      },
      {
        price: 6800,
        startDate: "2022-06-05",
        endDate: "2022-06-13",
      },
      {
        price: 7400,
        startDate: "2022-06-12",
        endDate: "2022-06-20",
      },
      {
        price: 6800,
        startDate: "2022-09-11",
        endDate: "2022-09-26",
      },
    ],
    defaultImage: {
      dimensions: [768, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/169/sparrow new -1.jpg",
    },
    location: {
      lat: 41.4069,
      lng: -70.5778,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "12 Atwood Circle",
    },
    features: ["A/C", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/12-atwood-circle",
    bookings: [
      {
        endDate: "2021-06-16",
        startDate: "2021-06-10",
      },
      {
        endDate: "2022-06-12",
        startDate: "2022-01-01",
      },
      {
        endDate: "2022-06-26",
        startDate: "2022-06-11",
      },
      {
        endDate: "2021-06-20",
        startDate: "2021-06-15",
      },
      {
        endDate: "2021-10-13",
        startDate: "2021-09-04",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-20",
      },
      {
        endDate: "2022-07-24",
        startDate: "2022-06-25",
      },
      {
        endDate: "2021-08-08",
        startDate: "2021-07-24",
      },
      {
        endDate: "2020-08-02",
        startDate: "2020-06-27",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-08-22",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-06-19",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2020-09-26",
        endDate: "2020-10-25",
      },
      {
        price: 16500,
        startDate: "2020-06-27",
        endDate: "2020-09-06",
      },
      {
        price: 10000,
        startDate: "2022-10-01",
        endDate: "2023-01-01",
      },
      {
        price: 10000,
        startDate: "2020-09-05",
        endDate: "2020-09-27",
      },
      {
        price: 17500,
        startDate: "2021-06-26",
        endDate: "2021-08-29",
      },
      {
        price: 8000,
        startDate: "2020-10-24",
        endDate: "2021-01-03",
      },
      {
        price: 8000,
        startDate: "2021-10-30",
        endDate: "2022-01-02",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1066],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/143/lafley-28.jpg",
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "15 Bold Meadow Lane",
    },
    features: [],
    beds: 3,
    sleeps: 8,
    type: "rental",
    path: "/rentals/15-bold-meadow-lane",
    bookings: [
      {
        endDate: "2022-04-17",
        startDate: "2021-12-26",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-10-29",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-06",
      },
      {
        endDate: "2022-07-31",
        startDate: "2022-07-16",
      },
      {
        endDate: "2022-07-17",
        startDate: "2022-07-09",
      },
      {
        endDate: "2022-08-07",
        startDate: "2022-07-30",
      },
      {
        endDate: "2022-06-26",
        startDate: "2022-06-18",
      },
      {
        endDate: "2022-07-10",
        startDate: "2022-07-02",
      },
    ],
    rates: [
      {
        price: 2000,
        startDate: "2022-04-16",
        endDate: "2022-04-24",
      },
      {
        price: 2500,
        startDate: "2022-04-23",
        endDate: "2022-05-22",
      },
      {
        price: 5250,
        startDate: "2022-07-02",
        endDate: "2022-07-10",
      },
      {
        price: 4725,
        startDate: "2022-07-09",
        endDate: "2022-07-24",
      },
      {
        price: 5250,
        startDate: "2022-07-23",
        endDate: "2022-07-31",
      },
      {
        price: 3250,
        startDate: "2022-06-04",
        endDate: "2022-06-26",
      },
      {
        price: 4000,
        startDate: "2022-06-25",
        endDate: "2022-07-03",
      },
      {
        price: 6000,
        startDate: "2022-07-30",
        endDate: "2022-08-07",
      },
      {
        price: 6300,
        startDate: "2022-08-06",
        endDate: "2022-08-14",
      },
      {
        price: 6300,
        startDate: "2022-08-13",
        endDate: "2022-08-21",
      },
      {
        price: 2500,
        startDate: "2022-10-01",
        endDate: "2022-10-30",
      },
      {
        price: 2500,
        startDate: "2022-05-21",
        endDate: "2022-05-29",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/167/sweeney-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Vineyard Haven",

      text: "21 William Street",
    },
    features: [],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/21-william-street",
    bookings: [
      {
        endDate: "2023-01-01",
        startDate: "2022-06-04",
      },
      {
        endDate: "2021-09-12",
        startDate: "2021-06-20",
      },
      {
        endDate: "2022-06-05",
        startDate: "2021-12-26",
      },
      {
        endDate: "2020-09-06",
        startDate: "2020-06-28",
      },
    ],
    rates: [],
    defaultImage: {
      dimensions: [1600, 1059],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/132/warnecke-1.jpg",
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "30 Katama Bayview Road",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/30-katama-bayview-road",
    bookings: [
      {
        endDate: "2020-07-13",
        startDate: "2020-07-10",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-07-24",
      },
      {
        endDate: "2021-09-06",
        startDate: "2021-07-18",
      },
      {
        endDate: "2022-08-28",
        startDate: "2022-08-07",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-07-28",
      },
      {
        endDate: "2021-07-19",
        startDate: "2021-05-30",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-08-23",
      },
    ],
    rates: [
      {
        price: 8500,
        startDate: "2020-06-28",
        endDate: "2020-08-10",
      },
      {
        price: 9500,
        startDate: "2020-08-09",
        endDate: "2020-08-31",
      },
      {
        price: 17500,
        startDate: "2022-01-01",
        endDate: "2022-07-31",
      },
      {
        price: 15400,
        startDate: "2021-07-11",
        endDate: "2021-08-02",
      },
      {
        price: 6500,
        startDate: "2020-06-14",
        endDate: "2020-06-29",
      },
      {
        price: 10500,
        startDate: "2022-09-10",
        endDate: "2023-01-01",
      },
      {
        price: 8500,
        startDate: "2019-06-30",
        endDate: "2019-08-04",
      },
      {
        price: 9500,
        startDate: "2019-08-04",
        endDate: "2019-08-18",
      },
      {
        price: 9500,
        startDate: "2019-08-18",
        endDate: "2019-08-25",
      },
      {
        price: 8500,
        startDate: "2019-08-25",
        endDate: "2019-09-01",
      },
      {
        price: 20300,
        startDate: "2021-06-27",
        endDate: "2021-07-12",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/123/katama-1.jpg",
    },
    location: {
      lat: 41.355623,
      lng: -70.503626,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "35 Cooke Street",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 7,
    type: "rental",
    path: "/rentals/35-cooke-street",
    bookings: [
      {
        endDate: "2020-09-01",
        startDate: "2020-08-24",
      },
      {
        endDate: "2020-08-25",
        startDate: "2020-08-15",
      },
      {
        endDate: "2020-07-20",
        startDate: "2020-06-07",
      },
      {
        endDate: "2021-06-17",
        startDate: "2021-05-01",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-21",
      },
      {
        endDate: "2020-08-16",
        startDate: "2020-08-02",
      },
      {
        endDate: "2019-08-03",
        startDate: "2019-07-26",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-06-26",
      },
      {
        endDate: "2021-06-27",
        startDate: "2021-06-16",
      },
      {
        endDate: "2019-07-14",
        startDate: "2019-06-29",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-07-19",
      },
      {
        endDate: "2021-08-22",
        startDate: "2021-06-26",
      },
      {
        endDate: "2021-09-13",
        startDate: "2021-08-29",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-08-10",
      },
    ],
    rates: [
      {
        price: 6000,
        startDate: "2020-05-03",
        endDate: "2020-07-06",
      },
      {
        price: 6000,
        startDate: "2019-08-31",
        endDate: "2019-10-06",
      },
      {
        price: 7500,
        startDate: "2022-07-31",
        endDate: "2022-09-04",
      },
      {
        price: 6000,
        startDate: "2019-06-29",
        endDate: "2019-07-28",
      },
      {
        price: 6500,
        startDate: "2019-07-27",
        endDate: "2019-09-01",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/115/berger-2.jpg",
    },
    location: {
      lat: 41.388665,
      lng: -70.515479,
    },
  },
  {
    baths: 2,
    bathsHalf: 0,
    address: {
      city: "Chilmark",

      text: "35 North Road",
    },
    features: ["A/C"],
    beds: 2,
    sleeps: 5,
    type: "rental",
    path: "/rentals/35-north-road",
    bookings: [
      {
        endDate: "2022-09-26",
        startDate: "2022-07-03",
      },
      {
        endDate: "2021-09-07",
        startDate: "2021-06-24",
      },
    ],
    rates: [
      {
        price: 3450,
        startDate: "2022-05-14",
        endDate: "2022-06-12",
      },
      {
        price: 2500,
        startDate: "2021-03-28",
        endDate: "2021-05-03",
      },
      {
        price: 3000,
        startDate: "2021-05-02",
        endDate: "2021-05-31",
      },
      {
        price: 5000,
        startDate: "2021-06-27",
        endDate: "2021-07-05",
      },
      {
        price: 4500,
        startDate: "2021-09-05",
        endDate: "2021-09-13",
      },
      {
        price: 3000,
        startDate: "2021-09-26",
        endDate: "2021-11-01",
      },
      {
        price: 2500,
        startDate: "2021-10-31",
        endDate: "2021-12-27",
      },
      {
        price: 5000,
        startDate: "2021-07-25",
        endDate: "2021-08-02",
      },
      {
        price: 4500,
        startDate: "2021-07-04",
        endDate: "2021-07-26",
      },
      {
        price: 4000,
        startDate: "2021-09-12",
        endDate: "2021-09-27",
      },
      {
        price: 2300,
        startDate: "2022-04-02",
        endDate: "2022-05-01",
      },
      {
        price: 1725,
        startDate: "2022-01-01",
        endDate: "2022-04-03",
      },
      {
        price: 5750,
        startDate: "2022-06-25",
        endDate: "2022-09-04",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/152/35north-1.jpg",
    },
    location: {
      lat: 41.39579,
      lng: -70.70877,
    },
  },
  {
    baths: 6,
    bathsHalf: 1,
    address: {
      city: "West Tisbury",

      text: "41 Naushon Road",
    },
    features: ["A/C", "Dock", "Waterfront"],
    beds: 5,
    sleeps: 12,
    type: "rental",
    path: "/rentals/41-naushon-road",
    bookings: [
      {
        endDate: "2021-07-04",
        startDate: "2021-06-12",
      },
      {
        endDate: "2021-09-02",
        startDate: "2021-07-31",
      },
      {
        endDate: "2021-05-30",
        startDate: "2021-01-02",
      },
      {
        endDate: "2021-06-06",
        startDate: "2021-05-29",
      },
      {
        endDate: "2022-07-03",
        startDate: "2022-06-04",
      },
      {
        endDate: "2021-08-01",
        startDate: "2021-07-24",
      },
      {
        endDate: "2021-07-11",
        startDate: "2021-07-03",
      },
      {
        endDate: "2021-07-25",
        startDate: "2021-07-17",
      },
      {
        endDate: "2021-09-19",
        startDate: "2021-09-11",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2021-10-02",
        endDate: "2021-10-17",
      },
      {
        price: 14500,
        startDate: "2022-07-02",
        endDate: "2022-07-24",
      },
      {
        price: 12000,
        startDate: "2021-05-29",
        endDate: "2021-06-20",
      },
      {
        price: 12000,
        startDate: "2021-06-19",
        endDate: "2021-06-27",
      },
      {
        price: 14500,
        startDate: "2021-07-03",
        endDate: "2021-07-25",
      },
      {
        price: 15000,
        startDate: "2021-07-31",
        endDate: "2021-08-29",
      },
      {
        price: 13000,
        startDate: "2021-08-28",
        endDate: "2021-09-19",
      },
      {
        price: 12000,
        startDate: "2021-09-18",
        endDate: "2021-10-03",
      },
      {
        price: 13000,
        startDate: "2022-09-17",
        endDate: "2022-09-25",
      },
      {
        price: 15000,
        startDate: "2022-08-06",
        endDate: "2022-08-28",
      },
      {
        price: 14500,
        startDate: "2021-07-24",
        endDate: "2021-08-01",
      },
      {
        price: 13000,
        startDate: "2021-06-26",
        endDate: "2021-07-04",
      },
      {
        price: 13000,
        startDate: "2022-09-03",
        endDate: "2022-09-18",
      },
    ],
    defaultImage: {
      dimensions: [1024, 682],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/157/naushon-1.jpg",
    },
    location: {
      lat: 41.45988,
      lng: -70.659,
    },
  },
  {
    baths: 3,
    bathsHalf: 1,
    address: {
      city: "Chilmark",

      text: "94 Menemsha Inn Road",
    },
    features: ["Waterfront"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/94-menemsha-inn-road",
    bookings: [
      {
        endDate: "2019-06-07",
        startDate: "2019-03-31",
      },
      {
        endDate: "2019-07-13",
        startDate: "2019-06-29",
      },
      {
        endDate: "2019-09-12",
        startDate: "2019-09-02",
      },
      {
        endDate: "2022-10-01",
        startDate: "2022-06-25",
      },
      {
        endDate: "2022-06-11",
        startDate: "2022-05-01",
      },
      {
        endDate: "2020-08-18",
        startDate: "2020-06-28",
      },
      {
        endDate: "2021-10-31",
        startDate: "2021-06-19",
      },
      {
        endDate: "2019-08-18",
        startDate: "2019-07-20",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2019-07-21",
        endDate: "2019-08-04",
      },
      {
        price: 6500,
        startDate: "2021-05-01",
        endDate: "2021-05-31",
      },
      {
        price: 8000,
        startDate: "2019-05-26",
        endDate: "2019-06-30",
      },
      {
        price: 10000,
        startDate: "2019-06-30",
        endDate: "2019-07-07",
      },
      {
        price: 10000,
        startDate: "2019-07-07",
        endDate: "2019-07-14",
      },
      {
        price: 10000,
        startDate: "2019-07-14",
        endDate: "2019-07-21",
      },
      {
        price: 13000,
        startDate: "2019-08-04",
        endDate: "2019-09-01",
      },
      {
        price: 8000,
        startDate: "2019-09-01",
        endDate: "2019-10-06",
      },
      {
        price: 8000,
        startDate: "2019-10-06",
        endDate: "2019-11-03",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/124/93 Menemsha Inn-1.jpg",
    },
    location: {
      lat: 41.364315,
      lng: -70.758627,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "40 Old Purchase Road",
    },
    features: [],
    beds: 3,
    sleeps: 6,
    type: "rental",
    path: "/rentals/40-old-purchase-road",
    bookings: [
      {
        endDate: "2021-09-05",
        startDate: "2021-05-01",
      },
      {
        endDate: "2022-10-02",
        startDate: "2022-05-01",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2021-05-01",
        endDate: "2021-06-27",
      },
      {
        price: 6000,
        startDate: "2020-09-06",
        endDate: "2020-10-05",
      },
      {
        price: 7000,
        startDate: "2020-08-02",
        endDate: "2020-09-07",
      },
      {
        price: 6500,
        startDate: "2020-06-28",
        endDate: "2020-08-03",
      },
    ],
    defaultImage: {
      dimensions: [1423, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/141/safar-1.jpg",
    },
  },
  {
    baths: 5,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "103 School Street",
    },
    features: ["A/C"],
    beds: 6,
    sleeps: 14,
    type: "rental",
    path: "/rentals/103-school-street",
    bookings: [
      {
        endDate: "2022-10-10",
        startDate: "2022-10-02",
      },
      {
        endDate: "2022-06-06",
        startDate: "2022-05-01",
      },
      {
        endDate: "2022-07-04",
        startDate: "2022-06-19",
      },
      {
        endDate: "2022-08-08",
        startDate: "2022-07-17",
      },
      {
        endDate: "2021-07-26",
        startDate: "2021-06-20",
      },
      {
        endDate: "2021-05-31",
        startDate: "2021-05-23",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-08-08",
      },
      {
        endDate: "2021-09-13",
        startDate: "2021-08-22",
      },
      {
        endDate: "2022-09-12",
        startDate: "2022-09-04",
      },
      {
        endDate: "2022-07-18",
        startDate: "2022-07-03",
      },
      {
        endDate: "2022-09-26",
        startDate: "2022-09-11",
      },
    ],
    rates: [
      {
        price: 6300,
        startDate: "2021-05-02",
        endDate: "2021-06-07",
      },
      {
        price: 12500,
        startDate: "2022-07-31",
        endDate: "2022-08-15",
      },
      {
        price: 6500,
        startDate: "2022-05-01",
        endDate: "2022-06-06",
      },
      {
        price: 9500,
        startDate: "2022-10-09",
        endDate: "2022-12-04",
      },
      {
        price: 10500,
        startDate: "2021-07-11",
        endDate: "2021-07-26",
      },
      {
        price: 8500,
        startDate: "2021-08-29",
        endDate: "2021-09-13",
      },
      {
        price: 11000,
        startDate: "2021-07-04",
        endDate: "2021-07-12",
      },
      {
        price: 7350,
        startDate: "2021-06-06",
        endDate: "2021-06-14",
      },
      {
        price: 12500,
        startDate: "2021-08-01",
        endDate: "2021-08-16",
      },
      {
        price: 11500,
        startDate: "2021-08-15",
        endDate: "2021-08-23",
      },
      {
        price: 7500,
        startDate: "2021-09-12",
        endDate: "2021-11-01",
      },
      {
        price: 8400,
        startDate: "2021-06-13",
        endDate: "2021-06-21",
      },
      {
        price: 11500,
        startDate: "2022-07-03",
        endDate: "2022-07-25",
      },
    ],
    defaultImage: {
      dimensions: [1464, 1067],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/150/miskel-1.jpg",
    },
    location: {
      lat: 41.38628954986383,
      lng: -70.51837502512454,
    },
  },
  {
    baths: 1,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "59 Cooke Street",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 0,
    type: "rental",
    path: "/rentals/59-cooke-street",
    bookings: [
      {
        endDate: "2022-08-31",
        startDate: "2022-08-22",
      },
      {
        endDate: "2021-08-21",
        startDate: "2021-07-02",
      },
      {
        endDate: "2022-06-12",
        startDate: "2022-06-04",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-07-16",
      },
      {
        endDate: "2022-06-19",
        startDate: "2022-06-11",
      },
    ],
    rates: [
      {
        price: 2500,
        startDate: "2021-10-29",
        endDate: "2022-01-01",
      },
      {
        price: 8500,
        startDate: "2022-07-23",
        endDate: "2022-08-01",
      },
      {
        price: 2500,
        startDate: "2021-12-31",
        endDate: "2022-05-22",
      },
      {
        price: 7000,
        startDate: "2021-07-02",
        endDate: "2021-07-31",
      },
      {
        price: 8000,
        startDate: "2021-07-30",
        endDate: "2021-08-21",
      },
      {
        price: 7200,
        startDate: "2021-08-20",
        endDate: "2021-08-28",
      },
      {
        price: 7000,
        startDate: "2021-08-27",
        endDate: "2021-09-04",
      },
      {
        price: 7000,
        startDate: "2021-09-03",
        endDate: "2021-09-11",
      },
      {
        price: 6500,
        startDate: "2021-09-10",
        endDate: "2021-09-25",
      },
      {
        price: 5600,
        startDate: "2021-09-24",
        endDate: "2021-10-16",
      },
      {
        price: 5000,
        startDate: "2021-10-15",
        endDate: "2021-10-30",
      },
      {
        price: 3800,
        startDate: "2022-05-28",
        endDate: "2022-06-12",
      },
      {
        price: 4200,
        startDate: "2022-06-11",
        endDate: "2022-06-19",
      },
      {
        price: 5000,
        startDate: "2022-06-18",
        endDate: "2022-06-26",
      },
      {
        price: 7000,
        startDate: "2022-06-25",
        endDate: "2022-07-24",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/161/59cooke-1.jpg",
    },
    location: {
      lat: 41.38964851411497,
      lng: -70.51632609821813,
    },
  },
  {
    baths: 3,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "61 Davis Lane",
    },
    features: ["A/C"],
    beds: 3,
    sleeps: 5,
    type: "rental",
    path: "/rentals/61-davis-lane",
    bookings: [
      {
        endDate: "2020-09-02",
        startDate: "2020-08-01",
      },
      {
        endDate: "2023-01-01",
        startDate: "2022-01-01",
      },
    ],
    rates: [
      {
        price: 10000,
        startDate: "2020-12-27",
        endDate: "2021-05-02",
      },
      {
        price: 14000,
        startDate: "2021-05-01",
        endDate: "2021-05-30",
      },
      {
        price: 14000,
        startDate: "2021-08-28",
        endDate: "2021-10-24",
      },
      {
        price: 10000,
        startDate: "2021-10-23",
        endDate: "2022-01-02",
      },
      {
        price: 14000,
        startDate: "2020-05-02",
        endDate: "2020-05-31",
      },
      {
        price: 17000,
        startDate: "2020-08-01",
        endDate: "2020-08-30",
      },
      {
        price: 14000,
        startDate: "2020-08-29",
        endDate: "2020-09-27",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/139/davis-1.jpg",
    },
    location: {
      lat: 41.389703212222734,
      lng: -70.51597583023309,
    },
  },
  {
    baths: 4,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "70 Curtis Lane",
    },
    features: ["A/C"],
    beds: 4,
    sleeps: 8,
    type: "rental",
    path: "/rentals/70-curtis-lane",
    bookings: [
      {
        endDate: "2022-01-03",
        startDate: "2021-12-26",
      },
      {
        endDate: "2021-09-14",
        startDate: "2021-09-09",
      },
      {
        endDate: "2022-08-01",
        startDate: "2022-06-12",
      },
      {
        endDate: "2022-09-06",
        startDate: "2022-08-28",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-06-13",
      },
      {
        endDate: "2021-10-14",
        startDate: "2021-10-09",
      },
      {
        endDate: "2022-08-15",
        startDate: "2022-08-07",
      },
      {
        endDate: "2022-09-19",
        startDate: "2022-09-11",
      },
      {
        endDate: "2021-08-16",
        startDate: "2021-08-08",
      },
      {
        endDate: "2021-08-30",
        startDate: "2021-08-22",
      },
      {
        endDate: "2021-08-09",
        startDate: "2021-08-01",
      },
      {
        endDate: "2021-08-23",
        startDate: "2021-08-15",
      },
    ],
    rates: [
      {
        price: 5000,
        startDate: "2021-09-26",
        endDate: "2021-10-18",
      },
      {
        price: 10000,
        startDate: "2022-06-19",
        endDate: "2022-08-01",
      },
      {
        price: 6000,
        startDate: "2022-05-29",
        endDate: "2022-06-13",
      },
      {
        price: 6000,
        startDate: "2022-09-04",
        endDate: "2022-09-26",
      },
      {
        price: 5000,
        startDate: "2021-12-26",
        endDate: "2022-05-30",
      },
      {
        price: 6000,
        startDate: "2021-06-06",
        endDate: "2021-06-21",
      },
      {
        price: 8000,
        startDate: "2021-06-20",
        endDate: "2021-06-28",
      },
      {
        price: 10000,
        startDate: "2021-08-22",
        endDate: "2021-08-30",
      },
      {
        price: 6000,
        startDate: "2021-09-05",
        endDate: "2021-09-27",
      },
    ],
    defaultImage: {
      dimensions: [1024, 683],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/151/curtis-1.jpg",
    },
    location: {
      lat: 41.39582484946697,
      lng: -70.52395641726682,
    },
  },
  {
    baths: 4,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "106 South Summer Street",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/106-south-summer-street",
    bookings: [
      {
        endDate: "2023-01-01",
        startDate: "2022-07-30",
      },
      {
        endDate: "2021-12-27",
        startDate: "2020-12-27",
      },
      {
        endDate: "2020-09-07",
        startDate: "2020-06-28",
      },
      {
        endDate: "2019-08-11",
        startDate: "2019-08-04",
      },
      {
        endDate: "2019-08-25",
        startDate: "2019-08-18",
      },
    ],
    rates: [
      {
        price: 12000,
        startDate: "2020-12-27",
        endDate: "2021-06-21",
      },
      {
        price: 12500,
        startDate: "2021-06-20",
        endDate: "2021-09-06",
      },
    ],
    defaultImage: {
      dimensions: [1600, 1060],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/113/clutterbuck-13.jpg",
    },
    location: {
      lat: 41.385978,
      lng: -70.517889,
    },
  },
  {
    baths: 6,
    bathsHalf: 0,
    address: {
      city: "Edgartown",

      text: "1 Field Club Drive",
    },
    features: ["A/C", "Hot Tub", "Pool"],
    beds: 5,
    sleeps: 10,
    type: "rental",
    path: "/rentals/1-field-club-drive",
    bookings: [
      {
        endDate: "2020-07-28",
        startDate: "2020-06-28",
      },
      {
        endDate: "2022-07-01",
        startDate: "2022-06-23",
      },
      {
        endDate: "2020-08-30",
        startDate: "2020-08-22",
      },
      {
        endDate: "2020-08-09",
        startDate: "2020-08-01",
      },
      {
        endDate: "2020-08-16",
        startDate: "2020-08-08",
      },
      {
        endDate: "2020-08-23",
        startDate: "2020-08-15",
      },
      {
        endDate: "2021-09-05",
        startDate: "2021-06-26",
      },
      {
        endDate: "2018-09-02",
        startDate: "2018-07-29",
      },
      {
        endDate: "2021-10-03",
        startDate: "2021-09-04",
      },
      {
        endDate: "2022-08-21",
        startDate: "2022-07-16",
      },
      {
        endDate: "2021-06-27",
        startDate: "2021-01-02",
      },
    ],
    rates: [
      {
        price: 25000,
        startDate: "2021-06-26",
        endDate: "2021-09-05",
      },
      {
        price: 25000,
        startDate: "2020-06-28",
        endDate: "2020-09-07",
      },
      {
        price: 24000,
        startDate: "2018-08-03",
        endDate: "2018-08-10",
      },
      {
        price: 24000,
        startDate: "2018-08-10",
        endDate: "2018-08-17",
      },
      {
        price: 22000,
        startDate: "2018-08-17",
        endDate: "2018-08-24",
      },
      {
        price: 20000,
        startDate: "2018-08-24",
        endDate: "2018-08-31",
      },
      {
        price: 20000,
        startDate: "2018-08-31",
        endDate: "2018-09-07",
      },
      {
        price: 17500,
        startDate: "2018-09-07",
        endDate: "2018-09-14",
      },
      {
        price: 15000,
        startDate: "2018-09-14",
        endDate: "2018-09-21",
      },
      {
        price: 12500,
        startDate: "2018-09-21",
        endDate: "2018-09-28",
      },
      {
        price: 10000,
        startDate: "2018-09-28",
        endDate: "2018-10-05",
      },
      {
        price: 22000,
        startDate: "2018-07-27",
        endDate: "2018-08-03",
      },
      {
        price: 20000,
        startDate: "2022-04-30",
        endDate: "2022-05-29",
      },
      {
        price: 25000,
        startDate: "2022-05-28",
        endDate: "2022-06-26",
      },
      {
        price: 25000,
        startDate: "2022-09-03",
        endDate: "2022-10-02",
      },
      {
        price: 15000,
        startDate: "2021-01-02",
        endDate: "2021-05-30",
      },
    ],
    defaultImage: {
      dimensions: [1024, 768],
      url: "https://cdn.aglty.io/r2qmgwky/MediaGroupings/146/1 Field Club - 1.jpg",
    },
    location: {
      lat: 41.3694,
      lng: -70.51363,
    },
  },
  {
    baths: 2,
    bathsHalf: 1,
    address: {
      city: "Edgartown",

      text: "144 South Water Street",
    },
    features: ["A/C"],
    beds: 5,
    sleeps: 8,
    type: "rental",
    path: "/rentals/144-south-water-street",
    bookings: [
      {
        endDate: "2022-07-18",
        startDate: "2022-06-18",
      },
      {
        endDate: "2022-09-05",
        startDate: "2022-07-17",
      },
      {
        endDate: "2020-08-31",
        startDate: "2020-08-02",
      },
      {
        endDate: "2020-08-03",
        startDate: "2020-07-26",
      },
      {
        endDate: "2020-07-27",
        startDate: "2020-05-31",
      },
      {
        endDate: "2021-08-02",
        startDate: "2021-06-27",
      },
    ],
    rates: [
      {
        price: 8000,
        startDate: "2021-12-26",
        endDate: "2022-06-19",
      },
      {
        price: 10000,
        startDate: "2020-07-26",
        endDate: "2020-09-06",
      },
      {
        price: 11000,
        startDate: "2022-08-20",
        endDate: "2022-09-04",
      },
    ],
  },
];
